export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** GQL player's affiliate id */
  AffiliateId: { input: string; output: string; }
  /** GQL player's affiliate token */
  AffiliateToken: { input: string; output: string; }
  /** The `BigDecimal` scalar type represents signed fractional values with arbitrary precision. */
  BigDecimal: { input: number; output: number; }
  /** Campaign linked to a reward(s) */
  CampaignId: { input: string; output: string; }
  Duration: { input: any; output: any; }
  EmailAddress: { input: string; output: string; }
  /** ISO Country code */
  ISOCountryCode: { input: any; output: any; }
  /** ISO Currency code with crypto support */
  ISOCurrencyCode: { input: string; output: string; }
  /** Raw JSON value */
  Json: { input: { [key: string]: any }; output: { [key: string]: any }; }
  LocalDate: { input: string; output: string; }
  /**
   * The `Long` scalar type represents non-fractional signed whole numeric values.
   * Long can represent values between -(2^63) and 2^63 - 1.
   */
  Long: { input: number; output: number; }
  /** Non Empty string type */
  NonEmptyString: { input: string; output: string; }
  OffsetDateTime: { input: string; output: string; }
  /** GQL player's phone number scalar type */
  PhoneNumber: { input: string; output: string; }
  /** Positive Big Decimal value */
  PositiveBigDecimal: { input: number; output: number; }
  /** Positive Int value */
  PositiveInt: { input: number; output: number; }
  /** Positive Long value */
  PositiveLong: { input: any; output: any; }
};

/** Player payment summary info */
export type AccountStatus = {
  __typename: 'AccountStatus';
  cause: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** Statuses of a player accounts */
export enum AccountStatusEnum {
  Closed = 'Closed',
  Open = 'Open'
}

/** Adjustment Category. */
export enum AdjustmentCategory {
  Adjustment = 'Adjustment',
  Bonus = 'Bonus'
}

/** Adjustment Type */
export enum AdjustmentType {
  Bonus = 'Bonus',
  BonusConfiscation = 'BonusConfiscation',
  Cashdrop = 'Cashdrop',
  Gameplay = 'Gameplay',
  Goodwill = 'Goodwill',
  ManualPayment = 'ManualPayment',
  TestFunds = 'TestFunds'
}

/** Adjustment Type Data */
export type AdjustmentTypeData = {
  __typename: 'AdjustmentTypeData';
  /** category. */
  category: Scalars['String']['output'];
  /** type name. */
  typeName: Scalars['String']['output'];
};

/** AffiliateInfo with token and affiliate id. */
export type AffiliateInfo = {
  __typename: 'AffiliateInfo';
  affiliateId: Maybe<Scalars['String']['output']>;
  affiliateToken: Maybe<Scalars['String']['output']>;
};

export type AffiliateParameters = {
  id: Scalars['AffiliateId']['input'];
  token: Scalars['AffiliateToken']['input'];
};

/** Okta User (Agent) information */
export type Agent = {
  __typename: 'Agent';
  agentId: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastLogin: Maybe<Scalars['OffsetDateTime']['output']>;
  lastName: Scalars['String']['output'];
};

export type AgentInitiator = {
  __typename: 'AgentInitiator';
  agent: Maybe<Agent>;
};

/** Agent role type */
export enum AgentRoleEnum {
  AccessAmok = 'AccessAmok',
  AccessAmokH = 'AccessAmokH',
  AccessBetInferno = 'AccessBetInferno',
  AccessBlingz = 'AccessBlingz',
  AccessCasinoEye = 'AccessCasinoEye',
  AccessDJack = 'AccessDJack',
  AccessDJackF = 'AccessDJackF',
  AccessDiceWise = 'AccessDiceWise',
  AccessDiceWiseF = 'AccessDiceWiseF',
  AccessF9 = 'AccessF9',
  AccessGemler = 'AccessGemler',
  AccessGemlerH = 'AccessGemlerH',
  AccessGigasino = 'AccessGigasino',
  AccessGoldroll = 'AccessGoldroll',
  AccessGoldrollH = 'AccessGoldrollH',
  AccessGreatSlots = 'AccessGreatSlots',
  AccessHungerSpin = 'AccessHungerSpin',
  AccessHuzzlin = 'AccessHuzzlin',
  AccessHyperLucky = 'AccessHyperLucky',
  AccessJackpotCow = 'AccessJackpotCow',
  AccessJackpotCowF = 'AccessJackpotCowF',
  AccessKim = 'AccessKim',
  AccessLuckyFuel = 'AccessLuckyFuel',
  AccessLuckyJungle = 'AccessLuckyJungle',
  AccessLuckyJungleH = 'AccessLuckyJungleH',
  AccessMadRush = 'AccessMadRush',
  AccessMadRushF = 'AccessMadRushF',
  AccessMonsino = 'AccessMonsino',
  AccessMonsinoH = 'AccessMonsinoH',
  AccessMonster = 'AccessMonster',
  AccessMountGold = 'AccessMountGold',
  AccessMountGoldH = 'AccessMountGoldH',
  AccessNifty = 'AccessNifty',
  AccessNiftyH = 'AccessNiftyH',
  AccessNitroWin = 'AccessNitroWin',
  AccessOverload = 'AccessOverload',
  AccessOverloadH = 'AccessOverloadH',
  AccessQuickz = 'AccessQuickz',
  AccessRabbitReel = 'AccessRabbitReel',
  AccessRaptor = 'AccessRaptor',
  AccessRazorSpin = 'AccessRazorSpin',
  AccessReblz = 'AccessReblz',
  AccessReelFury = 'AccessReelFury',
  AccessRefuelCasino = 'AccessRefuelCasino',
  AccessRefuelCasinoH = 'AccessRefuelCasinoH',
  AccessReko = 'AccessReko',
  AccessRekoF = 'AccessRekoF',
  AccessRichMoose = 'AccessRichMoose',
  AccessShockz = 'AccessShockz',
  AccessSlamz = 'AccessSlamz',
  AccessSlotCloud = 'AccessSlotCloud',
  AccessSlotCloudF = 'AccessSlotCloudF',
  AccessSlotHaus = 'AccessSlotHaus',
  AccessSlotHeart = 'AccessSlotHeart',
  AccessSlotHype = 'AccessSlotHype',
  AccessSlotHypeH = 'AccessSlotHypeH',
  AccessSlotIq = 'AccessSlotIq',
  AccessSlotLion = 'AccessSlotLion',
  AccessSlotMojo = 'AccessSlotMojo',
  AccessSlotOwl = 'AccessSlotOwl',
  AccessSlotOwlF = 'AccessSlotOwlF',
  AccessSlotPony = 'AccessSlotPony',
  AccessSlotSpice = 'AccessSlotSpice',
  AccessSlotSquad = 'AccessSlotSquad',
  AccessSlotWish = 'AccessSlotWish',
  AccessSlotWishF = 'AccessSlotWishF',
  AccessSlotWorm = 'AccessSlotWorm',
  AccessSlotable = 'AccessSlotable',
  AccessSlotableH = 'AccessSlotableH',
  AccessSlotser = 'AccessSlotser',
  AccessSlotzy = 'AccessSlotzy',
  AccessSmasha = 'AccessSmasha',
  AccessSpinJam = 'AccessSpinJam',
  AccessSpinPurple = 'AccessSpinPurple',
  AccessSpinSkull = 'AccessSpinSkull',
  AccessSpinSweet = 'AccessSpinSweet',
  AccessSpinWar = 'AccessSpinWar',
  AccessSpinara = 'AccessSpinara',
  AccessSpinero = 'AccessSpinero',
  AccessSpineroH = 'AccessSpineroH',
  AccessSpinju = 'AccessSpinju',
  AccessSugarino = 'AccessSugarino',
  AccessSwingz = 'AccessSwingz',
  AccessTasteVegas = 'AccessTasteVegas',
  AccessUnlimitCasino = 'AccessUnlimitCasino',
  AccessUnlimitCasinoH = 'AccessUnlimitCasinoH',
  AccessWinsly = 'AccessWinsly',
  AccessWinslyF = 'AccessWinslyF',
  AccessWinzie = 'AccessWinzie',
  AccessWinzieH = 'AccessWinzieH',
  AccessWizzSpin = 'AccessWizzSpin',
  AccessWizzSpinF = 'AccessWizzSpinF',
  Adjustments = 'Adjustments',
  AffiliateManager = 'AffiliateManager',
  CMS = 'CMS',
  Compliance = 'Compliance',
  CustomerSupport = 'CustomerSupport',
  CustomerSupportAgent = 'CustomerSupportAgent',
  CustomerSupportTL = 'CustomerSupportTL',
  Developers = 'Developers',
  Manager = 'Manager',
  Marketing = 'Marketing',
  PaymentAgent = 'PaymentAgent',
  PaymentManager = 'PaymentManager',
  PaymentTL = 'PaymentTL',
  PaymentsAndFraud = 'PaymentsAndFraud',
  VIPManager = 'VIPManager'
}

/** The order to list aggregated KYC6 matches. */
export enum AggregatedKYC6MatchesOrderBy {
  LastSearchedAt = 'LastSearchedAt',
  MaxScore = 'MaxScore',
  PepTier = 'PepTier'
}

/** A connection to a list of items. */
export type AggregatedKyc6MatchItemConnection = {
  __typename: 'AggregatedKyc6MatchItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AggregatedKyc6MatchItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AggregatedKyc6MatchItemEdge = {
  __typename: 'AggregatedKyc6MatchItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: KYC6AggregatedMatches;
};

/** All linked accounts */
export type AllLinkedAccounts = {
  __typename: 'AllLinkedAccounts';
  addressLine: Maybe<Scalars['String']['output']>;
  birthDate: Maybe<Scalars['String']['output']>;
  brand: Maybe<Brand>;
  city: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  linkedAccounts: Array<LinkedAccounts>;
  playerId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  zipCode: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type AllLinkedAccountsItemConnection = {
  __typename: 'AllLinkedAccountsItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AllLinkedAccountsItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AllLinkedAccountsItemEdge = {
  __typename: 'AllLinkedAccountsItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: AllLinkedAccounts;
};

/** The URL where the AML risk assessment report can be found */
export type AmlRiskAssessmentReport = {
  __typename: 'AmlRiskAssessmentReport';
  url: Scalars['String']['output'];
};

/** The aml risk level of a player */
export enum AmlRiskLevel {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
  NotSet = 'NotSet'
}

/** SoW history entry for AML Risk Level changed */
export type AmlRiskLevelChangedItem = PlayerComplianceHistorySearchItem & {
  __typename: 'AmlRiskLevelChangedItem';
  amlRiskLevel: AmlRiskLevel;
  eventType: Scalars['String']['output'];
  /** @deprecated Use initiatorV2 */
  initiator: Initiator;
  initiatorV2: Maybe<Initiator>;
  playerGlobalId: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  playerUUID: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  reason: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/** Authentication Method */
export type AuthenticationMethod = {
  __typename: 'AuthenticationMethod';
  authenticationMethodId: Scalars['String']['output'];
  brand: Brand;
  /**
   * Number of allowed invalid login attempts before player is locked from logging in
   * @deprecated Get info from `globalLoginAttemptsInfo` object instead
   */
  invalidGlobalLoginAttemptsAllowed: Scalars['Int']['output'];
  /**
   * Timestamp when player was locked due to too many invalid login attempts
   * @deprecated Get info from `globalLoginAttemptsInfo` object instead
   */
  maxGlobalLoginAttemptsReachedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  playerId: Maybe<Scalars['String']['output']>;
  processedAt: Scalars['OffsetDateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** Blocking limit. */
export type BlockingLimit = {
  __typename: 'BlockingLimit';
  /** Value of roles the agent had at the time of block/unblock. */
  agentRoles: Array<Scalars['String']['output']>;
  /** Value of the blocking status for the limit limit. */
  blocked: Scalars['Boolean']['output'];
  /** Date of configuration. */
  configuredAt: Scalars['OffsetDateTime']['output'];
  /** Value of the initiator who blocked/unblocked the limit. */
  initiatorId: Scalars['String']['output'];
  /** Value of the initiator type who blocked/unblocked the limit. */
  initiatorType: Scalars['String']['output'];
  /** Date when blocking limit will take effect. */
  validFrom: Scalars['OffsetDateTime']['output'];
};

export type BoSourceOfFund = {
  sourceOfFundType: SourceOfFundType;
  wasProvided: Scalars['Boolean']['input'];
};

export type BoSourceOfFundType = {
  __typename: 'BoSourceOfFundType';
  /** Type of the source of fund */
  sourceOfFundType: SourceOfFundType;
  /** Was provided? */
  wasProvided: Scalars['Boolean']['output'];
};

export type BoSourceOfFunds = {
  sourceOfFunds: Array<BoSourceOfFund>;
};

export type BoSourceOfFundsType = {
  __typename: 'BoSourceOfFundsType';
  /** list of provided source of funds */
  sourceOfFunds: Array<BoSourceOfFundType>;
};

/** Information about a single bonus */
export type Bonus = {
  __typename: 'Bonus';
  /** The original bonus amount given */
  amount: Scalars['BigDecimal']['output'];
  /** The amount converted to the real money balance */
  amountConverted: Maybe<Scalars['BigDecimal']['output']>;
  /** The bonus amount not converted to real money money balance at time of conversion */
  amountDiscarded: Maybe<Scalars['BigDecimal']['output']>;
  amountForfeited: Maybe<Scalars['BigDecimal']['output']>;
  assignationId: Maybe<Scalars['String']['output']>;
  bonusId: Scalars['String']['output'];
  brand: BrandEnum;
  campaignId: Maybe<Scalars['String']['output']>;
  /** The current bonus balance */
  closingBalance: Scalars['BigDecimal']['output'];
  convertedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  createdAt: Scalars['OffsetDateTime']['output'];
  createdBy: Initiator;
  currency: Scalars['String']['output'];
  /** Time when expiration was triggered */
  expiredAt: Maybe<Scalars['OffsetDateTime']['output']>;
  /** Time when bonus will expire */
  expiresAt: Scalars['OffsetDateTime']['output'];
  /** Reason why a bonus was forfeited */
  forfeitCause: Maybe<Scalars['String']['output']>;
  forfeitedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  /** The maximum amount that can converted to real money */
  maxPayout: Scalars['BigDecimal']['output'];
  playerId: Scalars['String']['output'];
  /** Time of the latest update to the bonus */
  processedAt: Scalars['OffsetDateTime']['output'];
  rewardId: Maybe<Scalars['String']['output']>;
  status: BonusStatus;
  /** The amount that has been turned over so far */
  wageringProgress: Scalars['BigDecimal']['output'];
  /** The total amount that has to be turned over */
  wageringRequirement: Scalars['BigDecimal']['output'];
  /** The number of times the amount has to be turned over */
  wageringRequirementFactor: Scalars['Int']['output'];
};

/** Bonus balance should have been updated but bonus was already non active */
export type BonusBalanceNotAffectedItem = BonusHistoryItem & {
  __typename: 'BonusBalanceNotAffectedItem';
  /** The amount that could not be given to the bonus balance */
  amountIgnored: Scalars['BigDecimal']['output'];
  assignationId: Maybe<Scalars['String']['output']>;
  bonusId: Scalars['String']['output'];
  brand: BrandEnum;
  campaignId: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  eventType: BonusEventType;
  id: Scalars['String']['output'];
  playerId: Scalars['String']['output'];
  playerSessionId: Maybe<Scalars['String']['output']>;
  processedAt: Scalars['OffsetDateTime']['output'];
  /** The reason that the amount could not be given to the bonus balance */
  reason: Scalars['String']['output'];
  rewardId: Maybe<Scalars['String']['output']>;
};

/** A bonus code redeemable by players for rewards or challenges */
export type BonusCode = Node & {
  __typename: 'BonusCode';
  bonusItems: Array<BonusCodeItem>;
  brand: Brand;
  category: BonusCodeCategory;
  /** Players currently holding this bonus code, most recent claim first */
  claimingPlayers: BonusCodeClaimConnection;
  claimsUsed: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  createdAt: Maybe<Scalars['OffsetDateTime']['output']>;
  endDate: Maybe<Scalars['OffsetDateTime']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  initiator: Initiator;
  isActive: Scalars['Boolean']['output'];
  isForNewAccountOnly: Scalars['Boolean']['output'];
  maxClaims: Maybe<Scalars['PositiveInt']['output']>;
  startDate: Maybe<Scalars['OffsetDateTime']['output']>;
};


/** A bonus code redeemable by players for rewards or challenges */
export type BonusCodeclaimingPlayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Category of a bonus code */
export enum BonusCodeCategory {
  PROMOTION = 'PROMOTION',
  REFERRAL = 'REFERRAL',
  UNSPECIFIED = 'UNSPECIFIED'
}

/** A player's claim on a bonus code, shared by the claiming-players and claimed-bonus-codes lists */
export type BonusCodeClaim = {
  __typename: 'BonusCodeClaim';
  bonusCode: Maybe<BonusCode>;
  brand: Brand;
  category: BonusCodeCategory;
  claimedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  code: Scalars['String']['output'];
  player: Player;
};

/** A connection to a list of items. */
export type BonusCodeClaimConnection = {
  __typename: 'BonusCodeClaimConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<BonusCodeClaimEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BonusCodeClaimEdge = {
  __typename: 'BonusCodeClaimEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BonusCodeClaim;
};

/** Whether a bonus code can be claimed right now */
export enum BonusCodeClaimability {
  CLAIMABLE_NOW = 'CLAIMABLE_NOW',
  NOT_CLAIMABLE = 'NOT_CLAIMABLE',
  UNSPECIFIED = 'UNSPECIFIED'
}

/** A connection to a list of items. */
export type BonusCodeConnection = {
  __typename: 'BonusCodeConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<BonusCodeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BonusCodeEdge = {
  __typename: 'BonusCodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BonusCode;
};

/** A reward or challenge granted by a bonus code */
export type BonusCodeItem = {
  __typename: 'BonusCodeItem';
  /** Global ID of the referenced RewardItem or ChallengeItemV3 */
  bonusId: Scalars['ID']['output'];
  bonusType: BonusItemType;
};

export type BonusCodeItemInput = {
  bonusId: Scalars['String']['input'];
  bonusType: BonusItemType;
};

/** How to order bonus codes; ignored unless both codePrefix and bonusItem are omitted */
export enum BonusCodeSortField {
  CREATED_AT = 'CREATED_AT',
  UPDATED_AT = 'UPDATED_AT'
}

/** A connection to a list of items. */
export type BonusConnection = {
  __typename: 'BonusConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<BonusEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Bonus converted */
export type BonusConvertedItem = BonusHistoryItem & {
  __typename: 'BonusConvertedItem';
  /** The amount that was converted */
  amountConverted: Scalars['BigDecimal']['output'];
  /** The amount that was discarded */
  amountDiscarded: Scalars['BigDecimal']['output'];
  assignationId: Maybe<Scalars['String']['output']>;
  bonusId: Scalars['String']['output'];
  brand: BrandEnum;
  campaignId: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  eventType: BonusEventType;
  id: Scalars['String']['output'];
  /** The maximum amount that can be paid out */
  maxPayout: Scalars['BigDecimal']['output'];
  playerId: Scalars['String']['output'];
  playerSessionId: Maybe<Scalars['String']['output']>;
  processedAt: Scalars['OffsetDateTime']['output'];
  rewardId: Maybe<Scalars['String']['output']>;
};

/** Bonus created */
export type BonusCreatedItem = BonusHistoryItem & {
  __typename: 'BonusCreatedItem';
  /** The original bonus amount given */
  amount: Scalars['BigDecimal']['output'];
  assignationId: Maybe<Scalars['String']['output']>;
  bonusId: Scalars['String']['output'];
  brand: BrandEnum;
  campaignId: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  eventType: BonusEventType;
  expiresAt: Scalars['OffsetDateTime']['output'];
  id: Scalars['String']['output'];
  initiator: Initiator;
  /** The maximum amount that can be paid out */
  maxPayout: Scalars['BigDecimal']['output'];
  playerId: Scalars['String']['output'];
  playerSessionId: Maybe<Scalars['String']['output']>;
  processedAt: Scalars['OffsetDateTime']['output'];
  rewardId: Maybe<Scalars['String']['output']>;
  /** The amount that has to be turned over */
  wageringRequirement: Scalars['BigDecimal']['output'];
  /** The number of times the amount has to be turned over */
  wageringRequirementFactor: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BonusEdge = {
  __typename: 'BonusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Bonus;
};

/** Type of bonus event */
export enum BonusEventType {
  /** Bonus balance should have been updated but bonus was already non active */
  BonusBalanceNotAffected = 'BonusBalanceNotAffected',
  /** Bonus converted */
  BonusConverted = 'BonusConverted',
  /** Bonus created */
  BonusCreated = 'BonusCreated',
  /** Bonus expired */
  BonusExpired = 'BonusExpired',
  /** Bonus forfeited */
  BonusForfeited = 'BonusForfeited'
}

/** Bonus expired */
export type BonusExpiredItem = BonusHistoryItem & {
  __typename: 'BonusExpiredItem';
  /** The amount that was forfeited */
  amountForfeited: Scalars['BigDecimal']['output'];
  assignationId: Maybe<Scalars['String']['output']>;
  bonusId: Scalars['String']['output'];
  brand: BrandEnum;
  campaignId: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  eventType: BonusEventType;
  id: Scalars['String']['output'];
  playerId: Scalars['String']['output'];
  playerSessionId: Maybe<Scalars['String']['output']>;
  processedAt: Scalars['OffsetDateTime']['output'];
  rewardId: Maybe<Scalars['String']['output']>;
  /** The amount that was wagered */
  wageringProgress: Scalars['BigDecimal']['output'];
  /** The number of times the amount has to be turned over */
  wageringRequirementFactor: Scalars['Int']['output'];
};

/** Bonus forfeited */
export type BonusForfeitedItem = BonusHistoryItem & {
  __typename: 'BonusForfeitedItem';
  /** The amount that was forfeited */
  amountForfeited: Scalars['BigDecimal']['output'];
  assignationId: Maybe<Scalars['String']['output']>;
  bonusId: Scalars['String']['output'];
  brand: BrandEnum;
  campaignId: Maybe<Scalars['String']['output']>;
  /** The reason why the bonus was forfeited */
  cause: Scalars['String']['output'];
  currency: Scalars['String']['output'];
  eventType: BonusEventType;
  id: Scalars['String']['output'];
  playerId: Scalars['String']['output'];
  playerSessionId: Maybe<Scalars['String']['output']>;
  processedAt: Scalars['OffsetDateTime']['output'];
  rewardId: Maybe<Scalars['String']['output']>;
  /** The amount that was wagered */
  wageringProgress: Scalars['BigDecimal']['output'];
  /** The number of times the amount has to be turned over */
  wageringRequirementFactor: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type BonusHistoryConnection = {
  __typename: 'BonusHistoryConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<BonusHistoryEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BonusHistoryEdge = {
  __typename: 'BonusHistoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: BonusHistoryItem;
};

/** An entry in the bonus history */
export type BonusHistoryItem = {
  assignationId: Maybe<Scalars['String']['output']>;
  bonusId: Scalars['String']['output'];
  brand: BrandEnum;
  campaignId: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  eventType: BonusEventType;
  id: Scalars['String']['output'];
  playerId: Scalars['String']['output'];
  playerSessionId: Maybe<Scalars['String']['output']>;
  processedAt: Scalars['OffsetDateTime']['output'];
  rewardId: Maybe<Scalars['String']['output']>;
};

/** The kind of entity a bonus item references */
export enum BonusItemType {
  CHALLENGE = 'CHALLENGE',
  REWARD = 'REWARD',
  UNSPECIFIED = 'UNSPECIFIED'
}

/** Bonus Money drop challenge reward type */
export type BonusMoneyDropChallengeReward = ChallengeRewardType & {
  __typename: 'BonusMoneyDropChallengeReward';
  amount: Scalars['BigDecimal']['output'];
  currency: Scalars['String']['output'];
  maxPayout: Scalars['BigDecimal']['output'];
  name: Scalars['String']['output'];
  wageringRequirementFactor: Scalars['Int']['output'];
};

/** Bonus Money drop reward type */
export type BonusMoneyDropReward = RewardType & {
  __typename: 'BonusMoneyDropReward';
  amount: Scalars['BigDecimal']['output'];
  currency: Scalars['String']['output'];
  maxPayout: Scalars['BigDecimal']['output'];
  name: Scalars['String']['output'];
  wageringRequirementFactor: Scalars['Int']['output'];
};

/** Represents a bonus money reward template */
export type BonusMoneyTemplate = {
  __typename: 'BonusMoneyTemplate';
  /** Optional affiliate ID, can also be defined at offer level */
  affiliateId: Maybe<Scalars['String']['output']>;
  /** Can be empty and defined at offer level */
  countries: Array<Scalars['ISOCountryCode']['output']>;
  currency: Scalars['ISOCurrencyCode']['output'];
  /** Max awarded amount depending on amount deposited: maxDepositAmount * multiplier = maxRewardAmount */
  dynamicAmount: Maybe<DynamicDepositAmount>;
  /** Will apply on staticAmount or dynamicAmount to calculate max payout */
  dynamicMaxPayoutMultiplier: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  /** Default value in case dynamicAmount is not provided */
  staticAmount: Scalars['Int']['output'];
  /** Default value in case dynamicMaxPayoutMultiplier is not provided */
  staticMaxPayout: Scalars['Int']['output'];
  /** The number of times the amount has to be turned over */
  wageringRequirementFactor: Scalars['Int']['output'];
};

/** The field by which to order the results */
export enum BonusOrder {
  /** createdAt */
  createdAt = 'createdAt',
  /** processedAt */
  processedAt = 'processedAt'
}

/** Reward profile of type Bonus money drop */
export type BonusRewardProfile = {
  __typename: 'BonusRewardProfile';
  /** Optional affiliate ID for this specific template */
  affiliateId: Maybe<Scalars['String']['output']>;
  /** Number of days to claim the reward */
  claimDays: Scalars['Int']['output'];
  /** Optional countries for this specific template */
  countries: Array<Scalars['ISOCountryCode']['output']>;
  /** Max awarded amount depending on amount deposited: maxDepositAmount * multiplier = maxRewardAmount */
  dynamicAmount: Maybe<DynamicAmount>;
  /** Will apply on staticAmount or dynamicAmount to calculate max payout */
  dynamicMaxPayoutMultiplier: Maybe<Scalars['Float']['output']>;
  /** Type of reward: Freespins, Bonus, or Money */
  rewardType: Scalars['String']['output'];
  /** Default value in case dynamicAmount is not provided */
  staticAmount: Scalars['Int']['output'];
  /** Default value in case dynamicMaxPayoutMultiplier is not provided */
  staticMaxPayout: Scalars['Int']['output'];
  /** The number of times the amount has to be turned over */
  wageringRequirementFactor: Scalars['Int']['output'];
};

/** Bonus status */
export enum BonusStatus {
  /** Active bonus */
  Active = 'Active',
  /** Converted bonus */
  Converted = 'Converted',
  /** Expired bonus */
  Expired = 'Expired',
  /** Forfeited bonus */
  Forfeited = 'Forfeited'
}

/** Data about a bonus transaction */
export type BonusTransactionData = {
  __typename: 'BonusTransactionData';
  /** The amount of the bonus */
  amount: Scalars['BigDecimal']['output'];
  /** The id of the bonus */
  bonusId: Scalars['String']['output'];
  /** The id of the campaign */
  campaignId: Maybe<Scalars['String']['output']>;
  /** The closing balance for the bonus transaction */
  closingBalance: Scalars['BigDecimal']['output'];
  /** The opening balance for the bonus transaction */
  openingBalance: Scalars['BigDecimal']['output'];
};

/** A brand. */
export type Brand = Node & {
  __typename: 'Brand';
  /** The brand code. */
  code: Scalars['String']['output'];
  /** The ID of an object */
  id: Scalars['ID']['output'];
  /** The name of the brand. */
  name: Scalars['String']['output'];
};

/** The brand of the site. */
export enum BrandEnum {
  AMOH = 'AMOH',
  AMOK = 'AMOK',
  BLING = 'BLING',
  CNEYE = 'CNEYE',
  DJACF = 'DJACF',
  DJACK = 'DJACK',
  DWISE = 'DWISE',
  DWISF = 'DWISF',
  F9CAS = 'F9CAS',
  GEMLH = 'GEMLH',
  GEMLR = 'GEMLR',
  GIGAS = 'GIGAS',
  GLDRH = 'GLDRH',
  GLDRL = 'GLDRL',
  GSLOT = 'GSLOT',
  HEART = 'HEART',
  HSPIN = 'HSPIN',
  HUZLN = 'HUZLN',
  HYPER = 'HYPER',
  JPCOF = 'JPCOF',
  JPCOW = 'JPCOW',
  KIMCN = 'KIMCN',
  LCKYH = 'LCKYH',
  LCKYJ = 'LCKYJ',
  LFUEL = 'LFUEL',
  MDRSF = 'MDRSF',
  MDRSH = 'MDRSH',
  MONKA = 'MONKA',
  MOOSE = 'MOOSE',
  MRGLD = 'MRGLD',
  MSINH = 'MSINH',
  MSINO = 'MSINO',
  MTGLD = 'MTGLD',
  MTGLH = 'MTGLH',
  NFRNO = 'NFRNO',
  NIFTH = 'NIFTH',
  NIFTY = 'NIFTY',
  NITRO = 'NITRO',
  OVRLD = 'OVRLD',
  OVRLH = 'OVRLH',
  PURPL = 'PURPL',
  QUIKZ = 'QUIKZ',
  RABIT = 'RABIT',
  RAPTR = 'RAPTR',
  RAZOR = 'RAZOR',
  REBLZ = 'REBLZ',
  REKO = 'REKO',
  REKOF = 'REKOF',
  RFLCH = 'RFLCH',
  RFLCN = 'RFLCN',
  RFURY = 'RFURY',
  SHAUS = 'SHAUS',
  SHOCK = 'SHOCK',
  SHYPE = 'SHYPE',
  SHYPH = 'SHYPH',
  SKULL = 'SKULL',
  SLAMZ = 'SLAMZ',
  SLCLD = 'SLCLD',
  SLCLF = 'SLCLF',
  SLION = 'SLION',
  SLOIQ = 'SLOIQ',
  SLOSR = 'SLOSR',
  SLOWF = 'SLOWF',
  SLOWL = 'SLOWL',
  SLOZY = 'SLOZY',
  SLTBH = 'SLTBH',
  SLTBL = 'SLTBL',
  SMASH = 'SMASH',
  SMOJO = 'SMOJO',
  SPICE = 'SPICE',
  SPINA = 'SPINA',
  SPJAM = 'SPJAM',
  SPNJU = 'SPNJU',
  SPNRH = 'SPNRH',
  SPNRO = 'SPNRO',
  SPONY = 'SPONY',
  SPWAR = 'SPWAR',
  SQUAD = 'SQUAD',
  SUGAR = 'SUGAR',
  SWEET = 'SWEET',
  SWING = 'SWING',
  SWISF = 'SWISF',
  SWISH = 'SWISH',
  SWORM = 'SWORM',
  UNLMH = 'UNLMH',
  UNLMT = 'UNLMT',
  VEGAS = 'VEGAS',
  WNSLF = 'WNSLF',
  WNSLY = 'WNSLY',
  WNZIE = 'WNZIE',
  WNZIH = 'WNZIH',
  WSPIF = 'WSPIF',
  WSPIN = 'WSPIN'
}

/** A bulk adjustment update error event triggered by the system (error/success). */
export type BulkAdjustmentProgressEventType = Node & {
  __typename: 'BulkAdjustmentProgressEventType';
  /** The id of the object. */
  id: Scalars['ID']['output'];
  /** result */
  result: Scalars['Json']['output'];
};

/** Bulk Adjustment */
export type BulkAdjustmentType = {
  __typename: 'BulkAdjustmentType';
  amountToProcess: Scalars['Int']['output'];
};

/** Response for bulk create excluded players */
export type BulkCreateExcludedPlayersResponse = {
  __typename: 'BulkCreateExcludedPlayersResponse';
  failedPlayers: Array<PlayerInformation>;
  numberOfSuccesses: Scalars['Int']['output'];
};

/** A bulkTransformPlayersResult */
export type BulkTransformPlayersResult = {
  __typename: 'BulkTransformPlayersResult';
  /** Report url */
  url: Scalars['String']['output'];
};

export type CalculatedReward = {
  __typename: 'CalculatedReward';
  maxWin: Scalars['Int']['output'];
  nrOfSpins: Scalars['Int']['output'];
  rewardAmount: Scalars['Float']['output'];
  spinsValue: Scalars['Int']['output'];
  wagering: Scalars['Int']['output'];
};

export type CancelBlockclearPayoutFailure = {
  __typename: 'CancelBlockclearPayoutFailure';
  dinoPayoutId: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type CancelBlockclearPayoutsResponse = {
  __typename: 'CancelBlockclearPayoutsResponse';
  failures: Array<CancelBlockclearPayoutFailure>;
};

/** Cashback transaction item */
export type CashbackTransactionItem = {
  __typename: 'CashbackTransactionItem';
  amount: Scalars['BigDecimal']['output'];
  currency: Scalars['String']['output'];
  currentCashbackPeriod: Scalars['OffsetDateTime']['output'];
  /** The ID of an object */
  id: Scalars['ID']['output'];
  nextCashbackPeriod: Maybe<Scalars['OffsetDateTime']['output']>;
  processedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  status: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

export type ChallengeBonusMoneyDropInput = {
  amount: Scalars['BigDecimal']['input'];
  currency: Scalars['ISOCurrencyCode']['input'];
  maxPayout: Scalars['BigDecimal']['input'];
  wageringRequirementFactor: Scalars['Int']['input'];
};

/** Action which a player has to perform to complete the challenge */
export enum ChallengeCriteria {
  CompleteSoW = 'CompleteSoW',
  Deposit = 'Deposit'
}

/** Action which a player has to perform to complete the challenge (V2) */
export type ChallengeCriteriaV2 = {
  type: Scalars['String']['output'];
};

export type ChallengeDynamicBonusMoneyDropInput = {
  currency: Scalars['ISOCurrencyCode']['input'];
  /** The maximum amount of bonus money that can be dropped */
  maxAmount: Scalars['BigDecimal']['input'];
  /** The maximum amount that can be paid out from the bonus money */
  maxPayout: Scalars['BigDecimal']['input'];
  /** Overrides maxPayout if defined. Multiplier used to calculate max payout based on the amount given in future */
  maxPayoutMultiplier?: InputMaybe<Scalars['BigDecimal']['input']>;
  multiplier: Scalars['BigDecimal']['input'];
  wageringRequirementFactor: Scalars['Int']['input'];
};

export type ChallengeDynamicFreeSpins = {
  currency: Scalars['ISOCurrencyCode']['input'];
  desktopId?: InputMaybe<Scalars['String']['input']>;
  freeSpinValue: Scalars['Long']['input'];
  maxFreeSpinsAmount: Scalars['Int']['input'];
  mobileId?: InputMaybe<Scalars['String']['input']>;
  multiplier: Scalars['BigDecimal']['input'];
  payLines: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
};

export type ChallengeDynamicMoneyDropInput = {
  currency: Scalars['ISOCurrencyCode']['input'];
  /** The maximum amount of bonus money that can be dropped */
  maxAmount: Scalars['BigDecimal']['input'];
  multiplier: Scalars['BigDecimal']['input'];
};

/** Challenge target systems */
export enum ChallengeExternalSystem {
  Internal = 'Internal',
  Smartico = 'Smartico'
}

export type ChallengeFreeSpins = {
  amountFreeSpins: Scalars['Int']['input'];
  currency: Scalars['ISOCurrencyCode']['input'];
  desktopId?: InputMaybe<Scalars['String']['input']>;
  freeSpinValue: Scalars['Long']['input'];
  mobileId?: InputMaybe<Scalars['String']['input']>;
  payLines: Scalars['Int']['input'];
  provider: Scalars['String']['input'];
};

/** A challenge item */
export type ChallengeItemV3 = {
  __typename: 'ChallengeItemV3';
  brands: Array<BrandEnum>;
  /** @deprecated use challengeActionsV2 instead */
  challengeActions: Array<ChallengeCriteria>;
  challengeActionsV2: Array<ChallengeCriteriaV2>;
  challengeId: Scalars['ID']['output'];
  challengeRewards: Array<ChallengeRewardV2>;
  challengeSystem: Scalars['String']['output'];
  challengeUUID: Scalars['String']['output'];
  countries: Array<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  eligibleCriteria: Array<EligibilityCriteria>;
  endDate: Maybe<Scalars['OffsetDateTime']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  numberOfPlayers: Scalars['Int']['output'];
  startDate: Scalars['OffsetDateTime']['output'];
  status: ChallengeStatus;
};

/** A connection to a list of items. */
export type ChallengeItemV3Connection = {
  __typename: 'ChallengeItemV3Connection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ChallengeItemV3Edge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ChallengeItemV3Edge = {
  __typename: 'ChallengeItemV3Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: ChallengeItemV3;
};

export type ChallengeMoneyDropInput = {
  amount: Scalars['BigDecimal']['input'];
  currency: Scalars['ISOCurrencyCode']['input'];
};

export type ChallengeRewardInputV2 = {
  activateAfter?: InputMaybe<Scalars['String']['input']>;
  challengeRewardTypeInput: ChallengeRewardTypeInput;
  claimType: ClaimType;
  displayName?: InputMaybe<Scalars['String']['input']>;
  expiresIn?: InputMaybe<Scalars['String']['input']>;
};

/** Details about a challenge reward */
export type ChallengeRewardType = {
  name: Scalars['String']['output'];
};

/** Challenge Reward types */
export enum ChallengeRewardTypeEnum {
  BonusMoneyDropType = 'BonusMoneyDropType',
  DynamicBonusMoneyDropType = 'DynamicBonusMoneyDropType',
  DynamicFreeSpinsType = 'DynamicFreeSpinsType',
  DynamicMoneyDropType = 'DynamicMoneyDropType',
  FreeSpinsType = 'FreeSpinsType',
  MoneyDropType = 'MoneyDropType',
  Unknown = 'Unknown'
}

export type ChallengeRewardTypeInput = {
  bonusMoneyDrop?: InputMaybe<ChallengeBonusMoneyDropInput>;
  challengeRewardType: ChallengeRewardTypeEnum;
  dynamicBonusMoneyDrop?: InputMaybe<ChallengeDynamicBonusMoneyDropInput>;
  dynamicFreeSpins?: InputMaybe<ChallengeDynamicFreeSpins>;
  dynamicMoneyDrop?: InputMaybe<ChallengeDynamicMoneyDropInput>;
  freeSpins?: InputMaybe<ChallengeFreeSpins>;
  moneyDrop?: InputMaybe<ChallengeMoneyDropInput>;
};

/** Reward which will be created for a player once their challenge is completed */
export type ChallengeRewardV2 = {
  __typename: 'ChallengeRewardV2';
  activateAfter: Maybe<Scalars['Duration']['output']>;
  campaignId: Maybe<Scalars['CampaignId']['output']>;
  challengeRewardType: ChallengeRewardType;
  expiresIn: Maybe<Scalars['Duration']['output']>;
};

/** Possible challenge statuses */
export enum ChallengeStatus {
  Activated = 'Activated',
  Expired = 'Expired',
  Removed = 'Removed',
  Scheduled = 'Scheduled'
}

/** Reward claim type */
export enum ClaimType {
  Instant = 'Instant',
  Manual = 'Manual'
}

/** Cause of closing account. */
export enum CloseAccountCauseV3 {
  AbusiveBehaviour = 'AbusiveBehaviour',
  AccountIssues = 'AccountIssues',
  AdverseMedia = 'AdverseMedia',
  BlockCustomerRequest = 'BlockCustomerRequest',
  BrandClosure = 'BrandClosure',
  ClosedInternalDecision = 'ClosedInternalDecision',
  ConfirmedFraud = 'ConfirmedFraud',
  ConfirmedPromotionAbuse = 'ConfirmedPromotionAbuse',
  CrossLicenseBlock = 'CrossLicenseBlock',
  ExceededSOWF = 'ExceededSOWF',
  FailureProvideDD = 'FailureProvideDD',
  InsufficientGameChoices = 'InsufficientGameChoices',
  KycReviewing = 'KycReviewing',
  MLRO = 'MLRO',
  MigrationCause = 'MigrationCause',
  MultipleAccounts = 'MultipleAccounts',
  NonCAPExtremeCRARisk = 'NonCAPExtremeCRARisk',
  NotEnoughBonusesOrPromotions = 'NotEnoughBonusesOrPromotions',
  PEPListMatch = 'PEPListMatch',
  PEPSanctionsListMatch = 'PEPSanctionsListMatch',
  PaymentIssues = 'PaymentIssues',
  PendingInternalChecks = 'PendingInternalChecks',
  PermanentCustomerRequest = 'PermanentCustomerRequest',
  PermanentNonRG = 'PermanentNonRG',
  ProhibitedCountry = 'ProhibitedCountry',
  ResponsibleGaming = 'ResponsibleGaming',
  RgBrandClosure = 'RgBrandClosure',
  RgPendingInternalChecks = 'RgPendingInternalChecks',
  SanctionsListMatch = 'SanctionsListMatch',
  ServiceDelays = 'ServiceDelays',
  SuspectedFraud = 'SuspectedFraud',
  SuspectedPromotionAbuse = 'SuspectedPromotionAbuse',
  TakingABreak = 'TakingABreak',
  TechnicalIssues = 'TechnicalIssues',
  TemporaryCustomerRequest = 'TemporaryCustomerRequest',
  ToBeCategorized = 'ToBeCategorized',
  UnsatisfactoryUx = 'UnsatisfactoryUx',
  WithdrawalConcerns = 'WithdrawalConcerns'
}

/** Cause of closing account. */
export enum CloseAccountCauseV4 {
  AbusiveBehaviour = 'AbusiveBehaviour',
  AccountIssues = 'AccountIssues',
  AdverseMedia = 'AdverseMedia',
  BlockCustomerRequest = 'BlockCustomerRequest',
  BrandClosure = 'BrandClosure',
  ClosedInternalDecision = 'ClosedInternalDecision',
  ConfirmedFraud = 'ConfirmedFraud',
  ConfirmedPromotionAbuse = 'ConfirmedPromotionAbuse',
  CrossLicenseBlock = 'CrossLicenseBlock',
  ExceededSOWF = 'ExceededSOWF',
  FailureProvideDD = 'FailureProvideDD',
  InsufficientGameChoices = 'InsufficientGameChoices',
  KycReviewing = 'KycReviewing',
  MLRO = 'MLRO',
  MigrationCause = 'MigrationCause',
  MultipleAccounts = 'MultipleAccounts',
  NonCAPExtremeCRARisk = 'NonCAPExtremeCRARisk',
  NotEnoughBonusesOrPromotions = 'NotEnoughBonusesOrPromotions',
  PEPListMatch = 'PEPListMatch',
  PaymentIssues = 'PaymentIssues',
  PendingInternalChecks = 'PendingInternalChecks',
  PermanentCustomerRequest = 'PermanentCustomerRequest',
  PermanentNonRG = 'PermanentNonRG',
  ProhibitedCountry = 'ProhibitedCountry',
  ResponsibleGaming = 'ResponsibleGaming',
  RgBrandClosure = 'RgBrandClosure',
  RgPendingInternalChecks = 'RgPendingInternalChecks',
  SanctionsListMatch = 'SanctionsListMatch',
  ServiceDelays = 'ServiceDelays',
  SuspectedFraud = 'SuspectedFraud',
  SuspectedPromotionAbuse = 'SuspectedPromotionAbuse',
  TakingABreak = 'TakingABreak',
  TechnicalIssues = 'TechnicalIssues',
  TemporaryCustomerRequest = 'TemporaryCustomerRequest',
  ToBeCategorized = 'ToBeCategorized',
  UnsatisfactoryUx = 'UnsatisfactoryUx',
  WithdrawalConcerns = 'WithdrawalConcerns'
}

/** Sort direction for the closing balance report */
export enum ClosingBalanceOrder {
  asc = 'asc',
  desc = 'desc'
}

/** Column to sort the closing balance report by */
export enum ClosingBalanceOrderBy {
  brand = 'brand',
  closingBalance = 'closingBalance'
}

/** A closing balances export details. */
export type ClosingBalancesExportDetails = {
  __typename: 'ClosingBalancesExportDetails';
  url: Scalars['String']['output'];
};

/** A statistics column value sorting order specification. */
export type ColumnOrderSpecType = {
  column: Scalars['String']['input'];
  order: OrderingSpecType;
};

/** Complete Source of Wealth challenge criteria */
export type CompleteSoWChallengeCriteria = ChallengeCriteriaV2 & {
  __typename: 'CompleteSoWChallengeCriteria';
  type: Scalars['String']['output'];
};

/** A compliance limit for an individual person across all brands */
export type ComplianceGlobalPlayerLimit = {
  __typename: 'ComplianceGlobalPlayerLimit';
  activeFrom: Maybe<Scalars['OffsetDateTime']['output']>;
  euroAmount: Scalars['BigDecimal']['output'];
  euroThreshold: Scalars['BigDecimal']['output'];
  latestChangeAt: Scalars['OffsetDateTime']['output'];
  limitName: Scalars['String']['output'];
  limitReached: Scalars['Boolean']['output'];
  rollingPeriod: RollingPeriod;
};

/** SoW history entry for CRA Risk Level changed */
export type CraRiskLevelChangedItem = PlayerComplianceHistorySearchItem & {
  __typename: 'CraRiskLevelChangedItem';
  customerRisk: CustomerRisk;
  eventType: Scalars['String']['output'];
  initiatorV2: Maybe<Initiator>;
  playerGlobalId: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  playerUUID: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** Input for creating a bonus code */
export type CreateBonusCodeInput = {
  bonusItems: Array<BonusCodeItemInput>;
  brand: BrandEnum;
  category: BonusCodeCategory;
  code: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  isForNewAccountOnly: Scalars['Boolean']['input'];
  maxClaims?: InputMaybe<Scalars['PositiveInt']['input']>;
  startDate?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};

/** Information about supported crypto currencies and which networks we are supporting them. */
export type CryptoCurrencyNetworkInformation = {
  __typename: 'CryptoCurrencyNetworkInformation';
  /** The crypto currency code. */
  cryptoCurrency: Scalars['ISOCurrencyCode']['output'];
  /** The supported networks for this crypto currency. */
  supportedByNetworks: Array<CryptoNetworkEnum>;
};

/** Info about a crypto payment */
export type CryptoInformation = {
  __typename: 'CryptoInformation';
  /** The crypto network on which as payment took place */
  network: Maybe<CryptoNetworkEnum>;
  /** The fee on the crypto network */
  networkFee: Maybe<Fee>;
  /** Used for some crypto together with address to specify a destination */
  tag: Maybe<Scalars['String']['output']>;
  /** The address to which the payment is going */
  toWalletAddress: Maybe<Scalars['String']['output']>;
  /** Id to find the payment on the block chain */
  txHashId: Maybe<Scalars['String']['output']>;
};

/** The crypto network on which as payment took place */
export enum CryptoNetworkEnum {
  Arbitrum = 'Arbitrum',
  BCH = 'BCH',
  BCH_TESTNET = 'BCH_TESTNET',
  BSC = 'BSC',
  BTC_TESTNET = 'BTC_TESTNET',
  Bitcoin = 'Bitcoin',
  DogeCoin = 'DogeCoin',
  DogeCoin_TESTNET = 'DogeCoin_TESTNET',
  EOS = 'EOS',
  EOS_TESTNET = 'EOS_TESTNET',
  Ethereum = 'Ethereum',
  Goerli = 'Goerli',
  LiteCoin = 'LiteCoin',
  LiteCoin_TESTNET = 'LiteCoin_TESTNET',
  Polygon = 'Polygon',
  Rinkeby = 'Rinkeby',
  Sepolia = 'Sepolia',
  Solana = 'Solana',
  Solana_TESTNET = 'Solana_TESTNET',
  TRON = 'TRON',
  XRP = 'XRP',
  XRP_TESTNET = 'XRP_TESTNET'
}

/** A customer, an individual person across all brands. Represented by playerGlobalId. */
export type Customer = {
  __typename: 'Customer';
  customerClosure: Maybe<CustomerClosure>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  isCancelWithdrawalBlocked: Scalars['Boolean']['output'];
  isCustomerWhitelisted: Scalars['Boolean']['output'];
  isDepositsBlocked: Scalars['Boolean']['output'];
  isGamanzaBlocked: Scalars['Boolean']['output'];
  isIncreaseDepositLimitBlocked: Scalars['Boolean']['output'];
  isMarketingBlocked: Scalars['Boolean']['output'];
  isRewardsBlocked: Scalars['Boolean']['output'];
  isRgNetDepositLimitEnabled: Scalars['Boolean']['output'];
  playerGlobalId: Scalars['ID']['output'];
  playerGlobalUUID: Scalars['String']['output'];
  popUpsNeeded: Array<Scalars['String']['output']>;
};

/** Customer closure details */
export type CustomerClosure = {
  __typename: 'CustomerClosure';
  closeAccountCause: Scalars['String']['output'];
};

/** The CRA of a player */
export enum CustomerRisk {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

export type CustomerRiskAssessment = {
  __typename: 'CustomerRiskAssessment';
  /** The last time the risk assessment was calculated */
  calculatedAt: Scalars['OffsetDateTime']['output'];
  /** The final risk score with weights for each region taken into account (0 to 100) */
  finalScore: Scalars['Int']['output'];
  /** Kyc Status for the player global id */
  kycCheckStatus: KycCheckStatus;
  /** The maximum total unweighted score that is possible */
  maxScore: Scalars['Int']['output'];
  /** If exists, this it the system risk level based on the score. This means that the risk level has been manually overwritten */
  overriddenRiskLevel: Maybe<RiskLevel>;
  /** Player Global Id */
  playerGlobalId: Scalars['String']['output'];
  /** Players that belong to this risk assessment */
  players: Array<Player>;
  /** A list of the different CRA regions that make up the final score */
  regions: Array<Region>;
  /** Current review status */
  reviewStatusInfo: ReviewStatusInfo;
  /** Needs to be passed back in submitReview mutation. Can be considered a token */
  reviewTrigger: ReviewTrigger;
  /** The final risk level of the player */
  riskLevel: RiskLevel;
  /** The total unweighted score */
  score: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type CustomerRiskAssessmentConnection = {
  __typename: 'CustomerRiskAssessmentConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CustomerRiskAssessmentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CustomerRiskAssessmentEdge = {
  __typename: 'CustomerRiskAssessmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerRiskAssessment;
};

/** An entry in the risk history */
export type CustomerRiskAssessmentHistoryItem = {
  __typename: 'CustomerRiskAssessmentHistoryItem';
  comment: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  eventType: EventType;
  initiator: Maybe<Initiator>;
  outcomes: Array<Outcome>;
  playerGlobalId: Scalars['String']['output'];
  playerId: Maybe<Scalars['String']['output']>;
  processedAt: Scalars['OffsetDateTime']['output'];
};

/** A connection to a list of items. */
export type CustomerRiskAssessmentHistoryItemConnection = {
  __typename: 'CustomerRiskAssessmentHistoryItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CustomerRiskAssessmentHistoryItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CustomerRiskAssessmentHistoryItemEdge = {
  __typename: 'CustomerRiskAssessmentHistoryItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: CustomerRiskAssessmentHistoryItem;
};

/** DataSource version to query */
export enum DataSourceVersionEnum {
  NEW = 'NEW',
  OLD = 'OLD'
}

export enum DecisionSearchType {
  Approve = 'Approve',
  Deny = 'Deny',
  NotSet = 'NotSet'
}

export enum DecisionType {
  Approve = 'Approve',
  Deny = 'Deny'
}

/** Deposit challenge criteria */
export type DepositChallengeCriteria = ChallengeCriteriaV2 & {
  __typename: 'DepositChallengeCriteria';
  /** Optional payment integration filter for the deposit criteria */
  paymentIntegration: Maybe<PaymentIntegrationEnum>;
  type: Scalars['String']['output'];
};

/** Deposit info with first and last deposit date. */
export type DepositInfo = {
  __typename: 'DepositInfo';
  first: Scalars['String']['output'];
  last: Scalars['String']['output'];
};

/** Detailed cashback report */
export type DetailedCashbackReport = {
  __typename: 'DetailedCashbackReport';
  url: Scalars['String']['output'];
};

/** Detailed rakeback report */
export type DetailedRakebackReport = {
  __typename: 'DetailedRakebackReport';
  url: Scalars['String']['output'];
};

export type DinoBulkContributionSwitchResult = {
  __typename: 'DinoBulkContributionSwitchResult';
  failed: Array<DinoContributionSwitchFailure>;
  succeeded: Array<DinoContributionSwitchResult>;
};

/** Jackpot contribution switch state for a brand */
export type DinoContributionSwitch = {
  __typename: 'DinoContributionSwitch';
  /** Brand code */
  brand: Scalars['String']['output'];
  /** Whether contributions are enabled */
  enabled: Scalars['Boolean']['output'];
  /** Who last changed the switch */
  initiator: Maybe<Initiator>;
  /** Timestamp of the last change in millis */
  processedAt: Maybe<Scalars['Long']['output']>;
};

export type DinoContributionSwitchFailure = {
  __typename: 'DinoContributionSwitchFailure';
  brand: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

/** A jackpot contribution switch history entry */
export type DinoContributionSwitchHistoryEntry = {
  __typename: 'DinoContributionSwitchHistoryEntry';
  /** Brand code */
  brand: Scalars['String']['output'];
  /** Whether contributions were enabled */
  enabled: Scalars['Boolean']['output'];
  /** Who changed the switch */
  initiator: Initiator;
  /** Timestamp of the change in millis */
  processedAt: Scalars['Long']['output'];
};

/** A connection to a list of items. */
export type DinoContributionSwitchHistoryEntryConnection = {
  __typename: 'DinoContributionSwitchHistoryEntryConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<DinoContributionSwitchHistoryEntryEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DinoContributionSwitchHistoryEntryEdge = {
  __typename: 'DinoContributionSwitchHistoryEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DinoContributionSwitchHistoryEntry;
};

export type DinoContributionSwitchResult = {
  __typename: 'DinoContributionSwitchResult';
  brand: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
};

/** A historical snapshot of a dino jackpot leaderboard */
export type DinoJackpotLeaderboardHistoryEntry = {
  __typename: 'DinoJackpotLeaderboardHistoryEntry';
  /** Timestamp the snapshot was computed, in millis */
  computedTime: Scalars['Long']['output'];
  /** ISO currency code */
  currency: Scalars['String']['output'];
  /** Top contributors */
  leaderboard: Array<DinoLeaderboardPlayer>;
  /** Display name of the pot */
  potName: Scalars['String']['output'];
  /** Total contributions to the pot */
  totalContributions: Scalars['Float']['output'];
};

export enum DinoJackpotOptInStatus {
  optedIn = 'optedIn',
  optedOut = 'optedOut',
  undefined = 'undefined'
}

/** A player entry on a dino jackpot leaderboard */
export type DinoLeaderboardPlayer = {
  __typename: 'DinoLeaderboardPlayer';
  /** Brand code of the player */
  brand: Scalars['String']['output'];
  /** Player's contribution to the pot */
  contributionValue: Scalars['Float']['output'];
  /** Player's expected prize */
  expectedPrize: Scalars['Float']['output'];
  /** Player ID */
  playerId: Scalars['String']['output'];
  /** Player initials */
  playerInitials: Scalars['String']['output'];
};

/** A jackpot opt-in history entry */
export type DinoOptInHistoryEntry = {
  __typename: 'DinoOptInHistoryEntry';
  /** Brand code */
  brand: Scalars['String']['output'];
  /** Who performed the opt-in/opt-out */
  initiator: Initiator;
  /** Whether the player is opted in */
  optedIn: Scalars['Boolean']['output'];
  /** Player ID */
  playerId: Scalars['String']['output'];
  /** Timestamp of the event in millis */
  processedAt: Scalars['Long']['output'];
};

/** A connection to a list of items. */
export type DinoOptInHistoryEntryConnection = {
  __typename: 'DinoOptInHistoryEntryConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<DinoOptInHistoryEntryEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DinoOptInHistoryEntryEdge = {
  __typename: 'DinoOptInHistoryEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DinoOptInHistoryEntry;
};

/** A document uploaded by the player. */
export type Document = Node & {
  __typename: 'Document';
  deletedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  deletedBy: Maybe<Initiator>;
  documentType: Maybe<DocumentType>;
  expirationDate: Maybe<Scalars['String']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  player: Maybe<Player>;
  status: Maybe<DocumentStatus>;
  uploadedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  uploadedBy: Maybe<Initiator>;
  uuid: Scalars['String']['output'];
  verificationTypes: Array<DocumentVerificationType>;
  verifiedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  verifiedBy: Maybe<Initiator>;
};

/** A connection to a list of items. */
export type DocumentConnection = {
  __typename: 'DocumentConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<DocumentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DocumentEdge = {
  __typename: 'DocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Document;
};

/** DocumentResponse */
export type DocumentResponse = Node & {
  __typename: 'DocumentResponse';
  document: Document;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  origin: origin;
};

/** A connection to a list of items. */
export type DocumentResponseConnection = {
  __typename: 'DocumentResponseConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<DocumentResponseEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DocumentResponseEdge = {
  __typename: 'DocumentResponseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: DocumentResponse;
};

/** The order to list documents results. */
export enum DocumentSearchOrder {
  deletedAt = 'deletedAt',
  expirationDate = 'expirationDate',
  uploadedAt = 'uploadedAt',
  verifiedAt = 'verifiedAt'
}

/** The status of a document. */
export enum DocumentStatus {
  Deleted = 'Deleted',
  NotUploaded = 'NotUploaded',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Verified = 'Verified'
}

/** Type of document */
export enum DocumentType {
  BankStatement = 'BankStatement',
  CreditCard = 'CreditCard',
  DividendsSOW = 'DividendsSOW',
  DrivingLicense = 'DrivingLicense',
  ID = 'ID',
  InheritanceSOW = 'InheritanceSOW',
  Other = 'Other',
  Passport = 'Passport',
  SalarySOW = 'SalarySOW',
  SaleOfCompanySOW = 'SaleOfCompanySOW',
  SaleOfPropertySOW = 'SaleOfPropertySOW',
  SourceOfWealth = 'SourceOfWealth',
  UtilityBill = 'UtilityBill'
}

/** Document verification type */
export enum DocumentVerificationType {
  Address = 'Address',
  Age = 'Age',
  Email = 'Email',
  Identity = 'Identity',
  PhoneNumber = 'PhoneNumber',
  SourceOfWealth = 'SourceOfWealth'
}

export type DynamicAmount = {
  __typename: 'DynamicAmount';
  maxDepositAmount: Scalars['Int']['output'];
  maxRewardAmount: Scalars['Int']['output'];
  multiplier: Scalars['Float']['output'];
};

/** Dynamic Bonus Money drop challenge reward type */
export type DynamicBonusMoneyDropChallengeReward = ChallengeRewardType & {
  __typename: 'DynamicBonusMoneyDropChallengeReward';
  currency: Scalars['String']['output'];
  maxAmount: Scalars['BigDecimal']['output'];
  maxPayout: Scalars['BigDecimal']['output'];
  /** If defined, overrides maxPayout. Multiplier used to calculate max payout based on the amount given in future */
  maxPayoutMultiplier: Maybe<Scalars['BigDecimal']['output']>;
  multiplier: Scalars['BigDecimal']['output'];
  name: Scalars['String']['output'];
  wageringRequirementFactor: Scalars['Int']['output'];
};

export type DynamicDepositAmount = {
  __typename: 'DynamicDepositAmount';
  maxDepositAmount: Scalars['Int']['output'];
  maxRewardAmount: Scalars['Int']['output'];
  minRewardAmount: Scalars['Int']['output'];
  multiplier: Scalars['Float']['output'];
};

/** Dynamic Free spins challenge reward type */
export type DynamicFreeSpinChallengeReward = ChallengeRewardType & {
  __typename: 'DynamicFreeSpinChallengeReward';
  betLevel: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  /** @deprecated use gameDescriptorV2 instead */
  gameDescriptor: Maybe<GameDescriptorOrError>;
  maxFreeSpinsAmount: Scalars['Int']['output'];
  multiplier: Scalars['BigDecimal']['output'];
  name: Scalars['String']['output'];
  value: Scalars['Long']['output'];
};

/** Dynamic Money drop challenge reward type */
export type DynamicMoneyDropChallengeReward = ChallengeRewardType & {
  __typename: 'DynamicMoneyDropChallengeReward';
  currency: Scalars['String']['output'];
  maxAmount: Scalars['BigDecimal']['output'];
  multiplier: Scalars['BigDecimal']['output'];
  name: Scalars['String']['output'];
};

/** Criteria which let a player see and take part on a challenge */
export enum EligibilityCriteria {
  PendingSoW = 'PendingSoW'
}

/** Information regarding the player's email */
export type EmailInfo = {
  __typename: 'EmailInfo';
  email: Maybe<Scalars['String']['output']>;
  isEmailMarketingAccepted: Maybe<Scalars['Boolean']['output']>;
  isEmailVerified: Maybe<Scalars['Boolean']['output']>;
};

/** An entity with statistics. */
export type EntityWithStatistics = {
  /** Statistics. */
  stats: Maybe<StatsType>;
};


/** An entity with statistics. */
export type EntityWithStatisticsstatsArgs = {
  dataSourceVersion?: InputMaybe<DataSourceVersionEnum>;
  exchangeRateBaseCurrency?: InputMaybe<Scalars['String']['input']>;
  exchangeRateDate?: InputMaybe<Scalars['LocalDate']['input']>;
  from: Scalars['OffsetDateTime']['input'];
  granularity: GranularityEnum;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ColumnOrderSpecType>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['OffsetDateTime']['input'];
};

/** The value in euros */
export type EuroQuote = {
  __typename: 'EuroQuote';
  /** The amount in euros */
  amount: Scalars['BigDecimal']['output'];
  /** The exchange rate */
  exchangeRate: ExchangeRate;
};

/** The type of event in the risk history */
export enum EventType {
  ManualRiskCalculation = 'ManualRiskCalculation',
  ReviewApproved = 'ReviewApproved',
  ReviewNeeded = 'ReviewNeeded',
  ReviewNotNeeded = 'ReviewNotNeeded',
  ReviewPending = 'ReviewPending',
  ReviewRejected = 'ReviewRejected',
  RiskLevelOverridden = 'RiskLevelOverridden',
  RiskLevelOverrideRemoved = 'RiskLevelOverrideRemoved',
  RiskUpdated = 'RiskUpdated'
}

/** Exchange rate used */
export type ExchangeRate = {
  __typename: 'ExchangeRate';
  /** The id of the pricing service for this exchange rate */
  id: Scalars['String']['output'];
  /** The market price, without fee */
  marketPrice: Scalars['BigDecimal']['output'];
};

/** A fee */
export type Fee = {
  __typename: 'Fee';
  euroQuote: EuroQuote;
  money: Money;
};

/** Match Decision */
export enum FilteringMatchDecision {
  /**
   * Indicates that the given profile no longer matches the monitor record due to
   * the changes in the profile, monitor record, or the worklist. It's a possible
   * income from Acuris
   */
  Discarded = 'Discarded',
  FalsePositive = 'FalsePositive',
  Pending = 'Pending',
  TrueMatch = 'TrueMatch'
}

/** The final/overall risk level has changed */
export type FinalRiskLevelUpdated = Outcome & {
  __typename: 'FinalRiskLevelUpdated';
  /** The name of the outcome */
  name: Scalars['String']['output'];
  /** The final risk level after this event took place */
  riskLevel: RiskLevel;
  /** The final risk level before this event took place */
  riskLevelBefore: RiskLevel;
};

/** Free spins challenge reward type */
export type FreeSpinChallengeReward = ChallengeRewardType & {
  __typename: 'FreeSpinChallengeReward';
  amount: Scalars['Int']['output'];
  betLevel: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  /** @deprecated use gameDescriptorV2 instead */
  gameDescriptor: Maybe<GameDescriptorOrError>;
  name: Scalars['String']['output'];
  value: Scalars['Long']['output'];
};

/** Free spins reward type */
export type FreeSpinReward = RewardType & {
  __typename: 'FreeSpinReward';
  amount: Scalars['Int']['output'];
  betLevel: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  /** @deprecated use gameDescriptorV2 instead */
  gameDescriptor: Maybe<GameDescriptor>;
  /** @deprecated use gameDescriptorV2 instead */
  gameDescriptorV2: Maybe<GameDescriptorOrError>;
  name: Scalars['String']['output'];
  value: Scalars['Long']['output'];
};

/** Reward profile of type Freespins */
export type FreespinsRewardProfile = {
  __typename: 'FreespinsRewardProfile';
  /** Optional affiliate ID for this specific template */
  affiliateId: Maybe<Scalars['String']['output']>;
  /** Number of days to claim the reward */
  claimDays: Scalars['Int']['output'];
  /** Optional countries for this specific template */
  countries: Array<Scalars['ISOCountryCode']['output']>;
  /** Max awarded amount depending on amount deposited: maxDepositAmount * multiplier = maxRewardAmount */
  dynamicAmount: Maybe<DynamicAmount>;
  gameId: Scalars['String']['output'];
  gameProvider: GameProvider;
  /** Free Spin value multiplier */
  paylines: Scalars['Int']['output'];
  /** Type of reward: Freespins, Bonus, or Money */
  rewardType: Scalars['String']['output'];
  /** Spread free spins over this many days (50 over 5 days = 10 per day) */
  spreadOverDays: Scalars['Int']['output'];
  /** Default value in case dynamicAmount is not provided */
  staticAmount: Scalars['Int']['output'];
  /** Value of each free spin in cents in the player's currency */
  valueCents: Scalars['Int']['output'];
};

/** Represents a freespins reward template */
export type FreespinsTemplate = {
  __typename: 'FreespinsTemplate';
  /** Optional affiliate ID, can also be defined at offer level */
  affiliateId: Maybe<Scalars['String']['output']>;
  /** Can be empty and defined at offer level */
  countries: Array<Scalars['ISOCountryCode']['output']>;
  currency: Scalars['ISOCurrencyCode']['output'];
  /** Max awarded amount depending on amount deposited: maxDepositAmount * multiplier = maxRewardAmount */
  dynamicAmount: Maybe<DynamicDepositAmount>;
  gameId: Scalars['String']['output'];
  gameProvider: GameProvider;
  id: Scalars['String']['output'];
  /** Free Spin value multiplier */
  payLines: Scalars['Int']['output'];
  /** Spread free spins over this many days (50 over 5 days = 10 per day) */
  spreadOverDays: Scalars['Int']['output'];
  /** Default value in case dynamicAmount is not provided */
  staticAmount: Scalars['Int']['output'];
  /** Value of each free spin in cents in the currency provided */
  valueCents: Scalars['Int']['output'];
};

/** SoW history entry for funding document requested */
export type FundingDocumentsRequestedItem = PlayerComplianceHistorySearchItem & {
  __typename: 'FundingDocumentsRequestedItem';
  eventType: Scalars['String']['output'];
  /** @deprecated Use initiatorV2 */
  initiator: Initiator;
  initiatorV2: Maybe<Initiator>;
  playerGlobalId: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  playerUUID: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  requestedFundingDocuments: Array<FundingOption>;
  requestedRequiredDocumentsWithComments: Array<RequestedFundingDocument>;
  uuid: Scalars['String']['output'];
};

export enum FundingOption {
  Dividends = 'Dividends',
  Inheritance = 'Inheritance',
  Other = 'Other',
  Salary = 'Salary',
  SaleOfCompany = 'SaleOfCompany',
  SaleOfProperty = 'SaleOfProperty'
}

/** Gamanza gamification details */
export type GamanzaGamification = {
  __typename: 'GamanzaGamification';
  factor: Scalars['Float']['output'];
  limitMultiplier: Scalars['Float']['output'];
  nextFactor: Maybe<Scalars['Float']['output']>;
  nextLimitMultiplier: Maybe<Scalars['Float']['output']>;
  nextRank: Maybe<Scalars['String']['output']>;
  rank: Maybe<Scalars['String']['output']>;
};

export type Game = {
  __typename: 'Game';
  desktopGameId: Scalars['String']['output'];
  gameProvider: GameProvider;
  mobileGameId: Scalars['String']['output'];
};

/** Game */
export type GameArg = {
  desktopGameId: Scalars['String']['input'];
  gameProvider: GameProvider;
  mobileGameId: Scalars['String']['input'];
};

/** A game descriptor fetched from the CMS. */
export type GameDescriptor = {
  __typename: 'GameDescriptor';
  json: Scalars['Json']['output'];
  url: Scalars['String']['output'];
};

/** An error detail from the game descriptor fetching process from the CMS. */
export type GameDescriptorFetchError = {
  __typename: 'GameDescriptorFetchError';
  error: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** A game descriptor fetched from the CMS or an error from the fetching process */
export type GameDescriptorOrError = GameDescriptorFetchError | GameDescriptorV2;

/** A game descriptor fetched from the CMS. */
export type GameDescriptorV2 = {
  __typename: 'GameDescriptorV2';
  json: Scalars['Json']['output'];
  url: Scalars['String']['output'];
};

/** Name of game provider. */
export enum GameProvider {
  Aleaplay = 'Aleaplay',
  Authentic = 'Authentic',
  Betby = 'Betby',
  Betsoft = 'Betsoft',
  Booming = 'Booming',
  Delasport = 'Delasport',
  DinoJackpot = 'DinoJackpot',
  Elk = 'Elk',
  Endorphina = 'Endorphina',
  Everymatrix = 'Everymatrix',
  Evolution = 'Evolution',
  Ezugi = 'Ezugi',
  Fizzybubbly = 'Fizzybubbly',
  Gaming1x2 = 'Gaming1x2',
  Gator = 'Gator',
  Hub88 = 'Hub88',
  ISoftBet = 'ISoftBet',
  Microgaming = 'Microgaming',
  Netent = 'Netent',
  Nolimit = 'Nolimit',
  Pariplay = 'Pariplay',
  PlayNGo = 'PlayNGo',
  Playtech = 'Playtech',
  Pragmatic = 'Pragmatic',
  Quickspin = 'Quickspin',
  Rebeltech = 'Rebeltech',
  Reevo = 'Reevo',
  Relax = 'Relax',
  Rival = 'Rival',
  Scientific = 'Scientific',
  Swintt = 'Swintt',
  Thrilltech = 'Thrilltech',
  Thunderkick = 'Thunderkick',
  Wazdan = 'Wazdan',
  Yggdrasil = 'Yggdrasil'
}

/** A summarized game round. */
export type GameRoundItem = {
  __typename: 'GameRoundItem';
  /** The amount of the bonus bet */
  bonusBetAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** The amount of the bonus wins */
  bonusWinAmount: Maybe<Scalars['BigDecimal']['output']>;
  brand: Brand;
  closingBalance: Maybe<Scalars['PositiveBigDecimal']['output']>;
  /** The closing bonus balance for the transaction */
  closingBonusBalance: Maybe<Scalars['BigDecimal']['output']>;
  completedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  currency: Scalars['String']['output'];
  /** @deprecated use gameDescriptorV2 instead */
  gameDescriptor: Maybe<GameDescriptor>;
  gameDescriptorV2: Maybe<GameDescriptorOrError>;
  gameId: Scalars['String']['output'];
  gameProvider: Scalars['String']['output'];
  gameRoundId: Scalars['String']['output'];
  lastProcessedAt: Scalars['OffsetDateTime']['output'];
  openingBalance: Scalars['BigDecimal']['output'];
  /** The opening balance for the bonus transaction */
  openingBonusBalance: Maybe<Scalars['BigDecimal']['output']>;
  playerId: Scalars['ID']['output'];
  rawPlayerId: Scalars['String']['output'];
  startedAt: Scalars['OffsetDateTime']['output'];
  status: GameRoundStatus;
  totalBets: Scalars['BigDecimal']['output'];
  totalJackpotContribution: Scalars['BigDecimal']['output'];
  totalJackpotPayout: Scalars['BigDecimal']['output'];
  totalWins: Scalars['BigDecimal']['output'];
};

/** A connection to a list of items. */
export type GameRoundItemConnection = {
  __typename: 'GameRoundItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<GameRoundItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type GameRoundItemEdge = {
  __typename: 'GameRoundItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: GameRoundItem;
};

/** The order to list game rounds. */
export enum GameRoundSearchOrder {
  brand = 'brand',
  closingBalance = 'closingBalance',
  completedAt = 'completedAt',
  currency = 'currency',
  gameId = 'gameId',
  gameProvider = 'gameProvider',
  gameRoundId = 'gameRoundId',
  lastProcessedAt = 'lastProcessedAt',
  playerId = 'playerId',
  playerSessionId = 'playerSessionId'
}

/** The status of a game round. */
export enum GameRoundStatus {
  Loss = 'Loss',
  Pending = 'Pending',
  Win = 'Win'
}

/** Data about a gameplay rate conversions */
export type GameplayConversionData = {
  __typename: 'GameplayConversionData';
  /** The id of the conversion */
  conversionId: Scalars['String']['output'];
  /** The hedge fund used percentage */
  hedgeFundPercent: Scalars['BigDecimal']['output'];
  /** The hedge fund price */
  hedgeFundPrice: Scalars['BigDecimal']['output'];
  /** The amount shown in-game */
  inGameAmount: Scalars['BigDecimal']['output'];
  /** The currency shown in-game */
  inGameCurrency: Scalars['String']['output'];
  /** The market price */
  marketPrice: Scalars['BigDecimal']['output'];
  /** The total wallet amount of the transaction */
  walletAmount: Scalars['BigDecimal']['output'];
  /** Current wallet currency */
  walletCurrency: Scalars['String']['output'];
  /** Part of the wallet amount assigned to the hedge fund */
  walletHedgeFundAmount: Scalars['BigDecimal']['output'];
};

/** Gamification details for 3 separate systems: Gamanza, Smartico and NoGamification */
export type GamificationDetailsType = GamanzaGamification | NoGamificationSystem | SmarticoGamification;

/** Url for uploading a document document */
export type GenerateBulkDocument = {
  __typename: 'GenerateBulkDocument';
  /** The document id to upload the document into */
  documentId: Scalars['String']['output'];
  /** Url to upload a cashback document */
  url: Scalars['String']['output'];
};

/** Geolocation block status of a player */
export type GeoLocationBlockStatus = {
  __typename: 'GeoLocationBlockStatus';
  state: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** Geolocation state-axis status of a player */
export type GeoLocationStateStatus = {
  __typename: 'GeoLocationStateStatus';
  state: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** Geolocation VPN-axis status of a player */
export type GeoLocationVpnStatus = {
  __typename: 'GeoLocationVpnStatus';
  status: Scalars['String']['output'];
};

/** Url for uploading a document document */
export type GetDocumentUploadUrl = {
  __typename: 'GetDocumentUploadUrl';
  /** The document id to upload the document into */
  documentId: Scalars['ID']['output'];
  /** Url of the document */
  url: Scalars['String']['output'];
};

export type GetKrofortWhitelistResponse = {
  __typename: 'GetKrofortWhitelistResponse';
  playerIds: Array<Scalars['String']['output']>;
};

/** Get kyc request count */
export type GetKycRequestCountRequest = {
  __typename: 'GetKycRequestCountRequest';
  count: Scalars['PositiveInt']['output'];
};

export type GetWhitelistResponse = {
  __typename: 'GetWhitelistResponse';
  playerIds: Array<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type GlobalLimitSearchItemConnection = {
  __typename: 'GlobalLimitSearchItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<GlobalLimitSearchItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type GlobalLimitSearchItemEdge = {
  __typename: 'GlobalLimitSearchItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LimitSearchItem;
};

/** Global login attempts info */
export type GlobalLoginAttemptsInfo = {
  __typename: 'GlobalLoginAttemptsInfo';
  /** Number of allowed invalid login attempts before player is locked from logging in */
  invalidGlobalLoginAttemptsAllowed: Scalars['Int']['output'];
  /** Timestamp when player was locked due to too many invalid login attempts */
  maxGlobalLoginAttemptsReachedAt: Maybe<Scalars['OffsetDateTime']['output']>;
};

/** GlobalOrigin */
export type GlobalOrigin = Node & {
  __typename: 'GlobalOrigin';
  code: Scalars['String']['output'];
  /** The id of the object. */
  id: Scalars['ID']['output'];
};

/** A global player. */
export type GlobalPlayer = EntityWithStatistics & Node & {
  __typename: 'GlobalPlayer';
  /** Compliance related limits for the player across all brands */
  complianceGlobalPlayerLimits: Array<ComplianceGlobalPlayerLimit>;
  /** The customer which this player belongs to */
  customer: Customer;
  /** Get the list of games banned for the global player */
  gamesBanned: Array<Game>;
  /** Checks a global player block status for gamification with Gamanza */
  getGamanzaGlobalPlayerBlockStatus: PlayerGamificationBlockStatus;
  globalDocuments: DocumentResponseConnection;
  globalNotes: NoteResponseConnection;
  globalPayments: PaymentConnection;
  globalWallet: Maybe<GlobalWallet>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  /**
   * Checks if a global player is blocked or not for gamification with Gamanza
   * @deprecated Use getGamanzaPlayerBlockStatus instead
   */
  isGlobalPlayerBlockedInGamanza: Scalars['Boolean']['output'];
  kycMasterPlayer: Maybe<Player>;
  playerComplianceDetails: Maybe<PlayerCompliance>;
  playerComplianceDetailsV2: Maybe<PlayerComplianceV2>;
  playerComplianceDetailsV3: Maybe<PlayerComplianceV3>;
  playerGlobalUUID: Scalars['String']['output'];
  players: Array<Player>;
  providedSourceOfFunds: BoSourceOfFundsType;
  /** The RG customer risk assessment for the player */
  rgCraCustomerRiskAssessment: Maybe<RgCraCustomerRiskAssessment>;
  /** The RG customer risk assessment for the player */
  rgCraV2CustomerRiskAssessment: Maybe<RgCraV2GamingCustomerRiskAssessment>;
  sourceOfWealth: Maybe<SourceOfWealth>;
  sowBlockedStatus: Maybe<SowBlockedStatus>;
  /** Statistics. */
  stats: Maybe<StatsType>;
};


/** A global player. */
export type GlobalPlayerglobalDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DocumentSearchOrder>;
};


/** A global player. */
export type GlobalPlayerglobalNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<NoteCategoryEnum>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PlayerNoteSearchOrder>>;
  priority?: InputMaybe<PriorityEnum>;
};


/** A global player. */
export type GlobalPlayerglobalPaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<BrandEnum>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  indexPrefix?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PaymentSearchOrder>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  paymentType?: InputMaybe<PaymentType>;
  rawId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


/** A global player. */
export type GlobalPlayerstatsArgs = {
  dataSourceVersion?: InputMaybe<DataSourceVersionEnum>;
  exchangeRateBaseCurrency?: InputMaybe<Scalars['String']['input']>;
  exchangeRateDate?: InputMaybe<Scalars['LocalDate']['input']>;
  from: Scalars['OffsetDateTime']['input'];
  granularity: GranularityEnum;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ColumnOrderSpecType>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['OffsetDateTime']['input'];
};

/** A global wallet. */
export type GlobalWallet = {
  __typename: 'GlobalWallet';
  /** Amount of global balance. */
  balance: Scalars['BigDecimal']['output'];
  /** The ID of an object */
  id: Scalars['ID']['output'];
  playerGlobalUUID: Scalars['String']['output'];
  /** Amount of global reserved balance. */
  reservedBalance: Scalars['BigDecimal']['output'];
  /** player wallets summary info */
  wallets: Array<PlayerWalletType>;
};

/** Granularity level for stats reports */
export enum GranularityEnum {
  All = 'All',
  Day = 'Day',
  Hour = 'Hour',
  Minute = 'Minute',
  Month = 'Month',
  Quarter = 'Quarter',
  Second = 'Second',
  Week = 'Week',
  Year = 'Year'
}

/** Hampi check result type */
export type HampiCheckResult = {
  __typename: 'HampiCheckResult';
  restrictions: Array<Restriction>;
};

/** A bo agent identity */
export type Identity = {
  __typename: 'Identity';
  brands: Array<BrandEnum>;
  orgs: Array<OrgEnum>;
  roles: Array<AgentRoleEnum>;
};

/** A bo agent identity */
export type IdentityV2 = {
  __typename: 'IdentityV2';
  agent: Maybe<Agent>;
  agentId: Scalars['String']['output'];
  brands: Array<BrandEnum>;
  orgs: Array<OrgEnum>;
  roles: Array<AgentRoleEnum>;
};

/** The player or agent responsible for performing a specific action. */
export type Initiator = AgentInitiator | PlayerInitiator;

/** The initiator type. */
export enum InitiatorTypeEnum {
  Agent = 'Agent',
  Player = 'Player'
}

/**
 * If exists, the block is set. If activeFrom is not set, the block is active. If
 * activeFrom is set, but we have not passed the timestamp, the block is pending.
 */
export type InstantBankingBlock = {
  __typename: 'InstantBankingBlock';
  activeFrom: Maybe<Scalars['OffsetDateTime']['output']>;
};

/** KYC6 Aggregated Matches */
export type KYC6AggregatedMatches = {
  __typename: 'KYC6AggregatedMatches';
  /** Timestamp when the report was last searched */
  lastSearchedAt: Scalars['OffsetDateTime']['output'];
  /** Max Score */
  maxScore: Scalars['Int']['output'];
  /** Pep Tier */
  pepTier: Maybe<PepTier>;
  /** Player Global Id */
  playerGlobalId: Scalars['ID']['output'];
  /** Player Global UUID */
  playerGlobalUUID: Scalars['String']['output'];
  /** Player Id Per Brand */
  playerIdPerBrand: Array<PlayerIdPerBrand>;
  /** Review Status */
  reviewStatus: KYC6ReviewStatus;
  /** Type of Match */
  typeOfMatch: Array<KYC6MatchTypes>;
};

/** KYC6 Match */
export type KYC6Match = {
  __typename: 'KYC6Match';
  /** Brand */
  brand: Brand;
  /** Last Searched At */
  lastSearchedAt: Scalars['OffsetDateTime']['output'];
  /** Match Decision */
  matchDecision: Maybe<FilteringMatchDecision>;
  /** Pep Tier */
  pepTier: Maybe<PepTier>;
  /** Player Id */
  playerId: Scalars['ID']['output'];
  /** Player UUID */
  playerUUID: Scalars['String']['output'];
  /** Resource Id */
  resourceId: Scalars['String']['output'];
  /** Score */
  score: Scalars['Int']['output'];
  /** Type of Match */
  typeOfMatch: Array<KYC6MatchTypes>;
  /** Version */
  version: Maybe<Scalars['Long']['output']>;
};

/** The URL where the KYC6 report can be found */
export type KYC6MatchReport = {
  __typename: 'KYC6MatchReport';
  url: Scalars['String']['output'];
};

/** KYC6 Match Types */
export enum KYC6MatchTypes {
  PEP = 'PEP',
  REL = 'REL',
  RRE = 'RRE',
  SAN = 'SAN'
}

/** The order to list KYC6 matches. */
export enum KYC6MatchesOrderBy {
  LastSearchedAt = 'LastSearchedAt',
  PepTier = 'PepTier',
  Score = 'Score'
}

/** KYC6 Review Status */
export enum KYC6ReviewStatus {
  InProgress = 'InProgress',
  NotReviewed = 'NotReviewed',
  Reviewed = 'Reviewed'
}

/** Krofort Kyc Request Status. */
export enum KrofortKycRequestStatus {
  KYC_REQUEST_STATUS_CREATE_KYC_FAILED = 'KYC_REQUEST_STATUS_CREATE_KYC_FAILED',
  KYC_REQUEST_STATUS_GET_KYC_FAILED = 'KYC_REQUEST_STATUS_GET_KYC_FAILED',
  KYC_REQUEST_STATUS_GOT_KYC = 'KYC_REQUEST_STATUS_GOT_KYC',
  KYC_REQUEST_STATUS_KYC_CREATED = 'KYC_REQUEST_STATUS_KYC_CREATED',
  KYC_REQUEST_STATUS_KYC_CREATED_NOT_FOUND = 'KYC_REQUEST_STATUS_KYC_CREATED_NOT_FOUND'
}

export enum KrofortPayoutStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Created = 'Created',
  Failed = 'Failed',
  InProgress = 'InProgress',
  Rejected = 'Rejected'
}

/** A connection to a list of items. */
export type Kyc6MatchItemConnection = {
  __typename: 'Kyc6MatchItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<Kyc6MatchItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Kyc6MatchItemEdge = {
  __typename: 'Kyc6MatchItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: KYC6Match;
};

/** Declares kyc check deadline, and the missing verifications if kyc check is not done */
export type KycCheckStatus = {
  __typename: 'KycCheckStatus';
  /** Time at which the player wont be able to play or interact */
  deadline: Maybe<Scalars['OffsetDateTime']['output']>;
  /** Pending KYC flow for the missing verifications */
  kycFlow: Maybe<KycFlow>;
  /** KYC flows started by the player. */
  kycFlows: Array<KycFlow>;
  /**
   * Status of the KYC check
   * @deprecated Use statusV2 instead
   */
  status: Scalars['String']['output'];
  /** Status of the KYC check */
  statusV2: KycCheckStatusStatusType;
  /** The id of the player who did the last KYC flow. */
  sumSubEndUserId: Maybe<Scalars['String']['output']>;
  /** KYC verifications done for the player */
  verificationsDone: Array<VerificationTypeEnum>;
  /** KYC verifications missing for the player */
  verificationsMissing: Array<VerificationTypeEnum>;
};

/** KycCheckStatus.status */
export enum KycCheckStatusStatusType {
  Done = 'Done',
  NotNeed = 'NotNeed',
  Pending = 'Pending',
  Required = 'Required',
  WillBeRequired = 'WillBeRequired'
}

/** Give information about a specific KYC Flow */
export type KycFlow = {
  __typename: 'KycFlow';
  failureReason: Maybe<Scalars['String']['output']>;
  /** The id of the KYC Flow */
  flowId: Scalars['String']['output'];
  /** Time at which the player wont be able to play or interact */
  initializedAt: Scalars['OffsetDateTime']['output'];
  kycProvider: kycProvider;
  /** The id of the player who initiate the KYC Flow */
  playerId: Maybe<Scalars['String']['output']>;
  status: KycVerificationType;
  verifications: Array<VerificationTypeEnum>;
  verificationsApproved: Array<VerificationTypeEnum>;
  verificationsRejected: Array<VerificationTypeEnum>;
};

/** Kyc Provider */
export enum KycProviderType {
  Brite = 'Brite',
  BullPay = 'BullPay',
  Dino = 'Dino',
  Eniro = 'Eniro',
  Finshark = 'Finshark',
  Infinipi = 'Infinipi',
  Krofort = 'Krofort',
  Kyc6 = 'Kyc6',
  Sofort = 'Sofort',
  SumSub = 'SumSub',
  Trustly = 'Trustly',
  Zimpler = 'Zimpler'
}

/** KYC Flow verification type */
export enum KycVerificationType {
  Failed = 'Failed',
  Initialized = 'Initialized',
  Pending = 'Pending',
  Succeed = 'Succeed'
}

/** Limit. */
export type Limit = {
  __typename: 'Limit';
  /** Limits are blocked to be modified. */
  blockingStatus: Maybe<BlockingLimit>;
  /** Day limit if one is set. */
  dayLimit: Maybe<PeriodLimit>;
  /** Month limit if one is set. */
  monthLimit: Maybe<PeriodLimit>;
  /** Week limit if one is set. */
  weekLimit: Maybe<PeriodLimit>;
};

/** Limit changes count report */
export type LimitChangesCountReport = {
  __typename: 'LimitChangesCountReport';
  url: Scalars['String']['output'];
};

/** A limit search item. */
export type LimitSearchItem = {
  __typename: 'LimitSearchItem';
  availableAt: Maybe<Scalars['OffsetDateTime']['output']>;
  confirmedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  limitStatus: Maybe<Scalars['String']['output']>;
  limitType: Maybe<Scalars['String']['output']>;
  /** New value. */
  newValue: Maybe<Scalars['BigDecimal']['output']>;
  period: Maybe<Scalars['String']['output']>;
  playerId: Scalars['ID']['output'];
  /** Previous value. */
  prevValue: Maybe<Scalars['BigDecimal']['output']>;
  requestedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  requestedBy: Maybe<Initiator>;
  uuid: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type LimitSearchItemConnection = {
  __typename: 'LimitSearchItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<LimitSearchItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LimitSearchItemEdge = {
  __typename: 'LimitSearchItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: LimitSearchItem;
};

/** The order to list limit search results. */
export enum LimitSearchOrder {
  requestedAt = 'requestedAt'
}

/** Status of the limit. */
export enum LimitStatusEnum {
  LimitRemoved = 'LimitRemoved',
  LimitSet = 'LimitSet',
  PendingLimitCancelled = 'PendingLimitCancelled',
  PendingLimitSet = 'PendingLimitSet',
  PendingRemovalCancelled = 'PendingRemovalCancelled'
}

/** Type of limit. */
export enum LimitType {
  Deposit = 'Deposit',
  Loss = 'Loss',
  Session = 'Session',
  Wager = 'Wager',
  Withdraw = 'Withdraw'
}

/** The limit period type. */
export enum LimitTypeEnum {
  Day = 'Day',
  Month = 'Month',
  Week = 'Week'
}

/** Player's linked accounts */
export type LinkedAccounts = {
  __typename: 'LinkedAccounts';
  addressLine: Maybe<Scalars['String']['output']>;
  birthDate: Maybe<Scalars['String']['output']>;
  brand: Maybe<Brand>;
  city: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  numberOfLinks: Scalars['Int']['output'];
  playerId: Scalars['ID']['output'];
  rawPlayerId: Scalars['String']['output'];
  status: Scalars['String']['output'];
  triggerTypes: Array<Scalars['String']['output']>;
  zipCode: Maybe<Scalars['String']['output']>;
};

/** Information about a player's last login */
export type LoginInfo = {
  __typename: 'LoginInfo';
  lastLoginAt: Maybe<Scalars['OffsetDateTime']['output']>;
  lastLoginIp: Maybe<Scalars['String']['output']>;
  lastLoginIpCountryCode: Maybe<Scalars['String']['output']>;
};

/** Long running players export details. */
export type LongRunningPlayerExportDetails = {
  __typename: 'LongRunningPlayerExportDetails';
  /** The name of the file where the report can be found after it's finished. */
  fileName: Scalars['String']['output'];
};

/** Manual decision for a failed reward type */
export enum ManualDecisionType {
  manualCredited = 'manualCredited',
  removeReward = 'removeReward'
}

/**
 * The players marketing preferences, containing the acceptance status of each
 * individual marketing type and if these can be changed by the user
 */
export type MarketingPreferences = {
  __typename: 'MarketingPreferences';
  emailMarketingAccepted: Maybe<Scalars['Boolean']['output']>;
  marketingBlocked: Scalars['Boolean']['output'];
  phoneMarketingAccepted: Maybe<Scalars['Boolean']['output']>;
  smsMarketingAccepted: Maybe<Scalars['Boolean']['output']>;
  webPushMarketingAccepted: Maybe<Scalars['Boolean']['output']>;
};

/** Match Decision */
export enum MatchDecision {
  FalsePositive = 'FalsePositive',
  Pending = 'Pending',
  TrueMatch = 'TrueMatch'
}

/** Amount and currency */
export type Money = {
  __typename: 'Money';
  /** The amount */
  amount: Scalars['BigDecimal']['output'];
  /** The currency code */
  currency: Scalars['ISOCurrencyCode']['output'];
};

/** Money Adjustment */
export type MoneyAdjustedType = {
  __typename: 'MoneyAdjustedType';
  amount: Scalars['BigDecimal']['output'];
  brand: Maybe<Brand>;
  closingBalance: Scalars['BigDecimal']['output'];
  comment: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  initiator: Initiator;
  openingBalance: Scalars['BigDecimal']['output'];
  playerId: Scalars['ID']['output'];
  rawTransactionId: Scalars['String']['output'];
  transactionId: Scalars['ID']['output'];
  transactionType: Scalars['String']['output'];
};

/** Money drop challenge reward type */
export type MoneyDropChallengeReward = ChallengeRewardType & {
  __typename: 'MoneyDropChallengeReward';
  amount: Scalars['BigDecimal']['output'];
  currency: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Money drop reward type */
export type MoneyDropReward = RewardType & {
  __typename: 'MoneyDropReward';
  amount: Scalars['BigDecimal']['output'];
  currency: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Reward profile of type Bonus cash reward */
export type MoneyRewardProfile = {
  __typename: 'MoneyRewardProfile';
  /** Optional affiliate ID for this specific template */
  affiliateId: Maybe<Scalars['String']['output']>;
  /** Number of days to claim the reward */
  claimDays: Scalars['Int']['output'];
  /** Optional countries for this specific template */
  countries: Array<Scalars['ISOCountryCode']['output']>;
  /** Max awarded amount depending on amount deposited: maxDepositAmount * multiplier = maxRewardAmount */
  dynamicAmount: Maybe<DynamicAmount>;
  /** Type of reward: Freespins, Bonus, or Money */
  rewardType: Scalars['String']['output'];
  /** Default value in case dynamicAmount is not provided */
  staticAmount: Scalars['Int']['output'];
};

/** Represents a money reward template */
export type MoneyTemplate = {
  __typename: 'MoneyTemplate';
  /** Optional affiliate ID, can also be defined at offer level */
  affiliateId: Maybe<Scalars['String']['output']>;
  /** Can be empty and defined at offer level */
  countries: Array<Scalars['ISOCountryCode']['output']>;
  currency: Scalars['ISOCurrencyCode']['output'];
  /** Max awarded amount depending on amount deposited: maxDepositAmount * multiplier = maxRewardAmount */
  dynamicAmount: Maybe<DynamicDepositAmount>;
  id: Scalars['String']['output'];
  /** Default value in case dynamicAmount is not provided */
  staticAmount: Scalars['Int']['output'];
};

/** Container type for supporting multiple wallets. */
export type MultipleWallets = {
  __typename: 'MultipleWallets';
  /** Active wallet. */
  activeWallet: Wallet;
  availableDisplayCurrencies: Array<Scalars['ISOCurrencyCode']['output']>;
  /** Available wallets. */
  availableWallets: Array<Wallet>;
  /** Information about supported crypto currencies and which networks we are supporting them. */
  cryptoCurrencyNetworkInformation: Array<CryptoCurrencyNetworkInformation>;
  displayCurrency: Scalars['ISOCurrencyCode']['output'];
  /** The ID of an object */
  id: Scalars['ID']['output'];
};

export type Mutation = {
  __typename: 'Mutation';
  activateRewards: Scalars['Boolean']['output'];
  /** Activate a welcome offer */
  activateWelcomeOffer: OfferResult;
  addFraudStatusOverwrite: ScreeningStatuses;
  addGlobalNote: NoteResponse;
  addGlobalNoteV2: NoteResponse;
  addNote: Note;
  addNoteV2: Note;
  addPepStatusOverwrite: ScreeningStatuses;
  /** Add player to whitelist, withdrawal blocks because of suspected abusive deposit history will not apply */
  addPlayerToFinsharkWithdrawalBlockWhitelist: Scalars['Boolean']['output'];
  /** Add player to whitelist, withdrawal blocks because of suspected abusive deposit history will not apply */
  addPlayerToKrofortWithdrawalBlockWhitelist: Scalars['Boolean']['output'];
  addSanctionedStatusOverwrite: ScreeningStatuses;
  adjustReservedBalance: Scalars['String']['output'];
  adjustmentDepositV4: MoneyAdjustedType;
  adjustmentWithdrawalV4: MoneyAdjustedType;
  /**
   * Approve a document
   * @deprecated Use approveDocumentV2 instead
   */
  approveDocument: Document;
  /** Approve a document */
  approveDocumentV2: Document;
  approveFundingDocument: Document;
  approvePendingZimplerWithdrawal: Scalars['String']['output'];
  assignPlayers: Scalars['Boolean']['output'];
  /** Assign a list of players to a challenge */
  assignPlayersToChallenge: Scalars['Boolean']['output'];
  /** Attach a template to a welcome offer */
  attachTemplateToWelcomeOffer: OfferResult;
  banGames: Scalars['Boolean']['output'];
  blockDepositLimit: Wallet;
  blockGeoLocation: Player;
  /** @deprecated Use blockInstantBankingV2 which allows to set a grace period */
  blockInstantBanking: Player;
  blockInstantBankingV2: Player;
  blockSessionLimit: Wallet;
  blockWithdrawals: Player;
  /** Add note to a list of players. Always returning true, search for the report in the AWS S3 bucket */
  bulkAddNote: Scalars['Boolean']['output'];
  /** Add note to a list of player provided in a file. Always returning true, search for the report in the AWS S3 bucket */
  bulkAddNoteFromFile: Scalars['Boolean']['output'];
  bulkAdjustmentDeposit: BulkAdjustmentType;
  bulkBlockInstantBanking: Scalars['String']['output'];
  bulkCreateExcludedPlayers: BulkCreateExcludedPlayersResponse;
  /** Cancel pending Blockclear payouts, returns list of failures for unsuccessful cancellations */
  cancelBlockclearPayouts: CancelBlockclearPayoutsResponse;
  cancelDepositLimitRemoval: Wallet;
  cancelKrofortWithdrawal: Scalars['String']['output'];
  cancelPendingDepositLimit: Wallet;
  cancelPendingGlobalLossLimitByPlayerId: Wallet;
  cancelPendingLossLimit: Wallet;
  cancelPendingSelfExclusionV2: Player;
  cancelPendingSessionLimit: Wallet;
  cancelPendingWagerLimit: Wallet;
  cancelPendingZimplerWithdrawal: Scalars['String']['output'];
  cancelSelfExclusionV3: Player;
  /** Manually cancel an in-flight withdrawal in the wallet. Use with extreme caution. */
  cancelWithdrawal: Scalars['String']['output'];
  changeAddress: Player;
  /** Change a player AML Risk Level */
  changeAmlRiskLevel: PlayerCompliance;
  /** Change a player AML Risk Level */
  changeAmlRiskLevelV2: PlayerComplianceV2;
  changeAssignedSsn: Player;
  changeCampaignId: Maybe<RewardItem>;
  changeEmail: Player;
  changeEmailMarketingSettings: Player;
  changeGlobalPlayerEmailMarketing: GlobalPlayer;
  changeGlobalPlayerMarketingBlock: GlobalPlayer;
  changeGlobalPlayerPhoneMarketing: GlobalPlayer;
  changeGlobalPlayerSmsMarketing: GlobalPlayer;
  changeGlobalPlayerWebPushMarketing: GlobalPlayer;
  changeKycMasterPlayer: GlobalPlayer;
  changeMarketingBlockSettings: Player;
  changeNotePinStatus: Note;
  changePersonalDetails: Player;
  changePhoneMarketingSettings: Player;
  /** @deprecated Use changePhoneNumberV2 which has improved phone number parsing */
  changePhoneNumber: Player;
  changePhoneNumberV2: Player;
  changeProvidedSourceOfFunds: BoSourceOfFundsType;
  changeSmsMarketingSettings: Player;
  changeTranslatedPersonalInfo: TranslatedPersonalInfo;
  changeWebPushMarketingSettings: Player;
  claimFailedRewards: Scalars['Boolean']['output'];
  /** Clears the login throttle long block for the player's last login IP and phone number. */
  clearLoginLongBlock: Scalars['String']['output'];
  /** Clears the login throttle short block for the player's last login IP and phone number. */
  clearLoginShortBlock: Scalars['String']['output'];
  closeGlobalPlayerAccounts: GlobalPlayer;
  /** @deprecated use closePlayerAccountV4 */
  closePlayerAccountV3: Player;
  closePlayerAccountV4: Player;
  closeWageringRequirementCycle: Wallet;
  createBonusCode: BonusCode;
  createBonusMoneyDrop: Scalars['Boolean']['output'];
  createBonusMoneyDropV2: Scalars['Boolean']['output'];
  /** Create a new bonus reward template */
  createBonusTemplate: TemplateResult;
  createDepositChallenge: Scalars['Boolean']['output'];
  createDepositChallengeV2: Scalars['Boolean']['output'];
  createFreeSpins: Scalars['Boolean']['output'];
  createFreeSpinsV2: Scalars['Boolean']['output'];
  /** Create a new freespins reward template */
  createFreespinsTemplate: TemplateResult;
  createMoneyDrop: Scalars['Boolean']['output'];
  /** Create a new money reward template */
  createMoneyTemplate: TemplateResult;
  createPlayerV4: Player;
  createSowChallenge: Scalars['Boolean']['output'];
  createSowChallengeV2: Scalars['Boolean']['output'];
  createSportsbookMoneyDrop: Scalars['Boolean']['output'];
  /** Create a new welcome offer */
  createWelcomeOffer: OfferResult;
  /** Deactivate a welcome offer */
  deactivateWelcomeOffer: OfferResult;
  deleteBonusCode: Scalars['Boolean']['output'];
  /** Delete a document */
  deleteDocument: Document;
  deleteFundingDocument: Document;
  deleteNote: Scalars['Boolean']['output'];
  /** Delete a reward template */
  deleteTemplate: TemplateIdResult;
  /** Detach a template from a welcome offer */
  detachTemplateFromWelcomeOffer: OfferResult;
  /** This method will emit a PlayerRegisteredEvent to link a player to a globalPlayerId */
  forceRegistration: Scalars['Boolean']['output'];
  /** Forfeit bonus for players */
  forfeitBonus: Scalars['Boolean']['output'];
  fundingDocumentUploaded: Document;
  generateBulkDocumentUrl: GenerateBulkDocument;
  generateBulkGetDocumentUrl: GenerateBulkDocument;
  /** Based on documentId, it will provide a signed url to upload the document */
  generateDocumentUrl: GetDocumentUploadUrl;
  /** Generates a report of players with non-settled deposits, return download url */
  generateFinsharkNonSettledDepositsReport: Scalars['String']['output'];
  /** Generates a report with payouts that failed with UnknownPayout in Finshark, returns download url */
  generateFinsharkUnknownPayoutsReport: Scalars['String']['output'];
  generateFundingDocumentDownloadUrl: GetDocumentUploadUrl;
  generateFundingDocumentUploadUrl: GetDocumentUploadUrl;
  /** Based on documentId, it will provide a signed url to retrieve the document */
  generateGetDocumentUrl: GetDocumentUploadUrl;
  /** Generates a report of players with non-settled deposits, return download url */
  generateKrofortNonSettledDepositsReport: Scalars['String']['output'];
  /** Generates a report with payouts that failed with UnknownPayout in Krofort, returns download url */
  generateKrofortUnknownPayoutsReport: Scalars['String']['output'];
  /**
   * Generates the closing-balance report in dino-analytics (streamed to a CSV in
   * S3) and returns a (presigned) URL to download it.
   */
  getClosingBalanceReport: Scalars['String']['output'];
  /** Returns all playerIds on white list */
  getFinsharkWithdrawalBlockWhitelist: GetWhitelistResponse;
  /** Returns all playerIds on white list */
  getKrofortWithdrawalBlockWhitelist: GetKrofortWhitelistResponse;
  invitePlayersToVipBrand: Scalars['String']['output'];
  isPlayerInvitedToVipBrand: Scalars['Boolean']['output'];
  /** Returns true if player is on whitelist, false if not */
  isPlayerOnFinsharkWithdrawalBlockWhitelist: Scalars['Boolean']['output'];
  /** Returns true if player is on whitelist, false if not */
  isPlayerOnKrofortWithdrawalBlockWhitelist: Scalars['Boolean']['output'];
  linkPlayer: Scalars['Boolean']['output'];
  /** Manually completes a deposit criteria of a player in a challenge */
  manualCompleteDepositCriteria: Scalars['Boolean']['output'];
  manualKycCheck: Player;
  manualWithdrawalApproval: PaymentApproval;
  /** Merges game round documents that are missing a gameRoundId */
  mergeGameRounds: Scalars['Boolean']['output'];
  /** Removes phone number from 'oldPlayerId' and assigns it to another player */
  movePhoneNumberBetweenPlayers: Scalars['String']['output'];
  overrideRiskLevel: CustomerRiskAssessment;
  pendingReview: CustomerRiskAssessment;
  processStuckWithdrawals: StuckWithdrawalsReport;
  /**
   * Cancelling stuck withdrawals with a list of transaction ids to be cancelled.
   * The noteContent argument is optional. If not provided some generic note will
   * be used. Please have in mind, that when the transactionId is invalid - it will
   * be fully skipped.
   */
  processStuckWithdrawalsFromList: Scalars['Boolean']['output'];
  /**
   * Decline a document
   * @deprecated Use rejectDocumentV2 instead
   */
  rejectDocument: Document;
  /** Decline a document */
  rejectDocumentV2: Document;
  rejectFundingDocument: Document;
  /** Remove the affiliate parameters from a player. Note it is not removed from MyAffiliates */
  removeAffiliateParameters: Player;
  /** Removes a challenge by id, if it exists. This is a fire and forget process */
  removeChallengeV2: Scalars['Boolean']['output'];
  removeDepositLimit: Wallet;
  /** Removing email suppression's for player. Optimistic request always returning true. */
  removeEmailSuppressions: Player;
  removeFraudStatusOverwrite: ScreeningStatuses;
  removeGlobalLossLimitByPlayerId: Wallet;
  removeLossLimit: Wallet;
  removePepStatusOverwrite: ScreeningStatuses;
  /** Remove player from whitelist, withdrawal blocks because of suspected abusive deposit history apply again */
  removePlayerFromFinsharkWithdrawalBlockWhitelist: Scalars['Boolean']['output'];
  /** Remove player from whitelist, withdrawal blocks because of suspected abusive deposit history apply again */
  removePlayerFromKrofortWithdrawalBlockWhitelist: Scalars['Boolean']['output'];
  removePlayersV2: Scalars['Boolean']['output'];
  removeReward: Scalars['Boolean']['output'];
  removeRiskLevelOverride: CustomerRiskAssessment;
  removeSanctionedStatusOverwrite: ScreeningStatuses;
  /**
   * Removing sendgrid email suppression's for player. Optimistic request always returning true.
   * @deprecated Use removeEmailSuppressions which is agnostic to the provider technology
   */
  removeSendgridEmailSuppressions: Player;
  removeSessionLimit: Wallet;
  removeWagerLimit: Wallet;
  removeWithdrawalLimit: Wallet;
  /**
   * Reopen the customer. This does not open any player accounts. It stops new
   * players for this customer from being automatically blocked on registration.
   */
  reopenCustomer: Customer;
  reopenPlayerAccount: Player;
  requestDocuments: PlayerCompliance;
  requestDocumentsV2: PlayerComplianceV2;
  requestDocumentsV3: PlayerComplianceV3;
  /** Manually request SOW from a player */
  requestSow: Scalars['Boolean']['output'];
  resendVerificationEmail: VerificationEmailSentResponse;
  /**
   * Will reset the amount of invalid login attempts allowed for a player before login is locked
   * @deprecated Use resetGlobalInvalidLoginAttemptsLeftV2 instead
   */
  resetGlobalInvalidLoginAttemptsLeft: Player;
  /** Will reset the amount of invalid login attempts allowed for a player before login is locked in both Player and Keycloak */
  resetGlobalInvalidLoginAttemptsLeftV2: Player;
  resetKycEntityIdAuthMethodEntity: Scalars['String']['output'];
  resolveReward: Scalars['Boolean']['output'];
  retryKrofortKyc: Scalars['String']['output'];
  rgCraExportRiskAssessment: Scalars['String']['output'];
  rgCraIndicatorCommunications: Scalars['Boolean']['output'];
  rgCraOverrideRiskLevel: RgCraCustomerRiskAssessment;
  rgCraPayoutRequest: Scalars['Boolean']['output'];
  rgCraPendingReview: RgCraCustomerRiskAssessment;
  rgCraRemoveRiskLevelOverride: RgCraCustomerRiskAssessment;
  rgCraRewardRequest: Scalars['Boolean']['output'];
  rgCraSubmitReview: RgCraCustomerRiskAssessment;
  rgCraTriggerManualRiskUpdate: Scalars['Boolean']['output'];
  rgCraV2ExportRiskAssessment: Scalars['String']['output'];
  rgCraV2IndicatorCommunications: Scalars['Boolean']['output'];
  rgCraV2OverrideRiskLevel: RgCraV2GamingCustomerRiskAssessment;
  rgCraV2PayoutRequest: Scalars['Boolean']['output'];
  rgCraV2PendingReview: RgCraV2GamingCustomerRiskAssessment;
  rgCraV2RefreshRiskAggregation: RgCraV2GamingCustomerRiskAssessment;
  rgCraV2RemoveRiskLevelOverride: RgCraV2GamingCustomerRiskAssessment;
  rgCraV2RewardRequest: Scalars['Boolean']['output'];
  rgCraV2SubmitReview: RgCraV2GamingCustomerRiskAssessment;
  selfExcludeV3: Player;
  selfExcludeV4: Player;
  /** Enable or disable the jackpot contribution switch for all brands */
  setAllDinoJackpotContributionSwitches: DinoBulkContributionSwitchResult;
  /** Set pop-ups needed to display to a customer. */
  setCustomerPopUpsNeeded: Customer;
  setDepositLimit: Wallet;
  /** Enable or disable the jackpot contribution switch for a brand */
  setDinoJackpotContributionSwitch: DinoContributionSwitchResult;
  /** Opt in or opt out a player from the dino jackpot */
  setDinoJackpotOptIn: Scalars['Boolean']['output'];
  /** Opt in or opt out a player from the dino jackpot for a given source code */
  setDinoJackpotOptInBySourceCode: Scalars['Boolean']['output'];
  setGlobalLossLimitByPlayerId: Wallet;
  setLossLimit: Wallet;
  setSessionLimit: Wallet;
  setWagerLimit: Wallet;
  setWageringRequirementBypass: Wallet;
  setWithdrawalLimit: Wallet;
  submitMatchDecision: Scalars['Boolean']['output'];
  submitReview: CustomerRiskAssessment;
  transformWagerLimitsToLossLimits: BulkTransformPlayersResult;
  triggerManualRiskUpdate: Scalars['Boolean']['output'];
  /** Unassign a list of players to a challenge */
  unassignPlayersFromChallenge: Scalars['Boolean']['output'];
  unbanGames: Scalars['Boolean']['output'];
  unblockDepositLimit: Wallet;
  unblockGeoLocation: Player;
  unblockInstantBanking: Player;
  unblockSessionLimit: Wallet;
  unblockWithdrawals: Player;
  unlinkPlayer: Scalars['String']['output'];
  /** Updates the value of affiliate id and token */
  updateAffiliateParameters: Player;
  /** Set and remove block that does not allow withdrawals to be cancelled */
  updateCustomerCancelWithdrawalBlock: Customer;
  /** Set and remove deposit block */
  updateCustomerDepositBlock: Customer;
  /** Set and remove Gamanza block */
  updateCustomerGamanzaBlock: Customer;
  /** Set and remove increase deposit limit block */
  updateCustomerIncreaseDepositLimitBlock: Customer;
  /** Set and remove marketing block */
  updateCustomerMarketingBlock: Customer;
  /** Set and remove rewards block */
  updateCustomerRewardsBlock: Customer;
  /** Set and remove RG net deposit limit block */
  updateCustomerRgNetDepositLimitBlock: Customer;
  /**
   * Put the customer in the RG whitelist. This will save the player for RG blocks,
   * but not for periodic emails and communications.
   */
  updateCustomerWhitelistStatus: Customer;
  /** @deprecated Use V2 instead */
  updateGamanzaBlockStatusByGlobalPlayerId: Scalars['Boolean']['output'];
  updateGamanzaBlockStatusByGlobalPlayerIdV2: GlobalPlayer;
  /** @deprecated Use V2 instead */
  updateGamanzaBlockStatusByPlayerId: Scalars['Boolean']['output'];
  updateGamanzaBlockStatusByPlayerIdV2: Player;
  updatePep: Player;
  /** Update an existing welcome offer */
  updateWelcomeOffer: OfferResult;
  /**
   * Notify document has been uploaded successfully
   * @deprecated Use uploadDocumentV2 instead
   */
  uploadDocument: Document;
  /** Notify document has been uploaded successfully */
  uploadDocumentV2: Document;
  /** Approve of Reject players provided source of wealth documents */
  verifyPlayerSourceOfWealth: PlayerCompliance;
  /** Approve of Reject players provided source of wealth documents */
  verifyPlayerSourceOfWealthV2: PlayerComplianceV2;
};


export type MutationactivateRewardsArgs = {
  id: Scalars['String']['input'];
};


export type MutationactivateWelcomeOfferArgs = {
  offerId: Scalars['String']['input'];
};


export type MutationaddFraudStatusOverwriteArgs = {
  decision: Scalars['Boolean']['input'];
  details?: InputMaybe<Scalars['String']['input']>;
  playerId: Scalars['ID']['input'];
};


export type MutationaddGlobalNoteArgs = {
  content: Scalars['String']['input'];
  playerGlobalUUID: Scalars['String']['input'];
  priority: PriorityEnum;
};


export type MutationaddGlobalNoteV2Args = {
  content: Scalars['String']['input'];
  playerGlobalId: Scalars['ID']['input'];
  priority: PriorityEnum;
};


export type MutationaddNoteArgs = {
  content: Scalars['String']['input'];
  playerId: Scalars['ID']['input'];
  priority: PriorityEnum;
};


export type MutationaddNoteV2Args = {
  categories: Array<NoteCategoryEnum>;
  content: Scalars['String']['input'];
  playerId: Scalars['ID']['input'];
  priority: PriorityEnum;
};


export type MutationaddPepStatusOverwriteArgs = {
  decision: Scalars['Boolean']['input'];
  details?: InputMaybe<Scalars['String']['input']>;
  playerId: Scalars['ID']['input'];
};


export type MutationaddPlayerToFinsharkWithdrawalBlockWhitelistArgs = {
  playerUUID: Scalars['String']['input'];
};


export type MutationaddPlayerToKrofortWithdrawalBlockWhitelistArgs = {
  playerUUID: Scalars['String']['input'];
};


export type MutationaddSanctionedStatusOverwriteArgs = {
  decision: Scalars['Boolean']['input'];
  details?: InputMaybe<Scalars['String']['input']>;
  playerId: Scalars['ID']['input'];
};


export type MutationadjustReservedBalanceArgs = {
  adjustmentType: ReservedAdjustmentType;
  amount: Scalars['PositiveBigDecimal']['input'];
  comment: Scalars['String']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationadjustmentDepositV4Args = {
  adjustmentType: AdjustmentType;
  amount: Scalars['PositiveBigDecimal']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  playerId: Scalars['ID']['input'];
  transactionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationadjustmentWithdrawalV4Args = {
  adjustmentType: AdjustmentType;
  amount: Scalars['PositiveBigDecimal']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  playerId: Scalars['ID']['input'];
  transactionId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationapproveDocumentArgs = {
  documentId: Scalars['ID']['input'];
  documentType: DocumentType;
  documentVerificationTypes: Array<DocumentVerificationType>;
  expirationDate?: InputMaybe<Scalars['LocalDate']['input']>;
};


export type MutationapproveDocumentV2Args = {
  comment: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
  documentType: DocumentType;
  documentVerificationTypes: Array<DocumentVerificationType>;
  expirationDate?: InputMaybe<Scalars['LocalDate']['input']>;
};


export type MutationapproveFundingDocumentArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['ID']['input'];
  fundingOption: FundingOption;
  playerId: Scalars['ID']['input'];
};


export type MutationapprovePendingZimplerWithdrawalArgs = {
  brand: BrandEnum;
  externalTransactionId: Scalars['String']['input'];
  playerSessionId: Scalars['String']['input'];
};


export type MutationassignPlayersArgs = {
  assignationId?: InputMaybe<Scalars['String']['input']>;
  comment: Scalars['String']['input'];
  generateAssignationId?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  playerIds: Array<Scalars['String']['input']>;
};


export type MutationassignPlayersToChallengeArgs = {
  challengeId: Scalars['String']['input'];
  playerIds: Array<Scalars['String']['input']>;
};


export type MutationattachTemplateToWelcomeOfferArgs = {
  offerId: Scalars['String']['input'];
  templateId: Scalars['String']['input'];
};


export type MutationbanGamesArgs = {
  games: Array<GameArg>;
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationblockDepositLimitArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationblockGeoLocationArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationblockInstantBankingArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationblockInstantBankingV2Args = {
  gracePeriodMinutes?: InputMaybe<Scalars['Long']['input']>;
  playerId: Scalars['ID']['input'];
};


export type MutationblockSessionLimitArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationblockWithdrawalsArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationbulkAddNoteArgs = {
  content: Scalars['String']['input'];
  playerIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationbulkAddNoteFromFileArgs = {
  content: Scalars['String']['input'];
  filePath: Scalars['String']['input'];
};


export type MutationbulkAdjustmentDepositArgs = {
  adjustmentType?: InputMaybe<AdjustmentType>;
  id: Scalars['String']['input'];
};


export type MutationbulkBlockInstantBankingArgs = {
  gracePeriodMinutes?: InputMaybe<Scalars['Long']['input']>;
  playerIds: Array<Scalars['ID']['input']>;
};


export type MutationbulkCreateExcludedPlayersArgs = {
  brand: BrandEnum;
  closeCause: CloseAccountCauseV4;
  playersInformationInput: Array<PlayerInformationInput>;
};


export type MutationcancelBlockclearPayoutsArgs = {
  dinoPayoutIds: Array<Scalars['String']['input']>;
};


export type MutationcancelDepositLimitRemovalArgs = {
  limitPeriodType: LimitTypeEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationcancelKrofortWithdrawalArgs = {
  transactionId: Scalars['String']['input'];
};


export type MutationcancelPendingDepositLimitArgs = {
  limitPeriodType: LimitTypeEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationcancelPendingGlobalLossLimitByPlayerIdArgs = {
  limitPeriodType: LimitTypeEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationcancelPendingLossLimitArgs = {
  limitPeriodType: LimitTypeEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationcancelPendingSelfExclusionV2Args = {
  comment: Scalars['String']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationcancelPendingSessionLimitArgs = {
  limitPeriodType: LimitTypeEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationcancelPendingWagerLimitArgs = {
  limitPeriodType: LimitTypeEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationcancelPendingZimplerWithdrawalArgs = {
  brand: BrandEnum;
  externalTransactionId: Scalars['String']['input'];
  playerSessionId: Scalars['String']['input'];
};


export type MutationcancelSelfExclusionV3Args = {
  comment: Scalars['String']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationcancelWithdrawalArgs = {
  amount: Scalars['PositiveBigDecimal']['input'];
  brand: BrandEnum;
  comment: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  externalTransactionId: Scalars['String']['input'];
  integration: Scalars['String']['input'];
  paymentId: Scalars['String']['input'];
  playerSessionId: Scalars['String']['input'];
  playerUUID: Scalars['String']['input'];
  provider: Scalars['String']['input'];
};


export type MutationchangeAddressArgs = {
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  district?: InputMaybe<Scalars['String']['input']>;
  playerId: Scalars['ID']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};


export type MutationchangeAmlRiskLevelArgs = {
  amlLevel: AmlRiskLevel;
  playerId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationchangeAmlRiskLevelV2Args = {
  amlLevel: AmlRiskLevel;
  playerId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
};


export type MutationchangeAssignedSsnArgs = {
  playerId: Scalars['ID']['input'];
  ssn: Scalars['String']['input'];
};


export type MutationchangeCampaignIdArgs = {
  campaignId: Scalars['CampaignId']['input'];
  id: Scalars['String']['input'];
};


export type MutationchangeEmailArgs = {
  brand: BrandEnum;
  email: Scalars['EmailAddress']['input'];
  playerId: Scalars['ID']['input'];
  sendVerificationEmail?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationchangeEmailMarketingSettingsArgs = {
  isEmailMarketingAccepted: Scalars['Boolean']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationchangeGlobalPlayerEmailMarketingArgs = {
  isEmailMarketingAccepted: Scalars['Boolean']['input'];
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationchangeGlobalPlayerMarketingBlockArgs = {
  isMarketingBlocked: Scalars['Boolean']['input'];
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationchangeGlobalPlayerPhoneMarketingArgs = {
  isPhoneMarketingAccepted: Scalars['Boolean']['input'];
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationchangeGlobalPlayerSmsMarketingArgs = {
  isSmsMarketingAccepted: Scalars['Boolean']['input'];
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationchangeGlobalPlayerWebPushMarketingArgs = {
  isWebPushMarketingAccepted: Scalars['Boolean']['input'];
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationchangeKycMasterPlayerArgs = {
  playerGlobalId: Scalars['ID']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationchangeMarketingBlockSettingsArgs = {
  isMarketingBlocked: Scalars['Boolean']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationchangeNotePinStatusArgs = {
  noteUUID: Scalars['String']['input'];
  pinned: Scalars['Boolean']['input'];
};


export type MutationchangePersonalDetailsArgs = {
  birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  playerId: Scalars['ID']['input'];
  secondLastName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationchangePhoneMarketingSettingsArgs = {
  isPhoneMarketingAccepted: Scalars['Boolean']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationchangePhoneNumberArgs = {
  brand: BrandEnum;
  phoneNumber: Scalars['String']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationchangePhoneNumberV2Args = {
  brand: BrandEnum;
  phoneNumber: Scalars['PhoneNumber']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationchangeProvidedSourceOfFundsArgs = {
  playerId: Scalars['ID']['input'];
  providedSourceOfFunds: BoSourceOfFunds;
};


export type MutationchangeSmsMarketingSettingsArgs = {
  isSmsMarketingAccepted: Scalars['Boolean']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationchangeTranslatedPersonalInfoArgs = {
  city: Scalars['String']['input'];
  district?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  playerId: Scalars['ID']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
};


export type MutationchangeWebPushMarketingSettingsArgs = {
  isWebPushMarketingAccepted: Scalars['Boolean']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationclaimFailedRewardsArgs = {
  id: Scalars['String']['input'];
};


export type MutationclearLoginLongBlockArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationclearLoginShortBlockArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationcloseGlobalPlayerAccountsArgs = {
  closeCause: CloseAccountCauseV4;
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationclosePlayerAccountV3Args = {
  closeCause: CloseAccountCauseV3;
  playerId: Scalars['ID']['input'];
};


export type MutationclosePlayerAccountV4Args = {
  closeCause: CloseAccountCauseV4;
  playerId: Scalars['ID']['input'];
};


export type MutationcloseWageringRequirementCycleArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationcreateBonusCodeArgs = {
  input: CreateBonusCodeInput;
};


export type MutationcreateBonusMoneyDropArgs = {
  amount: Scalars['PositiveBigDecimal']['input'];
  campaignId?: InputMaybe<Scalars['CampaignId']['input']>;
  claimType: ClaimType;
  comment: Scalars['String']['input'];
  currencyCode: Scalars['ISOCurrencyCode']['input'];
  endsAt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  expiresIn?: InputMaybe<Scalars['Duration']['input']>;
  maxPayout: Scalars['PositiveBigDecimal']['input'];
  playerIds: Array<Scalars['String']['input']>;
  rewardDisplayName?: InputMaybe<Scalars['String']['input']>;
  rewardName: Scalars['String']['input'];
  rewardSystem?: InputMaybe<RewardTargetSystem>;
  startsAt: Scalars['OffsetDateTime']['input'];
  wageringRequirementFactor: Scalars['Int']['input'];
};


export type MutationcreateBonusMoneyDropV2Args = {
  amount: Scalars['PositiveBigDecimal']['input'];
  campaignId?: InputMaybe<Scalars['CampaignId']['input']>;
  claimType: ClaimType;
  comment: Scalars['String']['input'];
  currencyCode: Scalars['ISOCurrencyCode']['input'];
  endsAt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  expiresIn?: InputMaybe<Scalars['Duration']['input']>;
  maxPayout: Scalars['PositiveBigDecimal']['input'];
  playerIds: Array<Scalars['String']['input']>;
  rewardDisplayName?: InputMaybe<Scalars['String']['input']>;
  rewardName: Scalars['String']['input'];
  rewardSystem?: InputMaybe<RewardTargetSystem>;
  startsAt: Scalars['OffsetDateTime']['input'];
  wageringRequirementFactor: Scalars['PositiveInt']['input'];
};


export type MutationcreateBonusTemplateArgs = {
  affiliateId?: InputMaybe<Scalars['String']['input']>;
  claimDays: Scalars['Int']['input'];
  countries: Array<Scalars['ISOCountryCode']['input']>;
  dynamicMaxPayoutMultiplier?: InputMaybe<Scalars['Float']['input']>;
  maxDepositAmount?: InputMaybe<Scalars['Int']['input']>;
  maxRewardAmount?: InputMaybe<Scalars['Int']['input']>;
  multiplier?: InputMaybe<Scalars['Float']['input']>;
  staticAmount: Scalars['Int']['input'];
  staticMaxPayout: Scalars['Int']['input'];
  templateName: Scalars['String']['input'];
  wageringRequirementFactor: Scalars['Int']['input'];
};


export type MutationcreateDepositChallengeArgs = {
  brands: Array<BrandEnum>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  challengeDisplayName?: InputMaybe<Scalars['String']['input']>;
  challengeName: Scalars['String']['input'];
  challengeRewards: Array<ChallengeRewardInputV2>;
  countries: Array<Scalars['String']['input']>;
  currencyCode: Scalars['ISOCurrencyCode']['input'];
  endDate?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  paymentIntegration?: InputMaybe<PaymentIntegrationEnum>;
  startDate: Scalars['OffsetDateTime']['input'];
};


export type MutationcreateDepositChallengeV2Args = {
  brands: Array<BrandEnum>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  challengeDisplayName?: InputMaybe<Scalars['String']['input']>;
  challengeName: Scalars['String']['input'];
  challengeRewards: Array<ChallengeRewardInputV2>;
  challengeSystem: ChallengeExternalSystem;
  countries: Array<Scalars['String']['input']>;
  currencyCode: Scalars['ISOCurrencyCode']['input'];
  endDate?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  paymentIntegration?: InputMaybe<PaymentIntegrationEnum>;
  startDate: Scalars['OffsetDateTime']['input'];
};


export type MutationcreateFreeSpinsArgs = {
  betLevel: Scalars['Int']['input'];
  campaignId?: InputMaybe<Scalars['CampaignId']['input']>;
  claimType: ClaimType;
  comment: Scalars['String']['input'];
  currencyCode: Scalars['ISOCurrencyCode']['input'];
  endsAt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  expiresIn?: InputMaybe<Scalars['Duration']['input']>;
  gameDesktopId?: InputMaybe<Scalars['String']['input']>;
  gameMobileId?: InputMaybe<Scalars['String']['input']>;
  gameProviderId: GameProvider;
  playerIds: Array<Scalars['String']['input']>;
  rewardDisplayName?: InputMaybe<Scalars['String']['input']>;
  rewardName: Scalars['String']['input'];
  rewardSystem?: InputMaybe<RewardTargetSystem>;
  spinsNumber: Scalars['Int']['input'];
  spinsValue: Scalars['Long']['input'];
  startsAt: Scalars['OffsetDateTime']['input'];
};


export type MutationcreateFreeSpinsV2Args = {
  betLevel: Scalars['PositiveInt']['input'];
  campaignId?: InputMaybe<Scalars['CampaignId']['input']>;
  claimType: ClaimType;
  comment: Scalars['String']['input'];
  currencyCode: Scalars['ISOCurrencyCode']['input'];
  endsAt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  expiresIn?: InputMaybe<Scalars['Duration']['input']>;
  gameDesktopId?: InputMaybe<Scalars['String']['input']>;
  gameMobileId?: InputMaybe<Scalars['String']['input']>;
  gameProviderId: GameProvider;
  playerIds: Array<Scalars['String']['input']>;
  rewardDisplayName?: InputMaybe<Scalars['String']['input']>;
  rewardName: Scalars['String']['input'];
  rewardSystem?: InputMaybe<RewardTargetSystem>;
  spinsNumber: Scalars['PositiveInt']['input'];
  spinsValue: Scalars['PositiveLong']['input'];
  startsAt: Scalars['OffsetDateTime']['input'];
};


export type MutationcreateFreespinsTemplateArgs = {
  affiliateId?: InputMaybe<Scalars['String']['input']>;
  claimDays: Scalars['Int']['input'];
  countries: Array<Scalars['ISOCountryCode']['input']>;
  gameId: Scalars['String']['input'];
  gameProvider: GameProvider;
  maxDepositAmount?: InputMaybe<Scalars['Int']['input']>;
  maxRewardAmount?: InputMaybe<Scalars['Int']['input']>;
  multiplier?: InputMaybe<Scalars['Float']['input']>;
  paylines: Scalars['Int']['input'];
  spreadOverDays: Scalars['Int']['input'];
  staticAmount: Scalars['Int']['input'];
  templateName: Scalars['String']['input'];
  valueCents: Scalars['Int']['input'];
};


export type MutationcreateMoneyDropArgs = {
  amount: Scalars['PositiveBigDecimal']['input'];
  campaignId?: InputMaybe<Scalars['CampaignId']['input']>;
  claimType: ClaimType;
  comment: Scalars['String']['input'];
  currencyCode: Scalars['ISOCurrencyCode']['input'];
  endsAt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  expiresIn?: InputMaybe<Scalars['Duration']['input']>;
  playerIds: Array<Scalars['String']['input']>;
  rewardDisplayName?: InputMaybe<Scalars['String']['input']>;
  rewardName: Scalars['String']['input'];
  rewardSystem?: InputMaybe<RewardTargetSystem>;
  startsAt: Scalars['OffsetDateTime']['input'];
};


export type MutationcreateMoneyTemplateArgs = {
  affiliateId?: InputMaybe<Scalars['String']['input']>;
  claimDays: Scalars['Int']['input'];
  countries: Array<Scalars['ISOCountryCode']['input']>;
  maxDepositAmount?: InputMaybe<Scalars['Int']['input']>;
  maxRewardAmount?: InputMaybe<Scalars['Int']['input']>;
  multiplier?: InputMaybe<Scalars['Float']['input']>;
  staticAmount: Scalars['Int']['input'];
  templateName: Scalars['String']['input'];
};


export type MutationcreatePlayerV4Args = {
  birthDate: Scalars['LocalDate']['input'];
  brand: BrandEnum;
  bypassAgeValidation?: InputMaybe<Scalars['Boolean']['input']>;
  bypassCountryValidation?: InputMaybe<Scalars['Boolean']['input']>;
  city: Scalars['String']['input'];
  closeCause?: InputMaybe<CloseAccountCauseV4>;
  countryCode: Scalars['String']['input'];
  district?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['EmailAddress']['input'];
  firstName: Scalars['String']['input'];
  isTestAccount?: InputMaybe<Scalars['Boolean']['input']>;
  lastName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['PhoneNumber']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  street: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};


export type MutationcreateSowChallengeArgs = {
  campaignId?: InputMaybe<Scalars['String']['input']>;
  challengeDisplayName?: InputMaybe<Scalars['String']['input']>;
  challengeName: Scalars['String']['input'];
  challengeRewards: Array<ChallengeRewardInputV2>;
  currencyCode: Scalars['ISOCurrencyCode']['input'];
  startDate: Scalars['OffsetDateTime']['input'];
};


export type MutationcreateSowChallengeV2Args = {
  campaignId?: InputMaybe<Scalars['String']['input']>;
  challengeDisplayName?: InputMaybe<Scalars['String']['input']>;
  challengeName: Scalars['String']['input'];
  challengeRewards: Array<ChallengeRewardInputV2>;
  challengeSystem: ChallengeExternalSystem;
  currencyCode: Scalars['ISOCurrencyCode']['input'];
  startDate: Scalars['OffsetDateTime']['input'];
};


export type MutationcreateSportsbookMoneyDropArgs = {
  amount: Scalars['PositiveBigDecimal']['input'];
  campaignId?: InputMaybe<Scalars['CampaignId']['input']>;
  claimType: ClaimType;
  comment: Scalars['String']['input'];
  currencyCode: Scalars['ISOCurrencyCode']['input'];
  endsAt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  expiresIn?: InputMaybe<Scalars['Duration']['input']>;
  playerIds: Array<Scalars['String']['input']>;
  rewardDisplayName?: InputMaybe<Scalars['String']['input']>;
  rewardName: Scalars['String']['input'];
  rewardSystem?: InputMaybe<RewardTargetSystem>;
  startsAt: Scalars['OffsetDateTime']['input'];
  templateId: Scalars['String']['input'];
};


export type MutationcreateWelcomeOfferArgs = {
  activeFrom: Scalars['String']['input'];
  activeUntil?: InputMaybe<Scalars['String']['input']>;
  brand: BrandEnum;
  countries: Array<Scalars['ISOCountryCode']['input']>;
  currency: Scalars['ISOCurrencyCode']['input'];
  depositNumber: Scalars['Int']['input'];
};


export type MutationdeactivateWelcomeOfferArgs = {
  offerId: Scalars['String']['input'];
};


export type MutationdeleteBonusCodeArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeleteDocumentArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationdeleteFundingDocumentArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationdeleteNoteArgs = {
  noteUUID: Scalars['String']['input'];
};


export type MutationdeleteTemplateArgs = {
  templateId: Scalars['String']['input'];
};


export type MutationdetachTemplateFromWelcomeOfferArgs = {
  offerId: Scalars['String']['input'];
  rewardId: Scalars['String']['input'];
};


export type MutationforceRegistrationArgs = {
  playerUUID: Scalars['String']['input'];
  registrationScheme: RegistrationScheme;
};


export type MutationforfeitBonusArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationfundingDocumentUploadedArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['ID']['input'];
  fundingOption: FundingOption;
  playerId: Scalars['ID']['input'];
};


export type MutationgenerateBulkDocumentUrlArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
};


export type MutationgenerateBulkGetDocumentUrlArgs = {
  id: Scalars['String']['input'];
};


export type MutationgenerateFinsharkNonSettledDepositsReportArgs = {
  createdAt?: InputMaybe<RangeDate>;
  playerIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationgenerateFinsharkUnknownPayoutsReportArgs = {
  payoutStatus?: InputMaybe<PayoutStatus>;
  unknownFailureAt?: InputMaybe<RangeDate>;
};


export type MutationgenerateFundingDocumentDownloadUrlArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationgenerateGetDocumentUrlArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationgenerateKrofortNonSettledDepositsReportArgs = {
  createdAt?: InputMaybe<RangeDate>;
  playerIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationgenerateKrofortUnknownPayoutsReportArgs = {
  payoutStatus?: InputMaybe<KrofortPayoutStatus>;
  unknownFailureAt?: InputMaybe<RangeDate>;
};


export type MutationgetClosingBalanceReportArgs = {
  asOf?: InputMaybe<Scalars['LocalDate']['input']>;
  brand?: InputMaybe<BrandEnum>;
  order?: InputMaybe<ClosingBalanceOrder>;
  orderBy?: InputMaybe<ClosingBalanceOrderBy>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationinvitePlayersToVipBrandArgs = {
  brand: BrandEnum;
  phoneNumbers: Array<Scalars['PhoneNumber']['input']>;
};


export type MutationisPlayerInvitedToVipBrandArgs = {
  brand: BrandEnum;
  phoneNumber: Scalars['PhoneNumber']['input'];
};


export type MutationisPlayerOnFinsharkWithdrawalBlockWhitelistArgs = {
  playerUUID: Scalars['String']['input'];
};


export type MutationisPlayerOnKrofortWithdrawalBlockWhitelistArgs = {
  playerUUID: Scalars['String']['input'];
};


export type MutationlinkPlayerArgs = {
  playerGlobalUUID: Scalars['String']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationmanualCompleteDepositCriteriaArgs = {
  amount: Scalars['PositiveBigDecimal']['input'];
  challengeId: Scalars['String']['input'];
  completedAt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  paymentIntegration?: InputMaybe<PaymentIntegrationEnum>;
  playerId: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};


export type MutationmanualKycCheckArgs = {
  documentVerificationTypes: Array<DocumentVerificationType>;
  playerId: Scalars['ID']['input'];
  requestedAt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


export type MutationmanualWithdrawalApprovalArgs = {
  decision: DecisionType;
  paymentId: Scalars['String']['input'];
};


export type MutationmergeGameRoundsArgs = {
  brand?: InputMaybe<BrandEnum>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  months?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationmovePhoneNumberBetweenPlayersArgs = {
  brand: BrandEnum;
  oldPlayerId: Scalars['ID']['input'];
  phoneNumber: Scalars['PhoneNumber']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationoverrideRiskLevelArgs = {
  comment: Scalars['String']['input'];
  playerGlobalId: Scalars['ID']['input'];
  riskLevel: RiskLevel;
};


export type MutationpendingReviewArgs = {
  comment: Scalars['String']['input'];
  playerGlobalUUID: Scalars['String']['input'];
};


export type MutationprocessStuckWithdrawalsFromListArgs = {
  noteContent?: InputMaybe<Scalars['String']['input']>;
  transactionIds: Array<Scalars['String']['input']>;
};


export type MutationrejectDocumentArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationrejectDocumentV2Args = {
  comment: Scalars['String']['input'];
  documentId: Scalars['ID']['input'];
};


export type MutationrejectFundingDocumentArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['ID']['input'];
  fundingOption: FundingOption;
  playerId: Scalars['ID']['input'];
};


export type MutationremoveAffiliateParametersArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationremoveChallengeV2Args = {
  challengeId: Scalars['String']['input'];
};


export type MutationremoveDepositLimitArgs = {
  limitPeriodType: LimitTypeEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationremoveEmailSuppressionsArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationremoveFraudStatusOverwriteArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationremoveGlobalLossLimitByPlayerIdArgs = {
  limitPeriodType: LimitTypeEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationremoveLossLimitArgs = {
  limitPeriodType: LimitTypeEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationremovePepStatusOverwriteArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationremovePlayerFromFinsharkWithdrawalBlockWhitelistArgs = {
  playerUUID: Scalars['String']['input'];
};


export type MutationremovePlayerFromKrofortWithdrawalBlockWhitelistArgs = {
  playerUUID: Scalars['String']['input'];
};


export type MutationremovePlayersV2Args = {
  comment: Scalars['String']['input'];
  id: Scalars['String']['input'];
  playerRewardAssignations: Array<PlayerRewardAssignation>;
};


export type MutationremoveRewardArgs = {
  id: Scalars['String']['input'];
  reason: Scalars['NonEmptyString']['input'];
};


export type MutationremoveRiskLevelOverrideArgs = {
  comment: Scalars['String']['input'];
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationremoveSanctionedStatusOverwriteArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationremoveSendgridEmailSuppressionsArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationremoveSessionLimitArgs = {
  limitPeriodType: LimitTypeEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationremoveWagerLimitArgs = {
  limitPeriodType: LimitTypeEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationremoveWithdrawalLimitArgs = {
  currencyCode?: InputMaybe<Scalars['ISOCurrencyCode']['input']>;
  limitPeriodType: LimitTypeEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationreopenCustomerArgs = {
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationreopenPlayerAccountArgs = {
  overrideCooldown?: InputMaybe<Scalars['Boolean']['input']>;
  playerId: Scalars['ID']['input'];
};


export type MutationrequestDocumentsArgs = {
  playerId: Scalars['ID']['input'];
  requestedSowDocuments: Array<FundingOption>;
};


export type MutationrequestDocumentsV2Args = {
  playerId: Scalars['ID']['input'];
  requestedSowDocuments: Array<FundingOption>;
};


export type MutationrequestDocumentsV3Args = {
  playerId: Scalars['ID']['input'];
  requestedSowDocumentsV2: Array<RequestedFundingType>;
};


export type MutationrequestSowArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationresendVerificationEmailArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationresetGlobalInvalidLoginAttemptsLeftArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationresetGlobalInvalidLoginAttemptsLeftV2Args = {
  brand: BrandEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationresetKycEntityIdAuthMethodEntityArgs = {
  brand: BrandEnum;
  kycEntityId: Scalars['String']['input'];
  playerUUID: Scalars['String']['input'];
};


export type MutationresolveRewardArgs = {
  assignationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  manualDecision: ManualDecisionType;
  playerId: Scalars['ID']['input'];
};


export type MutationretryKrofortKycArgs = {
  playerIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationrgCraIndicatorCommunicationsArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationrgCraOverrideRiskLevelArgs = {
  comment: Scalars['String']['input'];
  playerGlobalId: Scalars['ID']['input'];
  rgCraRiskLevel: RgCraRiskLevel;
};


export type MutationrgCraPayoutRequestArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationrgCraPendingReviewArgs = {
  comment: Scalars['String']['input'];
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationrgCraRemoveRiskLevelOverrideArgs = {
  comment: Scalars['String']['input'];
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationrgCraRewardRequestArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationrgCraSubmitReviewArgs = {
  comment: Scalars['String']['input'];
  playerGlobalId: Scalars['ID']['input'];
  rgCraReviewStatus: RgCraSubmitReviewStatus;
  rgCraReviewTrigger: RgCraReviewTriggerArg;
};


export type MutationrgCraTriggerManualRiskUpdateArgs = {
  comment: Scalars['String']['input'];
};


export type MutationrgCraV2IndicatorCommunicationsArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationrgCraV2OverrideRiskLevelArgs = {
  comment: Scalars['String']['input'];
  playerGlobalId: Scalars['ID']['input'];
  rgCraRiskLevel: RgCraV2RiskLevel;
};


export type MutationrgCraV2PayoutRequestArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationrgCraV2PendingReviewArgs = {
  comment: Scalars['String']['input'];
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationrgCraV2RefreshRiskAggregationArgs = {
  playerGlobalId: Scalars['ID']['input'];
  riskPath?: InputMaybe<RgCraV2RiskPathArg>;
};


export type MutationrgCraV2RemoveRiskLevelOverrideArgs = {
  comment: Scalars['String']['input'];
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationrgCraV2RewardRequestArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationrgCraV2SubmitReviewArgs = {
  comment: Scalars['String']['input'];
  playerGlobalId: Scalars['ID']['input'];
  rgCraReviewStatus: RgCraV2SubmitReviewStatus;
  rgCraReviewTrigger: RgCraV2ReviewTriggerArg;
};


export type MutationselfExcludeV3Args = {
  comment: Scalars['String']['input'];
  exclusionEndsAt?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  playerId: Scalars['ID']['input'];
};


export type MutationselfExcludeV4Args = {
  comment: Scalars['String']['input'];
  exclusionDaysArg?: InputMaybe<Scalars['Int']['input']>;
  playerId: Scalars['ID']['input'];
};


export type MutationsetAllDinoJackpotContributionSwitchesArgs = {
  enabled: Scalars['Boolean']['input'];
};


export type MutationsetCustomerPopUpsNeededArgs = {
  playerGlobalId: Scalars['ID']['input'];
  popUpIds: Array<Scalars['String']['input']>;
};


export type MutationsetDepositLimitArgs = {
  amount: Scalars['PositiveBigDecimal']['input'];
  limitPeriodType: LimitTypeEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationsetDinoJackpotContributionSwitchArgs = {
  brand: BrandEnum;
  enabled: Scalars['Boolean']['input'];
};


export type MutationsetDinoJackpotOptInArgs = {
  brand: BrandEnum;
  optIn: Scalars['Boolean']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationsetDinoJackpotOptInBySourceCodeArgs = {
  brand: BrandEnum;
  optIn: Scalars['Boolean']['input'];
  playerId: Scalars['ID']['input'];
  sourceCode: Scalars['NonEmptyString']['input'];
};


export type MutationsetGlobalLossLimitByPlayerIdArgs = {
  amount: Scalars['PositiveBigDecimal']['input'];
  limitPeriodType: LimitTypeEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationsetLossLimitArgs = {
  amount: Scalars['PositiveBigDecimal']['input'];
  limitPeriodType: LimitTypeEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationsetSessionLimitArgs = {
  amount: Scalars['PositiveBigDecimal']['input'];
  limitPeriodType: LimitTypeEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationsetWagerLimitArgs = {
  amount: Scalars['PositiveBigDecimal']['input'];
  limitPeriodType: LimitTypeEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationsetWageringRequirementBypassArgs = {
  playerId: Scalars['ID']['input'];
  wageringRequirementBypass: Scalars['Boolean']['input'];
};


export type MutationsetWithdrawalLimitArgs = {
  amount: Scalars['PositiveBigDecimal']['input'];
  currencyCode?: InputMaybe<Scalars['ISOCurrencyCode']['input']>;
  limitPeriodType: LimitTypeEnum;
  playerId: Scalars['ID']['input'];
};


export type MutationsubmitMatchDecisionArgs = {
  matchDecision: MatchDecision;
  playerId: Scalars['ID']['input'];
  resourceId: Scalars['String']['input'];
};


export type MutationsubmitReviewArgs = {
  comment: Scalars['String']['input'];
  playerGlobalId: Scalars['ID']['input'];
  reviewStatus: SubmitReviewStatus;
  reviewTrigger: ReviewTriggerArg;
};


export type MutationtransformWagerLimitsToLossLimitsArgs = {
  playerIds: Array<Scalars['ID']['input']>;
};


export type MutationtriggerManualRiskUpdateArgs = {
  comment: Scalars['String']['input'];
};


export type MutationunassignPlayersFromChallengeArgs = {
  challengeId: Scalars['String']['input'];
  playerIds: Array<Scalars['String']['input']>;
};


export type MutationunbanGamesArgs = {
  games: Array<GameArg>;
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationunblockDepositLimitArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationunblockGeoLocationArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationunblockInstantBankingArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationunblockSessionLimitArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationunblockWithdrawalsArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationunlinkPlayerArgs = {
  playerId: Scalars['ID']['input'];
};


export type MutationupdateAffiliateParametersArgs = {
  affiliateParameters: AffiliateParameters;
  playerId: Scalars['ID']['input'];
};


export type MutationupdateCustomerCancelWithdrawalBlockArgs = {
  enable: Scalars['Boolean']['input'];
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationupdateCustomerDepositBlockArgs = {
  enable: Scalars['Boolean']['input'];
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationupdateCustomerGamanzaBlockArgs = {
  enable: Scalars['Boolean']['input'];
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationupdateCustomerIncreaseDepositLimitBlockArgs = {
  enable: Scalars['Boolean']['input'];
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationupdateCustomerMarketingBlockArgs = {
  enable: Scalars['Boolean']['input'];
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationupdateCustomerRewardsBlockArgs = {
  enable: Scalars['Boolean']['input'];
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationupdateCustomerRgNetDepositLimitBlockArgs = {
  enable: Scalars['Boolean']['input'];
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationupdateCustomerWhitelistStatusArgs = {
  playerGlobalId: Scalars['ID']['input'];
  whitelisted: Scalars['Boolean']['input'];
};


export type MutationupdateGamanzaBlockStatusByGlobalPlayerIdArgs = {
  blockPlayer: Scalars['Boolean']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationupdateGamanzaBlockStatusByGlobalPlayerIdV2Args = {
  blockPlayer: Scalars['Boolean']['input'];
  playerGlobalId: Scalars['ID']['input'];
};


export type MutationupdateGamanzaBlockStatusByPlayerIdArgs = {
  blockPlayer: Scalars['Boolean']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationupdateGamanzaBlockStatusByPlayerIdV2Args = {
  blockPlayer: Scalars['Boolean']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationupdatePepArgs = {
  isPep: Scalars['Boolean']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationupdateWelcomeOfferArgs = {
  activeFrom?: InputMaybe<Scalars['String']['input']>;
  activeUntil?: InputMaybe<Scalars['String']['input']>;
  countries?: InputMaybe<Array<Scalars['ISOCountryCode']['input']>>;
  offerId: Scalars['String']['input'];
  removeActiveUntil?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationuploadDocumentArgs = {
  documentId: Scalars['ID']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationuploadDocumentV2Args = {
  comment?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['ID']['input'];
  playerId: Scalars['ID']['input'];
};


export type MutationverifyPlayerSourceOfWealthArgs = {
  playerId: Scalars['ID']['input'];
  verificationDecision: VerificationDecision;
};


export type MutationverifyPlayerSourceOfWealthV2Args = {
  playerId: Scalars['ID']['input'];
  verificationDecision: VerificationDecision;
};

/** Base gamification details */
export type NoGamificationSystem = {
  __typename: 'NoGamificationSystem';
  factor: Scalars['Float']['output'];
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID']['output'];
};

/** Note */
export type Note = Node & {
  __typename: 'Note';
  addedBy: Initiator;
  categories: Array<NoteCategoryEnum>;
  content: Scalars['String']['output'];
  createdAt: Scalars['OffsetDateTime']['output'];
  deletedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  deletedBy: Maybe<Initiator>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  isDeleted: Scalars['Boolean']['output'];
  pinned: Scalars['Boolean']['output'];
  playerId: Scalars['ID']['output'];
  priority: PriorityEnum;
  rawPlayerId: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
};

/** Note categories */
export enum NoteCategoryEnum {
  Bonuses = 'Bonuses',
  Compliance = 'Compliance',
  Other = 'Other',
  Payments = 'Payments'
}

/** A connection to a list of items. */
export type NoteConnection = {
  __typename: 'NoteConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<NoteEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NoteEdge = {
  __typename: 'NoteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Note;
};

/** NoteResponse */
export type NoteResponse = Node & {
  __typename: 'NoteResponse';
  /** The ID of an object */
  id: Scalars['ID']['output'];
  note: Note;
  origin: origin;
};

/** A connection to a list of items. */
export type NoteResponseConnection = {
  __typename: 'NoteResponseConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<NoteResponseEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NoteResponseEdge = {
  __typename: 'NoteResponseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: NoteResponse;
};

/** A welcome offer with attached templates */
export type Offer = {
  __typename: 'Offer';
  activeFrom: Scalars['String']['output'];
  activeUntil: Maybe<Scalars['String']['output']>;
  brand: Brand;
  /** Optional countries for this offer - limits template-level countries if set */
  countries: Array<Scalars['ISOCountryCode']['output']>;
  currency: Scalars['ISOCurrencyCode']['output'];
  /** The deposit number this offer applies to (e.g., 1 for first deposit, 0 for registration) */
  depositNumber: Scalars['Int']['output'];
  /** The ID of an object */
  id: Scalars['ID']['output'];
  /** Draft, Active, or Deactivated */
  lifecycle: Scalars['String']['output'];
  offerId: Scalars['String']['output'];
  templates: Array<OfferTemplate>;
};

/** Lifecycle status of the offer */
export enum OfferLifecycle {
  Active = 'Active',
  Created = 'Created',
  Deactivated = 'Deactivated',
  Expired = 'Expired'
}

/** Result of an offer operation, either success or error */
export type OfferResult = Offer | WelcomeOfferError;

/** A template attached to an offer on which to build the reward */
export type OfferTemplate = {
  __typename: 'OfferTemplate';
  /** The ID of an object */
  id: Scalars['ID']['output'];
  rewardId: Scalars['String']['output'];
  rewardName: Scalars['String']['output'];
  rewardProfile: RewardProfile;
};

/** A connection to a list of items. */
export type OffersConnectionConnection = {
  __typename: 'OffersConnectionConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<OffersConnectionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OffersConnectionEdge = {
  __typename: 'OffersConnectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: OfferResult;
};

/** A sorting order specification. */
export enum OrderingSpecType {
  /** Ascending order. */
  ASCENDING = 'ASCENDING',
  /** Descending order. */
  DESCENDING = 'DESCENDING'
}

/** Organization name. */
export enum OrgEnum {
  APX = 'APX',
  DT = 'DT',
  Dummy = 'Dummy',
  ELM = 'ELM',
  FTV = 'FTV',
  FW = 'FW',
  HE = 'HE',
  IN = 'IN',
  LUD = 'LUD',
  MT = 'MT',
  TFF = 'TFF',
  VEL = 'VEL'
}

/** The outcome of a risk event */
export type Outcome = {
  /** The name of the outcome */
  name: Scalars['String']['output'];
};

/** The outcome of a risk event in the history */
export enum OutcomeEnum {
  FinalRiskLevelUpdated = 'FinalRiskLevelUpdated',
  ReviewApproved = 'ReviewApproved',
  ReviewNeeded = 'ReviewNeeded',
  ReviewPending = 'ReviewPending',
  ReviewRejected = 'ReviewRejected',
  RiskLevelUpdated = 'RiskLevelUpdated',
  RiskOverrideAdded = 'RiskOverrideAdded',
  RiskOverrideRemoved = 'RiskOverrideRemoved'
}

/** A players overwritable screening status check result */
export type OverwritableStatusCheck = {
  __typename: 'OverwritableStatusCheck';
  /** Status check was done */
  checkWasDone: Scalars['Boolean']['output'];
  finalDecision: Maybe<Scalars['Boolean']['output']>;
  /** KYC Provider which made the check */
  kycProvider: Maybe<KycProviderType>;
  /** Manual Overwrite */
  overwrite: Maybe<Overwrite>;
  /** The result of the status check */
  statusCheck: Maybe<StatusCheck>;
};

/** Overwrites a players screening status */
export type Overwrite = {
  __typename: 'Overwrite';
  at: Scalars['OffsetDateTime']['output'];
  decision: Scalars['Boolean']['output'];
  details: Maybe<Scalars['String']['output']>;
  madeBy: Maybe<Initiator>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

/** A payment. */
export type Payment = {
  __typename: 'Payment';
  amount: Maybe<Scalars['BigDecimal']['output']>;
  brand: Maybe<Brand>;
  /**
   * Timestamp of when the payment status changed to cancelInitialized. None if the
   * state has not been through cancelInitialized yet.
   */
  cancelInitializedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  /** Timestamp of when the payment status changed to cancelled. None if the state has not been through cancelled yet. */
  cancelledAt: Maybe<Scalars['OffsetDateTime']['output']>;
  closingBalance: Maybe<Scalars['BigDecimal']['output']>;
  /** Timestamp of when the payment status changed to completed. None if the state has not been through completed yet. */
  completedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  cryptoInformation: Maybe<CryptoInformation>;
  currency: Maybe<Scalars['String']['output']>;
  euroQuote: Maybe<EuroQuote>;
  extTransactionId: Maybe<Scalars['String']['output']>;
  initialAmount: Maybe<Scalars['BigDecimal']['output']>;
  /** Timestamp of when the payment status changed to initialized. None if the state has not been through initialized yet. */
  initializedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  initiator: Maybe<Initiator>;
  instrument: Maybe<Scalars['String']['output']>;
  integration: Maybe<PaymentIntegrationEnum>;
  /** Timestamp of last transactions */
  lastTransactionAt: Maybe<Scalars['OffsetDateTime']['output']>;
  openingBalance: Maybe<Scalars['BigDecimal']['output']>;
  paymentFee: Maybe<Fee>;
  paymentId: Scalars['ID']['output'];
  paymentMethod: Maybe<Scalars['String']['output']>;
  paymentStatus: Scalars['String']['output'];
  paymentType: Scalars['String']['output'];
  playerId: Maybe<Scalars['ID']['output']>;
  playerSessionId: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp of last processed transaction, can differ from lastTransactionAt in
   * rare occasions where transactions were processed out of order
   */
  processedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  provider: Maybe<Scalars['String']['output']>;
  providerFee: Maybe<Fee>;
  rawPaymentId: Scalars['String']['output'];
  riskScore: Maybe<Scalars['String']['output']>;
  /** Timestamp of when the payment status changed to rollback. None if the state has not been through rollback yet. */
  rollbackAt: Maybe<Scalars['OffsetDateTime']['output']>;
  /**
   * Timestamp of when the payment status changed to rollbackInitialized. None if
   * the state has not been through rollbackInitialized yet.
   */
  rollbackInitializedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  statusMessage: Maybe<Scalars['String']['output']>;
  targetExtTransactionId: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/** Information about a payment approval */
export type PaymentApproval = {
  __typename: 'PaymentApproval';
  address: Scalars['String']['output'];
  amount: Money;
  autoDecision: DecisionType;
  initiator: Maybe<Initiator>;
  integration: PaymentIntegration;
  manualDecision: Maybe<DecisionType>;
  paymentId: Scalars['String']['output'];
  paymentType: PaymentType;
  playerId: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
};

/** A connection to a list of items. */
export type PaymentApprovalConnection = {
  __typename: 'PaymentApprovalConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PaymentApprovalEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PaymentApprovalEdge = {
  __typename: 'PaymentApprovalEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PaymentApproval;
};

/** The order to list PaymentApproval search results */
export enum PaymentApprovalSearchOrder {
  playerId = 'playerId',
  processedAt = 'processedAt'
}

/** A connection to a list of items. */
export type PaymentConnection = {
  __typename: 'PaymentConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PaymentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PaymentEdge = {
  __typename: 'PaymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Payment;
};

/** A payment export details. */
export type PaymentExportDetails = {
  __typename: 'PaymentExportDetails';
  url: Scalars['String']['output'];
};

/** Integration with a payment provider */
export enum PaymentIntegration {
  Blockclear = 'Blockclear',
  Brite = 'Brite',
  BriteDirect = 'BriteDirect',
  BullPay = 'BullPay',
  Coinspaid = 'Coinspaid',
  Cryptoprocessing = 'Cryptoprocessing',
  EziFlo = 'EziFlo',
  Finshark = 'Finshark',
  Infinipi = 'Infinipi',
  Krofort = 'Krofort',
  Match2pay = 'Match2pay',
  PaymentIQ = 'PaymentIQ',
  Sofort = 'Sofort',
  Trustly = 'Trustly',
  Zimpler = 'Zimpler'
}

/** Payment integration name. */
export enum PaymentIntegrationEnum {
  Blockclear = 'Blockclear',
  Brite = 'Brite',
  BriteDirect = 'BriteDirect',
  BullPay = 'BullPay',
  Coinspaid = 'Coinspaid',
  Cryptoprocessing = 'Cryptoprocessing',
  EziFlo = 'EziFlo',
  Finshark = 'Finshark',
  Infinipi = 'Infinipi',
  Krofort = 'Krofort',
  Match2pay = 'Match2pay',
  PaymentIQ = 'PaymentIQ',
  Sofort = 'Sofort',
  Trustly = 'Trustly',
  Zimpler = 'Zimpler'
}

/** The order to list Payment search results */
export enum PaymentSearchOrder {
  brand = 'brand',
  cancelInitializedAt = 'cancelInitializedAt',
  cancelledAt = 'cancelledAt',
  completedAt = 'completedAt',
  initializedAt = 'initializedAt',
  playerId = 'playerId',
  processedAt = 'processedAt',
  provider = 'provider',
  rollbackAt = 'rollbackAt',
  rollbackInitializedAt = 'rollbackInitializedAt'
}

/** Status of a payment */
export enum PaymentStatus {
  CancelInitialized = 'CancelInitialized',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Initialized = 'Initialized',
  RollbackInitialized = 'RollbackInitialized',
  RolledBacked = 'RolledBacked'
}

/** Type of a payment */
export enum PaymentType {
  Deposit = 'Deposit',
  Withdrawal = 'Withdrawal'
}

export enum PayoutStatus {
  Cancelled = 'Cancelled',
  Created = 'Created',
  Failed = 'Failed',
  Processed = 'Processed'
}

/** View of the pending KYC flow of a player */
export type PendingKycFlowViewItem = {
  __typename: 'PendingKycFlowViewItem';
  flowId: Scalars['ID']['output'];
  kycCheckDeadline: Scalars['OffsetDateTime']['output'];
  kycCheckStartedAt: Scalars['OffsetDateTime']['output'];
  playerGlobalId: Scalars['ID']['output'];
  playerGlobalUUID: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  playerUUID: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type PendingKycFlowViewItemConnection = {
  __typename: 'PendingKycFlowViewItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PendingKycFlowViewItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PendingKycFlowViewItemEdge = {
  __typename: 'PendingKycFlowViewItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PendingKycFlowViewItem;
};

/** The order to list pending KYC flow results */
export enum PendingKycFlowViewSearchOrder {
  kycCheckDeadline = 'kycCheckDeadline',
  kycCheckStartedAt = 'kycCheckStartedAt',
  playerGlobalId = 'playerGlobalId',
  playerId = 'playerId'
}

/** Pending limit. */
export type PendingLimit = {
  __typename: 'PendingLimit';
  /** Date of configuration. */
  configuredAt: Scalars['OffsetDateTime']['output'];
  /** Date when limit will take effect. */
  validFrom: Scalars['OffsetDateTime']['output'];
  /** Value of the pending limit. */
  value: Maybe<Scalars['BigDecimal']['output']>;
};

/** A PEP and sanctions player list export details. */
export type PepAndSanctionsPlayerListExportDetails = {
  __typename: 'PepAndSanctionsPlayerListExportDetails';
  url: Scalars['String']['output'];
};

/** KYC6 Pep Tier */
export enum PepTier {
  Tier1 = 'Tier1',
  Tier2 = 'Tier2',
  Tier3 = 'Tier3'
}

/** Period limit. */
export type PeriodLimit = {
  __typename: 'PeriodLimit';
  /** Available amount. */
  available: Scalars['BigDecimal']['output'];
  /** Date of configuration. */
  configuredAt: Scalars['OffsetDateTime']['output'];
  /** Date when current limit period ends */
  currentPeriodEndTime: Scalars['OffsetDateTime']['output'];
  /** True means the limit is coming from the configuration, can't be removed */
  isDefault: Scalars['Boolean']['output'];
  /** How long a period last before resetting. */
  limitPeriodType: Scalars['String']['output'];
  /** Period limit that is waiting to take effect. */
  pendingPeriodLimit: Maybe<PendingLimit>;
  /** Period removal limit that is waiting to take effect. */
  pendingPeriodLimitRemoval: Maybe<PendingLimit>;
  /** Value of the limit. */
  value: Scalars['BigDecimal']['output'];
};

/** A connection to a list of items. */
export type PhoneLoginHistoryConnection = {
  __typename: 'PhoneLoginHistoryConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PhoneLoginHistoryEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PhoneLoginHistoryEdge = {
  __typename: 'PhoneLoginHistoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PhoneLoginHistoryItem;
};

/** Phone login history item */
export type PhoneLoginHistoryItem = {
  __typename: 'PhoneLoginHistoryItem';
  authenticationMethodId: Scalars['String']['output'];
  eventId: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  /** The ID of an object */
  id: Scalars['ID']['output'];
  initiator: Initiator;
  playerId: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
};

/** A player. */
export type Player = EntityWithStatistics & Node & {
  __typename: 'Player';
  accountStatus: AccountStatus;
  affiliateInfo: Maybe<AffiliateInfo>;
  areWithdrawalsBlocked: Scalars['Boolean']['output'];
  /** Information about the player's authentication method */
  authenticationMethod: Maybe<AuthenticationMethod>;
  birthDate: Maybe<Scalars['String']['output']>;
  brand: Brand;
  /**
   * Checks if a player is eligible for a reward
   * @deprecated use calculateRewardV2 instead
   */
  calculateReward: PlayerCalculatedReward;
  /** Checks if a player is eligible for a reward */
  calculateRewardV2: PlayerCalculatedRewardV2;
  city: Maybe<Scalars['String']['output']>;
  /** Bonus codes this player currently holds, most recent claim first */
  claimedBonusCodes: BonusCodeClaimConnection;
  /** Compliance related limits for the player across all brands */
  complianceGlobalPlayerLimits: Array<ComplianceGlobalPlayerLimit>;
  /** The country where the player is registered to live (ISO 3166-1). */
  countryCode: Maybe<Scalars['String']['output']>;
  /** The customer which this player belongs to */
  customer: Maybe<Customer>;
  depositInfoV2: Maybe<DepositInfo>;
  documents: DocumentConnection;
  email: Maybe<Scalars['String']['output']>;
  financialDataV2: Maybe<PlayerFinancialData>;
  firstName: Maybe<Scalars['String']['output']>;
  gameRounds: GameRoundItemConnection;
  gender: Maybe<Scalars['String']['output']>;
  geoLocationBlockStatus: GeoLocationBlockStatus;
  /** Checks a player block status for gamification with Gamanza */
  getGamanzaPlayerBlockStatus: PlayerGamificationBlockStatus;
  /** Global Limits history */
  globalLimits: GlobalLimitSearchItemConnection;
  /** Information about the player's global login attempts */
  globalLoginAttemptsInfo: Maybe<GlobalLoginAttemptsInfo>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  instantBankingBlock: Maybe<InstantBankingBlock>;
  isEmailMarketingAccepted: Maybe<Scalars['Boolean']['output']>;
  isEmailVerified: Scalars['Boolean']['output'];
  /** @deprecated Use instantBankingBlock instead, it contains more detailed info */
  isInstantBankingBlocked: Scalars['Boolean']['output'];
  isPep: Scalars['Boolean']['output'];
  isPhoneMarketingAccepted: Maybe<Scalars['Boolean']['output']>;
  isPhoneNumberVerified: Scalars['Boolean']['output'];
  /**
   * Checks if a player is blocked or not for gamification with Gamanza
   * @deprecated Use getGamanzaPlayerBlockStatus instead
   */
  isPlayerBlockedInGamanza: Scalars['Boolean']['output'];
  isSmsMarketingAccepted: Maybe<Scalars['Boolean']['output']>;
  isSupportingMultiCurrency: Scalars['Boolean']['output'];
  /** Indicates if a player is a test account */
  isTestAccount: Scalars['Boolean']['output'];
  isWebPushMarketingAccepted: Maybe<Scalars['Boolean']['output']>;
  kycCheckStatus: Maybe<KycCheckStatus>;
  language: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  /** Limits history */
  limits: LimitSearchItemConnection;
  linkedAccounts: Array<LinkedAccounts>;
  loginInfo: Maybe<PlayerLoginInfo>;
  marketingPreferences: MarketingPreferences;
  middleName: Maybe<Scalars['String']['output']>;
  /** Player migration information */
  migration: Maybe<PlayerMigration>;
  /** Returns multiple wallets if the brand supports multi-currency, HEAVY OPERATION, only use it for single player view pages. */
  multipleWallets: Maybe<MultipleWallets>;
  notes: NoteConnection;
  notesV2: NoteConnection;
  payments: PaymentConnection;
  phoneLoginHistory: PhoneLoginHistoryConnection;
  phoneNumber: Maybe<Scalars['String']['output']>;
  phoneNumberChangedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  playerComplianceDetails: Maybe<PlayerCompliance>;
  playerComplianceDetailsV2: Maybe<PlayerComplianceV2>;
  playerComplianceDetailsV3: Maybe<PlayerComplianceV3>;
  /** Player gamification details (gamanza card) */
  playerGamificationDetails: Maybe<PlayerGamificationDetails>;
  playerGlobalId: Maybe<Scalars['ID']['output']>;
  playerGlobalUUID: Maybe<Scalars['String']['output']>;
  playerKycHistory: PlayerKycHistoryItemConnection;
  /** List of assigned rewards to players. It's sorted by updatedAt desc if none it's provided */
  playerRewards: PlayerRewardFlatItemConnection;
  /** Player statistics */
  playerStats: Maybe<PlayerStats>;
  /** Ids of all players that are tied to the same source of wealth requirements */
  playersLinkedBySourceOfWealth: Maybe<Array<playerLinkedBySoW>>;
  providedSourceOfFunds: BoSourceOfFundsType;
  rawPlayerId: Scalars['String']['output'];
  /** The RG customer risk assessment for the player */
  rgCraCustomerRiskAssessment: Maybe<RgCraCustomerRiskAssessment>;
  /** The RG customer risk assessment for the player */
  rgCraV2CustomerRiskAssessment: Maybe<RgCraV2GamingCustomerRiskAssessment>;
  riskAssessment: Maybe<CustomerRiskAssessment>;
  /** Screening Statuses of the player */
  screeningStatuses: Maybe<ScreeningStatuses>;
  secondLastName: Maybe<Scalars['String']['output']>;
  selfExclusionDetails: Maybe<SelfExclusionDetails>;
  selfExclusionHistory: SelfExclusionHistoryItemConnection;
  shouldReopenAt: Maybe<Scalars['OffsetDateTime']['output']>;
  /** Player gamification details in smartico */
  smarticoGamificationDetails: Maybe<SmarticoGamificationDetails>;
  sourceOfWealth: Maybe<SourceOfWealth>;
  sowBlockedStatus: Maybe<SowBlockedStatus>;
  ssn: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  /** Statistics. */
  stats: Maybe<StatsType>;
  street: Maybe<Scalars['String']['output']>;
  suppressionGroups: Array<SuppressionGroupType>;
  title: Maybe<Scalars['String']['output']>;
  transactionsV2: TransactionSearchItemConnection;
  translatedPersonalInfo: Maybe<TranslatedPersonalInfo>;
  /** Trustly identifier for DE and NL */
  trustlyKycEntityId: Maybe<Scalars['String']['output']>;
  /** @deprecated Use upcomingCashbackV4 */
  upcomingCashbackV2: Maybe<CashbackTransactionItem>;
  /** @deprecated Use upcomingCashbackV4 */
  upcomingCashbackV3: Maybe<UpcomingCashbackItem>;
  upcomingCashbackV4: UpcomingCashbackItemV2;
  /** @deprecated Use upcomingRakebackV2 */
  upcomingRakeback: Maybe<UpcomingRakebackItem>;
  /** @deprecated Use upcomingRakebackV2 */
  upcomingRakebackV2: UpcomingRakebackItemV2;
  username: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  verificationLog: Maybe<PlayerVerificationLog>;
  verificationTypes: Maybe<PlayerKYCVerifiedItem>;
  wallet: Maybe<Wallet>;
  walletWithGlobalLimits: Maybe<Wallet>;
  zipCode: Maybe<Scalars['String']['output']>;
};


/** A player. */
export type PlayerclaimedBonusCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A player. */
export type PlayerdocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DocumentSearchOrder>;
};


/** A player. */
export type PlayergameRoundsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  gameId?: InputMaybe<Scalars['String']['input']>;
  gameProviderId?: InputMaybe<GameProvider>;
  gameRoundCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  gameRoundId?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GameRoundSearchOrder>;
  status?: InputMaybe<GameRoundStatus>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


/** A player. */
export type PlayerglobalLimitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limitPeriodType?: InputMaybe<LimitTypeEnum>;
  limitStatus?: InputMaybe<LimitStatusEnum>;
  limitType?: InputMaybe<LimitType>;
  orderBy?: InputMaybe<LimitSearchOrder>;
};


/** A player. */
export type PlayerlimitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  indexPrefix?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limitPeriodType?: InputMaybe<LimitTypeEnum>;
  limitStatus?: InputMaybe<LimitStatusEnum>;
  limitType?: InputMaybe<LimitType>;
  orderBy?: InputMaybe<LimitSearchOrder>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


/** A player. */
export type PlayermultipleWalletsArgs = {
  displayCurrency?: InputMaybe<Scalars['String']['input']>;
};


/** A player. */
export type PlayernotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<NoteCategoryEnum>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PlayerNoteSearchOrder>;
  priority?: InputMaybe<PriorityEnum>;
};


/** A player. */
export type PlayernotesV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<NoteCategoryEnum>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PlayerNoteSearchOrder>>;
  priority?: InputMaybe<PriorityEnum>;
};


/** A player. */
export type PlayerpaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  indexPrefix?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PaymentSearchOrder>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  paymentType?: InputMaybe<PaymentType>;
  rawId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


/** A player. */
export type PlayerphoneLoginHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A player. */
export type PlayerplayerKycHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  getOnlyLatestKycPerPlayer?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  kycProvider?: InputMaybe<KycProviderType>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PlayerKycHistorySearchOrder>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


/** A player. */
export type PlayerplayerRewardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignationId?: InputMaybe<Scalars['String']['input']>;
  assignedAtFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  assignedAtTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SearchPlayerRewardsOrderBy>;
  rewardId?: InputMaybe<Scalars['String']['input']>;
  rewardStatus?: InputMaybe<PlayerRewardStatus>;
  rewardStatusList?: InputMaybe<Array<PlayerRewardStatus>>;
  rewardSystem?: InputMaybe<RewardTargetSystem>;
  rewardTypes?: InputMaybe<Array<RewardTypeEnum>>;
  updatedAtFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  updatedAtTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


/** A player. */
export type PlayerplayerStatsArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** A player. */
export type PlayerselfExclusionHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  indexPrefix?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A player. */
export type PlayerstatsArgs = {
  dataSourceVersion?: InputMaybe<DataSourceVersionEnum>;
  exchangeRateBaseCurrency?: InputMaybe<Scalars['String']['input']>;
  exchangeRateDate?: InputMaybe<Scalars['LocalDate']['input']>;
  from: Scalars['OffsetDateTime']['input'];
  granularity: GranularityEnum;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ColumnOrderSpecType>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['OffsetDateTime']['input'];
};


/** A player. */
export type PlayertransactionsV2Args = {
  adjustmentCategory?: InputMaybe<AdjustmentCategory>;
  adjustmentType?: InputMaybe<AdjustmentType>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  externalTransactionId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  gameRoundId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxAmount?: InputMaybe<Scalars['PositiveBigDecimal']['input']>;
  minAmount?: InputMaybe<Scalars['PositiveBigDecimal']['input']>;
  orderBy?: InputMaybe<TransactionSearchOrder>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<Array<PaymentStatus>>;
  rawId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  transactionTypes?: InputMaybe<Array<TransactionType>>;
};


/** A player. */
export type PlayerupcomingCashbackV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A player. */
export type PlayerupcomingCashbackV3Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A player. */
export type PlayerupcomingCashbackV4Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A player. */
export type PlayerupcomingRakebackArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A player. */
export type PlayerupcomingRakebackV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Information regarding the player's address */
export type PlayerAddressInfo = {
  __typename: 'PlayerAddressInfo';
  city: Maybe<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['String']['output']>;
  district: Maybe<Scalars['String']['output']>;
  fullAddress: Scalars['String']['output'];
  state: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
  zipCode: Maybe<Scalars['String']['output']>;
};

export type PlayerCalculatedReward = {
  __typename: 'PlayerCalculatedReward';
  currency: Scalars['String']['output'];
  ineligibilityReasons: Array<Scalars['String']['output']>;
  lastBonusAtTimestamp: Maybe<Scalars['Long']['output']>;
  ngr: Scalars['BigDecimal']['output'];
  ngrSinceLastManualReward: Scalars['BigDecimal']['output'];
  playerCurrentSegment: Maybe<Scalars['String']['output']>;
  playerKycStatus: Maybe<Scalars['String']['output']>;
  playerLastClosureCause: Maybe<Scalars['String']['output']>;
  playerRgCraRisk: Maybe<Scalars['String']['output']>;
  playerSelfExcluded: Scalars['Boolean']['output'];
  playerSowBlocked: Scalars['Boolean']['output'];
  reward: Maybe<CalculatedReward>;
};

/** Player calculated reward with OffsetDateTime for lastBonusAt */
export type PlayerCalculatedRewardV2 = {
  __typename: 'PlayerCalculatedRewardV2';
  currency: Scalars['String']['output'];
  ineligibilityReasons: Array<Scalars['String']['output']>;
  lastBonusAt: Maybe<Scalars['OffsetDateTime']['output']>;
  ngr: Scalars['BigDecimal']['output'];
  ngrSinceLastManualReward: Scalars['BigDecimal']['output'];
  playerCurrentSegment: Maybe<Scalars['String']['output']>;
  playerKycStatus: Maybe<Scalars['String']['output']>;
  playerLastClosureCause: Maybe<Scalars['String']['output']>;
  playerRgCraRisk: Maybe<Scalars['String']['output']>;
  playerSelfExcluded: Scalars['Boolean']['output'];
  playerSowBlocked: Scalars['Boolean']['output'];
  reward: Maybe<CalculatedReward>;
};

/** Player compliance item */
export type PlayerCompliance = {
  __typename: 'PlayerCompliance';
  brand: Brand;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  needsManualReview: Scalars['Boolean']['output'];
  playerId: Scalars['String']['output'];
  rawPlayerId: Scalars['String']['output'];
  requiredDocumentTypes: Array<FundingOption>;
  requiresSubmissionSince: Maybe<Scalars['OffsetDateTime']['output']>;
  risk: AmlRiskLevel;
  status: PlayerComplianceStatus;
};

/** Player compliance details item */
export type PlayerComplianceDetails = {
  __typename: 'PlayerComplianceDetails';
  brand: Brand;
  playerId: Scalars['String']['output'];
  playerUUID: Scalars['String']['output'];
};

/** Player compliance details grouped by their playerGlobalId */
export type PlayerComplianceGroupedV2 = {
  __typename: 'PlayerComplianceGroupedV2';
  limitReachedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  needsManualReview: Scalars['Boolean']['output'];
  playerGlobalId: Scalars['String']['output'];
  playerGlobalUUID: Scalars['String']['output'];
  players: Array<PlayerComplianceDetails>;
  risk: AmlRiskLevel;
  startedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  status: PlayerComplianceStatus;
  statusChangedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  submittedAt: Maybe<Scalars['OffsetDateTime']['output']>;
};

/** An entry in the SoW history */
export type PlayerComplianceHistorySearchItem = {
  eventType: Scalars['String']['output'];
  initiatorV2: Maybe<Initiator>;
  playerGlobalId: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  playerUUID: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type PlayerComplianceHistorySearchItemConnection = {
  __typename: 'PlayerComplianceHistorySearchItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PlayerComplianceHistorySearchItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlayerComplianceHistorySearchItemEdge = {
  __typename: 'PlayerComplianceHistorySearchItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PlayerComplianceHistorySearchItem;
};

/** The field by which to order the search results. */
export enum PlayerComplianceHistorySearchOrder {
  globalPlayerId = 'globalPlayerId',
  playerId = 'playerId',
  processedAt = 'processedAt'
}

/** The compliance status of a player */
export enum PlayerComplianceStatus {
  FormSubmitted = 'FormSubmitted',
  Pending = 'Pending',
  PendingDocuments = 'PendingDocuments',
  Rejected = 'Rejected',
  UploadedDocuments = 'UploadedDocuments',
  Verified = 'Verified'
}

/** Player compliance item */
export type PlayerComplianceV2 = {
  __typename: 'PlayerComplianceV2';
  brand: Brand;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  needsManualReview: Scalars['Boolean']['output'];
  playerGlobalId: Scalars['String']['output'];
  requiredDocumentTypes: Array<FundingOption>;
  requiresSubmissionSince: Maybe<Scalars['OffsetDateTime']['output']>;
  risk: AmlRiskLevel;
  status: PlayerComplianceStatus;
};

/** Player compliance item */
export type PlayerComplianceV3 = {
  __typename: 'PlayerComplianceV3';
  brand: Brand;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  needsManualReview: Scalars['Boolean']['output'];
  playerGlobalId: Scalars['String']['output'];
  requiredDocumentTypes: Array<RequestedFundingDocument>;
  requiresSubmissionSince: Maybe<Scalars['OffsetDateTime']['output']>;
  risk: AmlRiskLevel;
  status: PlayerComplianceStatus;
};

/** A connection to a list of items. */
export type PlayerComplianceV3Connection = {
  __typename: 'PlayerComplianceV3Connection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PlayerComplianceV3Edge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlayerComplianceV3Edge = {
  __typename: 'PlayerComplianceV3Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PlayerComplianceGroupedV2;
};

/** A players export details. */
export type PlayerExportDetails = {
  __typename: 'PlayerExportDetails';
  url: Scalars['String']['output'];
};

/** Player financial data. */
export type PlayerFinancialData = {
  __typename: 'PlayerFinancialData';
  /** Amount of total GGR. */
  ggr: Scalars['BigDecimal']['output'];
  /** Amount of hold. */
  hold: Scalars['BigDecimal']['output'];
  /** Amount of total NGR. */
  ngr: Scalars['BigDecimal']['output'];
  /** Id of the player */
  playerId: Scalars['ID']['output'];
  /** Total deposits. */
  totalDepositAmount: Scalars['BigDecimal']['output'];
  /** Total withdrawals. */
  totalWithdrawalAmount: Scalars['BigDecimal']['output'];
};

/** Player gamification block status */
export type PlayerGamificationBlockStatus = {
  __typename: 'PlayerGamificationBlockStatus';
  isBlocked: Scalars['Boolean']['output'];
  updatedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  updatedBy: Maybe<Initiator>;
};

/** Player gamification */
export type PlayerGamificationDetails = {
  __typename: 'PlayerGamificationDetails';
  level: Scalars['Int']['output'];
  rank: Scalars['String']['output'];
  tokens: Scalars['BigDecimal']['output'];
  xpPoints: Scalars['BigDecimal']['output'];
};

/** Player Id Per Brand */
export type PlayerIdPerBrand = {
  __typename: 'PlayerIdPerBrand';
  /** Brand */
  brand: Brand;
  playerId: Scalars['ID']['output'];
  playerUUID: Scalars['String']['output'];
};

/** PlayerInfoHistory */
export type PlayerInfoHistory = {
  __typename: 'PlayerInfoHistory';
  eventType: Scalars['String']['output'];
  initiator: Initiator;
  player: PlayerSearchItem;
  processedAt: Scalars['OffsetDateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type PlayerInfoHistoryItemConnection = {
  __typename: 'PlayerInfoHistoryItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PlayerInfoHistoryItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlayerInfoHistoryItemEdge = {
  __typename: 'PlayerInfoHistoryItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PlayerInfoHistory;
};

/** Player information */
export type PlayerInformation = {
  __typename: 'PlayerInformation';
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  dateOfBirth: Scalars['LocalDate']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phoneNumber: Scalars['PhoneNumber']['output'];
  street: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

/** An entry in the compliance history */
export type PlayerInformationHistoryDocument = {
  __typename: 'PlayerInformationHistoryDocument';
  eventId: Scalars['String']['output'];
  eventType: PlayerInformationHistoryEventType;
  id: Scalars['String']['output'];
  initiator: Maybe<Initiator>;
  playerGlobalId: Maybe<Scalars['ID']['output']>;
  playerGlobalUUID: Maybe<Scalars['String']['output']>;
  playerId: Maybe<Scalars['ID']['output']>;
  playerUUID: Maybe<Scalars['String']['output']>;
  service: Service;
  timestamp: Scalars['OffsetDateTime']['output'];
  value: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type PlayerInformationHistoryDocumentConnection = {
  __typename: 'PlayerInformationHistoryDocumentConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PlayerInformationHistoryDocumentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlayerInformationHistoryDocumentEdge = {
  __typename: 'PlayerInformationHistoryDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PlayerInformationHistoryDocument;
};

/** The type of event in the player information history */
export enum PlayerInformationHistoryEventType {
  CustomerCancelWithdrawalBlocked = 'CustomerCancelWithdrawalBlocked',
  CustomerCancelWithdrawalUnblocked = 'CustomerCancelWithdrawalUnblocked',
  CustomerDepositsBlocked = 'CustomerDepositsBlocked',
  CustomerDepositsUnblocked = 'CustomerDepositsUnblocked',
  CustomerGamanzaBlocked = 'CustomerGamanzaBlocked',
  CustomerGamanzaUnblocked = 'CustomerGamanzaUnblocked',
  CustomerIncreaseDepositLimitBlocked = 'CustomerIncreaseDepositLimitBlocked',
  CustomerIncreaseDepositLimitUnblocked = 'CustomerIncreaseDepositLimitUnblocked',
  CustomerMarketingBlocked = 'CustomerMarketingBlocked',
  CustomerMarketingUnblocked = 'CustomerMarketingUnblocked',
  CustomerPopUpNeeded = 'CustomerPopUpNeeded',
  CustomerPopUpSeen = 'CustomerPopUpSeen',
  CustomerRemovedFromRgWhiteList = 'CustomerRemovedFromRgWhiteList',
  CustomerRewardsBlocked = 'CustomerRewardsBlocked',
  CustomerRewardsUnblocked = 'CustomerRewardsUnblocked',
  CustomerRgNetDepositLimitDisabled = 'CustomerRgNetDepositLimitDisabled',
  CustomerRgNetDepositLimitEnabled = 'CustomerRgNetDepositLimitEnabled',
  CustomerRgWhiteListed = 'CustomerRgWhiteListed',
  CustomerStatusClosed = 'CustomerStatusClosed',
  CustomerStatusReopened = 'CustomerStatusReopened',
  IndividualSearchTriggered = 'IndividualSearchTriggered',
  Kyc6MatchFound = 'Kyc6MatchFound',
  MonitoringUpdateReceived = 'MonitoringUpdateReceived',
  PingwireGatewayBankingCddNotification = 'PingwireGatewayBankingCddNotification',
  PlayerIdLinkedToGlobalId = 'PlayerIdLinkedToGlobalId',
  PlayerIdUnlinkedFromGlobalId = 'PlayerIdUnlinkedFromGlobalId',
  StatusOverwriteChanged = 'StatusOverwriteChanged',
  SubmittedKyc6MatchDecision = 'SubmittedKyc6MatchDecision',
  VerifiedStatusChanged = 'VerifiedStatusChanged'
}

/** The field to order by */
export enum PlayerInformationHistoryOrderBy {
  processedAt = 'processedAt'
}

/** Input type for basic player information */
export type PlayerInformationInput = {
  city: Scalars['NonEmptyString']['input'];
  countryCode: Scalars['NonEmptyString']['input'];
  dateOfBirth: Scalars['LocalDate']['input'];
  email: Scalars['NonEmptyString']['input'];
  firstName: Scalars['NonEmptyString']['input'];
  lastName: Scalars['NonEmptyString']['input'];
  phoneNumber: Scalars['PhoneNumber']['input'];
  street: Scalars['NonEmptyString']['input'];
  zipCode: Scalars['NonEmptyString']['input'];
};

export type PlayerInitiator = {
  __typename: 'PlayerInitiator';
  player: Maybe<Player>;
};

/** A player kyc item */
export type PlayerKYCHistoryItem = {
  __typename: 'PlayerKYCHistoryItem';
  city: Maybe<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['String']['output']>;
  dateOfBirth: Maybe<Scalars['LocalDate']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  gender: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  initiator: Initiator;
  kycProvider: Scalars['String']['output'];
  lastName: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  playerId: Scalars['ID']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  rawPlayerId: Scalars['String']['output'];
  ssn: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  zipCode: Maybe<Scalars['String']['output']>;
};

/** Player KYC Validation status. */
export type PlayerKYCValidationItem = {
  __typename: 'PlayerKYCValidationItem';
  aboutToExpireValidations: Array<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  expiredValidations: Array<Scalars['String']['output']>;
  pendingDocumentIds: Array<Scalars['String']['output']>;
  pendingValidations: Array<Scalars['String']['output']>;
  playerId: Scalars['ID']['output'];
  rawPlayerId: Scalars['String']['output'];
  rejectedDocumentIds: Array<Scalars['String']['output']>;
  upToDateValidations: Array<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type PlayerKYCValidationItemConnection = {
  __typename: 'PlayerKYCValidationItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PlayerKYCValidationItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlayerKYCValidationItemEdge = {
  __typename: 'PlayerKYCValidationItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PlayerKYCValidationItem;
};

/** KYC validated verifications */
export type PlayerKYCVerifiedItem = {
  __typename: 'PlayerKYCVerifiedItem';
  expiredVerifications: Array<DocumentVerificationType>;
  playerId: Scalars['ID']['output'];
  rawPlayerId: Scalars['String']['output'];
  upToDateVerifications: Array<VerificationWithProvider>;
};

/** A connection to a list of items. */
export type PlayerKycHistoryItemConnection = {
  __typename: 'PlayerKycHistoryItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PlayerKycHistoryItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlayerKycHistoryItemEdge = {
  __typename: 'PlayerKycHistoryItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PlayerKYCHistoryItem;
};

/** The order to list player kyc history results */
export enum PlayerKycHistorySearchOrder {
  kycProvider = 'kycProvider',
  processedAt = 'processedAt'
}

/** Player label. */
export type PlayerLabel = {
  __typename: 'PlayerLabel';
  color: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Player login info. */
export type PlayerLoginInfo = {
  __typename: 'PlayerLoginInfo';
  /** Is player currently on a login throttle long block. */
  isOnLongBlock: Scalars['Boolean']['output'];
  /** Is player currently on a login throttle short block. */
  isOnShortBlock: Scalars['Boolean']['output'];
  lastLogin: PlayerLoginInfoData;
  registration: PlayerLoginInfoData;
  utmParameters: Maybe<UtmParameters>;
};

/** Player login info. */
export type PlayerLoginInfoData = {
  __typename: 'PlayerLoginInfoData';
  /** An ISO 3166-1 country code from where the player logged in. */
  countryCode: Maybe<Scalars['String']['output']>;
  ip: Scalars['String']['output'];
  loggedAt: Scalars['String']['output'];
};

/** Player migration information */
export type PlayerMigration = {
  __typename: 'PlayerMigration';
  fromBrand: Scalars['String']['output'];
  fromPlayerId: Scalars['String']['output'];
  status: PlayerMigrationStatus;
};

/** The status of a player migration */
export enum PlayerMigrationStatus {
  Completed = 'Completed',
  Failed = 'Failed',
  InProgress = 'InProgress',
  NotStarted = 'NotStarted'
}

/** The order to list transaction search results. */
export enum PlayerNoteSearchOrder {
  createdAt = 'createdAt',
  priority = 'priority',
  priorityValue = 'priorityValue'
}

/** SoW history entry for PEP status set */
export type PlayerPepStatusSetItem = PlayerComplianceHistorySearchItem & {
  __typename: 'PlayerPepStatusSetItem';
  eventType: Scalars['String']['output'];
  /** @deprecated Use initiatorV2 */
  initiator: Initiator;
  initiatorV2: Maybe<Initiator>;
  isPep: Scalars['Boolean']['output'];
  playerGlobalId: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  playerUUID: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** The challenge progress of a player for a given challenge */
export type PlayerProgressItem = {
  __typename: 'PlayerProgressItem';
  challengeCriteriaCompleted: Scalars['Int']['output'];
  /** @deprecated Use challengeCriteriaRemainingV2 instead */
  challengeCriteriaRemaining: Array<ChallengeCriteria>;
  challengeCriteriaRemainingV2: Array<ChallengeCriteriaV2>;
  challengeCriteriaTotal: Scalars['Int']['output'];
  challengeId: Scalars['ID']['output'];
  challengeName: Scalars['String']['output'];
  challengeRewards: Array<ChallengeRewardV2>;
  challengeUUID: Scalars['String']['output'];
  endDate: Maybe<Scalars['OffsetDateTime']['output']>;
  globalPlayerUUID: Maybe<Scalars['String']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  joinedAt: Scalars['OffsetDateTime']['output'];
  playerId: Scalars['ID']['output'];
  playerProgressId: Scalars['String']['output'];
  playerUUID: Scalars['String']['output'];
  startDate: Scalars['OffsetDateTime']['output'];
  status: PlayerProgressStatus;
  timesCompleted: Scalars['Int']['output'];
  timesRestarted: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type PlayerProgressItemConnection = {
  __typename: 'PlayerProgressItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PlayerProgressItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlayerProgressItemEdge = {
  __typename: 'PlayerProgressItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PlayerProgressItem;
};

/** Possible player challenge progress statuses */
export enum PlayerProgressStatus {
  Assigned = 'Assigned',
  Completed = 'Completed',
  Ended = 'Ended',
  Unassigned = 'Unassigned'
}

export type PlayerRewardAssignation = {
  assignationId?: InputMaybe<Scalars['String']['input']>;
  playerId: Scalars['String']['input'];
};

/** Player reward item which contains information about a reward for a given player */
export type PlayerRewardFlatItem = {
  __typename: 'PlayerRewardFlatItem';
  agent: Maybe<Agent>;
  assignationId: Maybe<Scalars['String']['output']>;
  assignedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  playerId: Scalars['String']['output'];
  reason: Maybe<Scalars['String']['output']>;
  reward: RewardItem;
  status: PlayerRewardStatus;
  updatedAt: Scalars['OffsetDateTime']['output'];
};

/** A connection to a list of items. */
export type PlayerRewardFlatItemConnection = {
  __typename: 'PlayerRewardFlatItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PlayerRewardFlatItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlayerRewardFlatItemEdge = {
  __typename: 'PlayerRewardFlatItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PlayerRewardFlatItem;
};

/** Status of a reward for a given player */
export enum PlayerRewardStatus {
  Credited = 'Credited',
  Expired = 'Expired',
  FailedProcessing = 'FailedProcessing',
  Processing = 'Processing',
  Removed = 'Removed',
  Scheduled = 'Scheduled',
  Unclaimed = 'Unclaimed'
}

/** A player search item. */
export type PlayerSearchItem = EntityWithStatistics & {
  __typename: 'PlayerSearchItem';
  accountStatus: Scalars['String']['output'];
  addressInfo: Maybe<PlayerAddressInfo>;
  /** @deprecated Get this field from the object 'registrationInfo' instead */
  affiliateId: Maybe<Scalars['String']['output']>;
  /** @deprecated Get this field from the object 'registrationInfo' instead */
  affiliateToken: Maybe<Scalars['String']['output']>;
  areWithdrawalsBlocked: Scalars['Boolean']['output'];
  balance: Maybe<Scalars['BigDecimal']['output']>;
  birthDate: Maybe<Scalars['String']['output']>;
  brand: Maybe<Brand>;
  closeAccountCause: Maybe<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['String']['output']>;
  currency: Maybe<Scalars['ISOCurrencyCode']['output']>;
  emailInfo: EmailInfo;
  emailMarketingSuppressionGroup: Maybe<SuppressionGroupType>;
  firstName: Maybe<Scalars['String']['output']>;
  gender: Maybe<Scalars['String']['output']>;
  /** Deprecated - always null. Superseded by geoLocationStateStatus, geoLocationVpnStatus and geoLocationManualBlock. */
  geoLocationBlockStatus: Maybe<GeoLocationBlockStatus>;
  geoLocationManualBlock: Maybe<Scalars['Boolean']['output']>;
  geoLocationStateStatus: Maybe<GeoLocationStateStatus>;
  geoLocationVpnStatus: Maybe<GeoLocationVpnStatus>;
  instantBankingBlock: Maybe<InstantBankingBlock>;
  /** @deprecated Use instantBankingBlock instead, it contains more detailed info */
  isInstantBankingBlocked: Scalars['Boolean']['output'];
  isPhoneMarketingAccepted: Maybe<Scalars['Boolean']['output']>;
  isSmsMarketingAccepted: Maybe<Scalars['Boolean']['output']>;
  isTestAccount: Scalars['Boolean']['output'];
  labels: Array<PlayerLabel>;
  language: Maybe<Scalars['String']['output']>;
  /** @deprecated Get this field from the object 'loginInfo' instead */
  lastLoginAt: Maybe<Scalars['OffsetDateTime']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  loginInfo: Maybe<LoginInfo>;
  marketingBlocked: Scalars['Boolean']['output'];
  middleName: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  player: Player;
  playerGlobalId: Maybe<Scalars['ID']['output']>;
  playerGlobalUUID: Maybe<Scalars['String']['output']>;
  playerId: Scalars['ID']['output'];
  privacyPolicyAccepted: Maybe<Scalars['OffsetDateTime']['output']>;
  rawPlayerId: Scalars['String']['output'];
  /** @deprecated Get this field from the object 'registrationInfo' instead */
  registeredAt: Maybe<Scalars['OffsetDateTime']['output']>;
  /** @deprecated Use registrationInfoV2 instead */
  registrationInfo: Maybe<RegistrationInfo>;
  registrationInfoV2: Maybe<RegistrationInfo>;
  secondLastName: Maybe<Scalars['String']['output']>;
  shouldReopenAt: Maybe<Scalars['OffsetDateTime']['output']>;
  ssn: Maybe<Scalars['String']['output']>;
  /** Statistics. */
  stats: Maybe<StatsType>;
  title: Maybe<Scalars['String']['output']>;
  translatedPersonalInfoDocument: Maybe<TranslatedPersonalInfoDocument>;
  username: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};


/** A player search item. */
export type PlayerSearchItemstatsArgs = {
  dataSourceVersion?: InputMaybe<DataSourceVersionEnum>;
  exchangeRateBaseCurrency?: InputMaybe<Scalars['String']['input']>;
  exchangeRateDate?: InputMaybe<Scalars['LocalDate']['input']>;
  from: Scalars['OffsetDateTime']['input'];
  granularity: GranularityEnum;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ColumnOrderSpecType>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['OffsetDateTime']['input'];
};

/** A connection to a list of items. */
export type PlayerSearchItemConnection = {
  __typename: 'PlayerSearchItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PlayerSearchItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlayerSearchItemEdge = {
  __typename: 'PlayerSearchItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: PlayerSearchItem;
};

/** The order to list player search results. */
export enum PlayerSearchOrder {
  balance = 'balance',
  brand = 'brand',
  city = 'city',
  countryCode = 'countryCode',
  dateOfBirth = 'dateOfBirth',
  firstName = 'firstName',
  lastLoginAt = 'lastLoginAt',
  lastName = 'lastName',
  phoneNumber = 'phoneNumber',
  playerGlobalUUID = 'playerGlobalUUID',
  playerId = 'playerId',
  registeredAt = 'registeredAt',
  zipCode = 'zipCode'
}

/** Player stats */
export type PlayerStats = {
  __typename: 'PlayerStats';
  currency: Scalars['String']['output'];
  lastBonusAt: Maybe<Scalars['String']['output']>;
  ngr: Scalars['BigDecimal']['output'];
  ngrSinceLastManualReward: Scalars['BigDecimal']['output'];
  playerCurrentSegment: Maybe<Scalars['String']['output']>;
  playerId: Scalars['ID']['output'];
};

/** Player verification log. */
export type PlayerVerificationLog = {
  __typename: 'PlayerVerificationLog';
  code: Maybe<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['String']['output']>;
  ip: Maybe<Scalars['String']['output']>;
  target: Scalars['String']['output'];
  type: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  verificationSentAt: Scalars['String']['output'];
  verifiedAt: Maybe<Scalars['String']['output']>;
};

/** A player wallet summary */
export type PlayerWalletType = {
  __typename: 'PlayerWalletType';
  /** The ID of an object */
  id: Scalars['ID']['output'];
  /** Id of the player */
  playerId: Scalars['ID']['output'];
  playerUUID: Scalars['String']['output'];
  /** the wallet of the player */
  wallet: Maybe<Wallet>;
};

/** Priorities. */
export enum PriorityEnum {
  HIGH = 'HIGH',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM'
}

export type Query = {
  __typename: 'Query';
  /** Fetches an object given its ID */
  node: Maybe<Node>;
  /** Fetches objects given their IDs */
  nodes: Array<Maybe<Node>>;
  player: Player;
  playerGlobal: GlobalPlayer;
  viewer: Viewer;
};


export type QuerynodeArgs = {
  id: Scalars['ID']['input'];
};


export type QuerynodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryplayerArgs = {
  playerId: Scalars['ID']['input'];
};


export type QueryplayerGlobalArgs = {
  playerGlobalId: Scalars['ID']['input'];
};

export type RangeDate = {
  from: Scalars['OffsetDateTime']['input'];
  to: Scalars['OffsetDateTime']['input'];
};

export type RangeInt = {
  from: Scalars['Int']['input'];
  to: Scalars['Int']['input'];
};

/** A sub-part of the total risk assessment. Is made up of several rules */
export type Region = {
  __typename: 'Region';
  /** The final score of the region. How much this region will contribute to the total risk assessment final score */
  finalScore: Scalars['BigDecimal']['output'];
  /** The maximum total score possible for the region */
  maxScore: Scalars['Int']['output'];
  /** The unweighted percentage of the region */
  percentage: Scalars['BigDecimal']['output'];
  /** The name of the region */
  regionName: Scalars['String']['output'];
  /** If an agent review is required */
  reviewRequired: Scalars['Boolean']['output'];
  /** A list of risks that belong to this region */
  risks: Array<Risk>;
  /** The total score of all rules of the region */
  score: Scalars['Int']['output'];
  /** The percentage of how much this region contributes to the total risk assessment */
  weight: Scalars['BigDecimal']['output'];
};

/** Information regarding the registration of the player */
export type RegistrationInfo = {
  __typename: 'RegistrationInfo';
  affiliateId: Maybe<Scalars['String']['output']>;
  affiliateToken: Maybe<Scalars['String']['output']>;
  registeredAt: Scalars['OffsetDateTime']['output'];
  registrationIp: Scalars['String']['output'];
  registrationIpCountryCode: Scalars['String']['output'];
};

/** Registration scheme */
export enum RegistrationScheme {
  ByBrite = 'ByBrite',
  ByEmailPassword = 'ByEmailPassword',
  ByFinshark = 'ByFinshark',
  ByPhoneNumber = 'ByPhoneNumber',
  BySimpleRegistration = 'BySimpleRegistration',
  BySsn = 'BySsn',
  ByTrustly = 'ByTrustly',
  ByZimpler = 'ByZimpler',
  NotRegisteredYet = 'NotRegisteredYet'
}

/** Registration status: Registered or NotRegistered */
export enum RegistrationStatusFilter {
  PlayerNotRegistered = 'PlayerNotRegistered',
  PlayerRegistered = 'PlayerRegistered'
}

export type RequestedFundingDocument = {
  __typename: 'RequestedFundingDocument';
  comment: Maybe<Scalars['String']['output']>;
  requestedFundingType: FundingOption;
};

/** SoW history entry for SoW funding documents removed */
export type RequestedFundingDocumentsRemovedItem = PlayerComplianceHistorySearchItem & {
  __typename: 'RequestedFundingDocumentsRemovedItem';
  comment: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  /** @deprecated Use initiatorV2 */
  initiator: Initiator;
  initiatorV2: Maybe<Initiator>;
  playerGlobalId: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  playerUUID: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  remainingRequestedDocuments: Array<FundingOption>;
  removedRequestedDocuments: Array<FundingOption>;
  uuid: Scalars['String']['output'];
};

export type RequestedFundingType = {
  comment?: InputMaybe<Scalars['String']['input']>;
  requestedFundingType: FundingOption;
};

/** Reserved Balance Adjustment Type */
export enum ReservedAdjustmentType {
  Decrease = 'Decrease',
  Increase = 'Increase'
}

/** Restriction */
export enum Restriction {
  GAMBLING = 'GAMBLING',
  LOTTO = 'LOTTO',
  TOTO = 'TOTO',
  UNSPECIFIED = 'UNSPECIFIED'
}

/** Review approved for some trigger */
export type ReviewApproved = Outcome & {
  __typename: 'ReviewApproved';
  /** The name of the outcome */
  name: Scalars['String']['output'];
  reviewTrigger: ReviewTrigger;
};

/** Review needed because of some trigger */
export type ReviewNeeded = Outcome & {
  __typename: 'ReviewNeeded';
  /** The name of the outcome */
  name: Scalars['String']['output'];
  reviewTrigger: ReviewTrigger;
};

/** Review not needed anymore after risk reevaluation */
export type ReviewNotNeeded = Outcome & {
  __typename: 'ReviewNotNeeded';
  /** The name of the outcome */
  name: Scalars['String']['output'];
};

/** Review pending for some trigger */
export type ReviewPending = Outcome & {
  __typename: 'ReviewPending';
  /** The name of the outcome */
  name: Scalars['String']['output'];
};

/** Review rejected for some trigger */
export type ReviewRejected = Outcome & {
  __typename: 'ReviewRejected';
  /** The name of the outcome */
  name: Scalars['String']['output'];
  reviewTrigger: ReviewTrigger;
};

/** Review Status. */
export enum ReviewStatus {
  ReviewApproved = 'ReviewApproved',
  ReviewNeeded = 'ReviewNeeded',
  ReviewNotNeeded = 'ReviewNotNeeded',
  ReviewPending = 'ReviewPending',
  ReviewRejected = 'ReviewRejected'
}

/** Info about the review status */
export type ReviewStatusInfo = {
  __typename: 'ReviewStatusInfo';
  /** Timestamp when the last review happened */
  lastReviewed: Maybe<Scalars['OffsetDateTime']['output']>;
  /** Timestamp when status was last changed */
  processedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  /** The current review status */
  status: ReviewStatus;
};

/** Review trigger */
export type ReviewTrigger = {
  __typename: 'ReviewTrigger';
  byOverallRiskLevel: Scalars['Boolean']['output'];
  byRisks: Array<RiskPath>;
};

/** Review trigger */
export type ReviewTriggerArg = {
  byOverallRiskLevel: Scalars['Boolean']['input'];
  byRisks: Array<RiskPathArg>;
};

/** A reward item */
export type RewardItem = {
  __typename: 'RewardItem';
  campaignId: Scalars['CampaignId']['output'];
  claimType: ClaimType;
  comments: Scalars['String']['output'];
  createdAt: Scalars['OffsetDateTime']['output'];
  createdBy: Maybe<Agent>;
  displayName: Maybe<Scalars['String']['output']>;
  endsAt: Maybe<Scalars['OffsetDateTime']['output']>;
  expiresIn: Maybe<Scalars['Duration']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  players: PlayerRewardFlatItemConnection;
  rewardId: Scalars['String']['output'];
  rewardReason: RewardReason;
  rewardSystem: RewardTargetSystem;
  rewardType: RewardType;
  startsAt: Scalars['OffsetDateTime']['output'];
  status: RewardStatus;
  totalPlayers: Scalars['Long']['output'];
};


/** A reward item */
export type RewardItemplayersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignedAtFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  assignedAtTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  rewardStatus?: InputMaybe<PlayerRewardStatus>;
  rewardStatusList?: InputMaybe<Array<PlayerRewardStatus>>;
  updatedAtFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  updatedAtTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};

/** A connection to a list of items. */
export type RewardItemConnection = {
  __typename: 'RewardItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RewardItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RewardItemEdge = {
  __typename: 'RewardItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RewardItem;
};

/** The profile for a reward template */
export type RewardProfile = BonusRewardProfile | FreespinsRewardProfile | MoneyRewardProfile;

/** RewardType element of a template profile */
export enum RewardProfileType {
  bonus = 'bonus',
  freespins = 'freespins',
  money = 'money'
}

/** Purpose of the reward. e.g: Incentive, Cashback... */
export enum RewardReason {
  Cashback = 'Cashback',
  Incentive = 'Incentive',
  Rakeback = 'Rakeback'
}

/** Possible reward statuses */
export enum RewardStatus {
  Active = 'Active',
  Expired = 'Expired',
  Inactive = 'Inactive',
  NotCreated = 'NotCreated',
  Scheduled = 'Scheduled'
}

/** Reward target systems */
export enum RewardTargetSystem {
  Gamanza = 'Gamanza',
  IWinBack = 'IWinBack',
  Internal = 'Internal',
  Smartico = 'Smartico'
}

export type RewardTemplateType = BonusMoneyTemplate | FreespinsTemplate | MoneyTemplate | SportsbookMoneyTemplate;

/** Details about a reward */
export type RewardType = {
  name: Scalars['String']['output'];
};

/** Reward types */
export enum RewardTypeEnum {
  BonusMoneyDropType = 'BonusMoneyDropType',
  FreeSpinsType = 'FreeSpinsType',
  MoneyDropType = 'MoneyDropType',
  SportsbookMoneyDropType = 'SportsbookMoneyDropType',
  Unknown = 'Unknown'
}

/** The type of event in the risk history */
export enum RgCraAutomationEventType {
  BonusesBlocked = 'BonusesBlocked',
  BonusesEnabled = 'BonusesEnabled',
  CustomerRemovedFromRgWhitelist = 'CustomerRemovedFromRgWhitelist',
  CustomerRgWhitelisted = 'CustomerRgWhitelisted',
  DepositLimitChangesBlocked = 'DepositLimitChangesBlocked',
  DepositsDisabled = 'DepositsDisabled',
  EmailSent = 'EmailSent',
  GamanzaBlocked = 'GamanzaBlocked',
  GamanzaUnblocked = 'GamanzaUnblocked',
  MarketingBlocked = 'MarketingBlocked',
  MarketingUnblocked = 'MarketingUnblocked',
  PeriodicEmailSent = 'PeriodicEmailSent',
  PlayerAccountsClosed = 'PlayerAccountsClosed',
  PopupDisplayed = 'PopupDisplayed',
  ReturnFromLongSelfExclusionEmailSent = 'ReturnFromLongSelfExclusionEmailSent',
  ReturnFromShortSelfExclusionEmailSent = 'ReturnFromShortSelfExclusionEmailSent',
  RgNetDepositLimitApplied = 'RgNetDepositLimitApplied',
  RiskLevelUpdated = 'RiskLevelUpdated',
  StateAdjustmentApplied = 'StateAdjustmentApplied',
  Unspecified = 'Unspecified',
  WithdrawalsCancellationDisabled = 'WithdrawalsCancellationDisabled',
  WithdrawalsCancellationEnabled = 'WithdrawalsCancellationEnabled'
}

/** RG Automation actions history for a global player */
export type RgCraAutomationHistoryItem = {
  __typename: 'RgCraAutomationHistoryItem';
  eventId: Scalars['String']['output'];
  eventType: RgCraAutomationEventType;
  extraInformation: Maybe<Scalars['String']['output']>;
  playerGlobalId: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  regionId: Maybe<Scalars['String']['output']>;
  regionName: Maybe<Scalars['String']['output']>;
  riskId: Maybe<Scalars['String']['output']>;
  riskLevelAfter: Maybe<RgCraAutomationRiskLevel>;
  riskLevelBefore: Maybe<RgCraAutomationRiskLevel>;
  riskName: Maybe<Scalars['String']['output']>;
  suspendedBy: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type RgCraAutomationHistoryItemConnection = {
  __typename: 'RgCraAutomationHistoryItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RgCraAutomationHistoryItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RgCraAutomationHistoryItemEdge = {
  __typename: 'RgCraAutomationHistoryItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RgCraAutomationHistoryItem;
};

/** The type of event in the legacy (V1) automation history */
export enum RgCraAutomationLegacyEventType {
  BonusesBlocked = 'BonusesBlocked',
  BonusesEnabled = 'BonusesEnabled',
  CustomerRemovedFromRgWhitelist = 'CustomerRemovedFromRgWhitelist',
  CustomerRgWhitelisted = 'CustomerRgWhitelisted',
  DepositLimitChangesBlocked = 'DepositLimitChangesBlocked',
  DepositsDisabled = 'DepositsDisabled',
  EmailSent = 'EmailSent',
  GamanzaBlocked = 'GamanzaBlocked',
  GamanzaUnblocked = 'GamanzaUnblocked',
  MarketingBlocked = 'MarketingBlocked',
  MarketingUnblocked = 'MarketingUnblocked',
  PeriodicEmailSent = 'PeriodicEmailSent',
  PlayerAccountsClosed = 'PlayerAccountsClosed',
  PopupDisplayed = 'PopupDisplayed',
  ReturnFromLongSelfExclusionEmailSent = 'ReturnFromLongSelfExclusionEmailSent',
  ReturnFromShortSelfExclusionEmailSent = 'ReturnFromShortSelfExclusionEmailSent',
  RgNetDepositLimitApplied = 'RgNetDepositLimitApplied',
  RiskLevelUpdated = 'RiskLevelUpdated',
  StateAdjustmentApplied = 'StateAdjustmentApplied',
  Unspecified = 'Unspecified',
  WithdrawalsCancellationDisabled = 'WithdrawalsCancellationDisabled',
  WithdrawalsCancellationEnabled = 'WithdrawalsCancellationEnabled'
}

/** Legacy (V1) RG Automation actions history for a global player */
export type RgCraAutomationLegacyHistoryItem = {
  __typename: 'RgCraAutomationLegacyHistoryItem';
  eventId: Scalars['String']['output'];
  eventType: RgCraAutomationLegacyEventType;
  extraInformation: Maybe<Scalars['String']['output']>;
  playerGlobalId: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  regionId: Maybe<Scalars['String']['output']>;
  regionName: Maybe<Scalars['String']['output']>;
  riskId: Maybe<Scalars['String']['output']>;
  riskLevelAfter: Maybe<RgCraAutomationV2RiskLevel>;
  riskLevelBefore: Maybe<RgCraAutomationV2RiskLevel>;
  riskName: Maybe<Scalars['String']['output']>;
  suspendedBy: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type RgCraAutomationLegacyHistoryItemConnection = {
  __typename: 'RgCraAutomationLegacyHistoryItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RgCraAutomationLegacyHistoryItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RgCraAutomationLegacyHistoryItemEdge = {
  __typename: 'RgCraAutomationLegacyHistoryItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RgCraAutomationLegacyHistoryItem;
};

/** RG-CRA Automation Risk Levels */
export enum RgCraAutomationRiskLevel {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
  VeryHigh = 'VeryHigh'
}

/** The type of event in the risk history */
export enum RgCraAutomationV2EventType {
  AccountClosed = 'AccountClosed',
  AccountReopened = 'AccountReopened',
  AggregatedRiskLevelUpdated = 'AggregatedRiskLevelUpdated',
  BonusesBlocked = 'BonusesBlocked',
  BonusesUnblocked = 'BonusesUnblocked',
  CustomerRemovedFromRgWhitelist = 'CustomerRemovedFromRgWhitelist',
  CustomerRgWhitelisted = 'CustomerRgWhitelisted',
  DepositsBlocked = 'DepositsBlocked',
  DepositsUnblocked = 'DepositsUnblocked',
  GamanzaBlocked = 'GamanzaBlocked',
  GamanzaUnblocked = 'GamanzaUnblocked',
  MarketingBlocked = 'MarketingBlocked',
  MarketingUnblocked = 'MarketingUnblocked',
  PeriodicEmailSent = 'PeriodicEmailSent',
  PopupRequested = 'PopupRequested',
  ReturnFromLongSelfExclusionEmailSent = 'ReturnFromLongSelfExclusionEmailSent',
  ReturnFromShortSelfExclusionEmailSent = 'ReturnFromShortSelfExclusionEmailSent',
  RgAssessmentEmailSent = 'RgAssessmentEmailSent',
  RgNetDepositLimitApplied = 'RgNetDepositLimitApplied',
  RgNetDepositLimitRemoved = 'RgNetDepositLimitRemoved',
  Unspecified = 'Unspecified'
}

/** RG Automation actions history for a global player */
export type RgCraAutomationV2HistoryItem = {
  __typename: 'RgCraAutomationV2HistoryItem';
  eventId: Scalars['String']['output'];
  eventType: RgCraAutomationV2EventType;
  extraInformation: Maybe<Scalars['String']['output']>;
  playerGlobalId: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  riskLevelAfter: Maybe<RgCraAutomationV2RiskLevel>;
  riskLevelBefore: Maybe<RgCraAutomationV2RiskLevel>;
  suspendedBy: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type RgCraAutomationV2HistoryItemConnection = {
  __typename: 'RgCraAutomationV2HistoryItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RgCraAutomationV2HistoryItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RgCraAutomationV2HistoryItemEdge = {
  __typename: 'RgCraAutomationV2HistoryItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RgCraAutomationV2HistoryItem;
};

/** RG-CRA Automation Risk Levels */
export enum RgCraAutomationV2RiskLevel {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
  Unspecified = 'Unspecified',
  VeryHigh = 'VeryHigh'
}

export type RgCraCustomerRiskAssessment = {
  __typename: 'RgCraCustomerRiskAssessment';
  /** The last time the risk assessment was calculated */
  calculatedAt: Scalars['OffsetDateTime']['output'];
  /** Kyc Status for the player global id */
  kycCheckStatus: KycCheckStatus;
  /** If exists, this it the system risk level based on the score. This means that the risk level has been manually overwritten */
  overriddenRiskLevel: Maybe<RgCraRiskLevel>;
  /** Player Global Id */
  playerGlobalId: Scalars['String']['output'];
  /** Players that belong to this risk assessment */
  players: Array<Player>;
  /** A list of the different CRA regions that make up the final score */
  regions: Array<RgCraRegion>;
  /** Current review status */
  reviewStatusInfo: RgCraReviewStatusInfo;
  /** Needs to be passed back in submitReview mutation. Can be considered a token */
  reviewTrigger: RgCraReviewTrigger;
  rgCraNotificationCounters: RgCraNotificationsCounters;
  /** The final risk level of the player */
  riskLevel: RgCraRiskLevel;
};

/** A connection to a list of items. */
export type RgCraCustomerRiskAssessmentConnection = {
  __typename: 'RgCraCustomerRiskAssessmentConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RgCraCustomerRiskAssessmentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RgCraCustomerRiskAssessmentEdge = {
  __typename: 'RgCraCustomerRiskAssessmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RgCraCustomerRiskAssessment;
};

/** An entry in the risk history */
export type RgCraCustomerRiskAssessmentHistoryItem = {
  __typename: 'RgCraCustomerRiskAssessmentHistoryItem';
  comment: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  eventType: RgCraEventType;
  initiator: Maybe<Initiator>;
  outcomes: Array<RgCraOutcome>;
  playerGlobalId: Scalars['String']['output'];
  playerId: Maybe<Scalars['String']['output']>;
  processedAt: Scalars['OffsetDateTime']['output'];
};

/** A connection to a list of items. */
export type RgCraCustomerRiskAssessmentHistoryItemConnection = {
  __typename: 'RgCraCustomerRiskAssessmentHistoryItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RgCraCustomerRiskAssessmentHistoryItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RgCraCustomerRiskAssessmentHistoryItemEdge = {
  __typename: 'RgCraCustomerRiskAssessmentHistoryItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RgCraCustomerRiskAssessmentHistoryItem;
};

/** The type of event in the risk history */
export enum RgCraEventType {
  ManualRiskUpdate = 'ManualRiskUpdate',
  ReviewApproved = 'ReviewApproved',
  ReviewNeeded = 'ReviewNeeded',
  ReviewNotNeeded = 'ReviewNotNeeded',
  ReviewPending = 'ReviewPending',
  ReviewRejected = 'ReviewRejected',
  RiskLevelOverridden = 'RiskLevelOverridden',
  RiskLevelOverrideRemoved = 'RiskLevelOverrideRemoved',
  RiskRemoved = 'RiskRemoved',
  RiskUpdated = 'RiskUpdated'
}

export type RgCraNotificationsCounter = {
  __typename: 'RgCraNotificationsCounter';
  /** counter for the whole player lifecycle */
  lifecycleCount: Scalars['Int']['output'];
  /** notification type */
  notificationType: Scalars['String']['output'];
  /** counter for the period established */
  periodCount: Scalars['Int']['output'];
  /** days of the period for this counter */
  periodDays: Scalars['Int']['output'];
};

export type RgCraNotificationsCounters = {
  __typename: 'RgCraNotificationsCounters';
  /** counter for communication indicators complain requests */
  commIndicatorsCounter: RgCraNotificationsCounter;
  /** counter for player payout requests */
  payoutsRequestCounter: RgCraNotificationsCounter;
  /** counter for player reward requests */
  rewardsRequestCounter: RgCraNotificationsCounter;
};

/** The outcome of a risk event */
export type RgCraOutcome = {
  /** The name of the outcome */
  comment: Maybe<Scalars['String']['output']>;
  /** The name of the outcome */
  name: Scalars['String']['output'];
};

/** The outcome of a risk event in the history */
export enum RgCraOutcomeEnum {
  FinalRiskLevelUpdated = 'FinalRiskLevelUpdated',
  ReviewApproved = 'ReviewApproved',
  ReviewNeeded = 'ReviewNeeded',
  ReviewNotNeeded = 'ReviewNotNeeded',
  ReviewPending = 'ReviewPending',
  ReviewRejected = 'ReviewRejected',
  RiskLevelUpdated = 'RiskLevelUpdated',
  RiskOverrideAdded = 'RiskOverrideAdded',
  RiskOverrideRemoved = 'RiskOverrideRemoved',
  RiskRemoved = 'RiskRemoved'
}

/** A sub-part of the total risk assessment. Is made up of several rules */
export type RgCraRegion = {
  __typename: 'RgCraRegion';
  /** The name of the region */
  regionName: Scalars['String']['output'];
  /** The risk level of this region risk */
  regionRiskLevel: RgCraRiskLevel;
  /** If an agent review is required */
  reviewRequired: Scalars['Boolean']['output'];
  /** A list of risks that belong to this region */
  risks: Array<RgCraRisk>;
};

/** Review Status */
export enum RgCraReviewStatus {
  ReviewApproved = 'ReviewApproved',
  ReviewNeeded = 'ReviewNeeded',
  ReviewNotNeeded = 'ReviewNotNeeded',
  ReviewPending = 'ReviewPending',
  ReviewRejected = 'ReviewRejected'
}

/** Info about the review status */
export type RgCraReviewStatusInfo = {
  __typename: 'RgCraReviewStatusInfo';
  /** Timestamp when the last review happened */
  lastReviewed: Maybe<Scalars['OffsetDateTime']['output']>;
  /** Timestamp when status was last changed */
  processedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  /** The current review status */
  status: RgCraReviewStatus;
};

/** Review trigger */
export type RgCraReviewTrigger = {
  __typename: 'RgCraReviewTrigger';
  byOverallRiskLevel: Scalars['Boolean']['output'];
  byRisks: Array<RgCraRiskPath>;
};

/** Review trigger */
export type RgCraReviewTriggerArg = {
  byOverallRiskLevel: Scalars['Boolean']['input'];
  byRisks: Array<RgCraRiskPathArg>;
};

/** The result of a risk calculation attributing a risk score */
export type RgCraRisk = {
  __typename: 'RgCraRisk';
  /** The last time this risk was calculated */
  calculatedAt: Scalars['OffsetDateTime']['output'];
  /** Is an agent review required */
  reviewRequired: Scalars['Boolean']['output'];
  /** The id of the risk */
  riskId: Scalars['String']['output'];
  /** The risk level of this particular risk */
  riskLevel: RgCraRiskLevel;
  /** The name of the risk */
  riskName: Scalars['String']['output'];
};

/** The field to order by */
export enum RgCraRiskAggregationOrderBy {
  calculatedAt = 'calculatedAt',
  reviewStatus = 'reviewStatus',
  riskLevel = 'riskLevel'
}

/** Risk assessment report */
export type RgCraRiskAssessmentReport = {
  __typename: 'RgCraRiskAssessmentReport';
  url: Scalars['String']['output'];
};

/** The field to order by */
export enum RgCraRiskHistoryOrderBy {
  processedAt = 'processedAt'
}

/** RG-CRA Risk Levels */
export enum RgCraRiskLevel {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
  VeryHigh = 'VeryHigh'
}

/** risk path */
export type RgCraRiskPath = {
  __typename: 'RgCraRiskPath';
  regionId: Scalars['String']['output'];
  riskId: Scalars['String']['output'];
};

/** Risk path */
export type RgCraRiskPathArg = {
  regionId: Scalars['String']['input'];
  riskId: Scalars['String']['input'];
};

export type RgCraRiskTerm = {
  riskId: Scalars['String']['input'];
  riskLevel: RgCraRiskLevel;
};

/** The type of review that is submitted */
export enum RgCraSubmitReviewStatus {
  ReviewApproved = 'ReviewApproved',
  ReviewPending = 'ReviewPending',
  ReviewRejected = 'ReviewRejected'
}

/** An entry in the V2 risk history */
export type RgCraV2CustomerRiskAssessmentHistoryItem = {
  __typename: 'RgCraV2CustomerRiskAssessmentHistoryItem';
  comment: Maybe<Scalars['String']['output']>;
  eventId: Scalars['String']['output'];
  eventType: RgCraV2EventType;
  initiator: Maybe<Initiator>;
  outcomes: Array<RgCraV2Outcome>;
  playerGlobalId: Scalars['String']['output'];
  playerId: Maybe<Scalars['String']['output']>;
  processedAt: Scalars['OffsetDateTime']['output'];
};

/** A connection to a list of items. */
export type RgCraV2CustomerRiskAssessmentHistoryItemConnection = {
  __typename: 'RgCraV2CustomerRiskAssessmentHistoryItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RgCraV2CustomerRiskAssessmentHistoryItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RgCraV2CustomerRiskAssessmentHistoryItemEdge = {
  __typename: 'RgCraV2CustomerRiskAssessmentHistoryItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RgCraV2CustomerRiskAssessmentHistoryItem;
};

/** The type of event in the V2 risk history */
export enum RgCraV2EventType {
  LegacyStateMigrated = 'LegacyStateMigrated',
  ManualRiskUpdate = 'ManualRiskUpdate',
  ReviewApproved = 'ReviewApproved',
  ReviewNeeded = 'ReviewNeeded',
  ReviewNotNeeded = 'ReviewNotNeeded',
  ReviewPending = 'ReviewPending',
  ReviewRejected = 'ReviewRejected',
  RiskAggregationUpdated = 'RiskAggregationUpdated',
  RiskLevelOverridden = 'RiskLevelOverridden',
  RiskLevelOverrideRemoved = 'RiskLevelOverrideRemoved',
  RiskRemoved = 'RiskRemoved',
  RiskUpdated = 'RiskUpdated',
  Unspecified = 'Unspecified'
}

/** The final/overall risk level has changed */
export type RgCraV2FinalRiskLevelUpdated = RgCraV2Outcome & {
  __typename: 'RgCraV2FinalRiskLevelUpdated';
  /** Optional comment on the outcome */
  comment: Maybe<Scalars['String']['output']>;
  /** The name of the outcome */
  name: Scalars['String']['output'];
  /** The final risk level after this event */
  riskLevel: RgCraV2RiskLevel;
  /** The final risk level before this event */
  riskLevelBefore: RgCraV2RiskLevel;
};

export type RgCraV2GamingCustomerRiskAssessment = {
  __typename: 'RgCraV2GamingCustomerRiskAssessment';
  /** The last time the risk assessment was calculated */
  calculatedAt: Scalars['OffsetDateTime']['output'];
  /** The weighted final score */
  finalScore: Scalars['BigDecimal']['output'];
  /** Kyc Status for the player global id */
  kycCheckStatus: KycCheckStatus;
  /** The maximum possible total score */
  maxScore: Scalars['Int']['output'];
  /** The manually overridden risk level if set */
  overriddenRiskLevel: Maybe<RgCraV2RiskLevel>;
  /** The overall percentage score */
  percentage: Scalars['BigDecimal']['output'];
  /** Player Global Id */
  playerGlobalId: Scalars['String']['output'];
  /** Players that belong to this risk assessment */
  players: Array<Player>;
  /** A list of the different CRA regions that make up the final score */
  regions: Array<RgCraV2Region>;
  /** Current review status */
  reviewStatusInfo: RgCraV2ReviewStatusInfo;
  /** Needs to be passed back in submitReview mutation */
  reviewTrigger: RgCraV2ReviewTrigger;
  rgCraNotificationCounters: RgCraV2NotificationsCounters;
  /** The final risk level of the player */
  riskLevel: RgCraV2RiskLevel;
  /** The raw total score */
  score: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type RgCraV2GamingCustomerRiskAssessmentConnection = {
  __typename: 'RgCraV2GamingCustomerRiskAssessmentConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RgCraV2GamingCustomerRiskAssessmentEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RgCraV2GamingCustomerRiskAssessmentEdge = {
  __typename: 'RgCraV2GamingCustomerRiskAssessmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: RgCraV2GamingCustomerRiskAssessment;
};

export type RgCraV2NotificationsCounter = {
  __typename: 'RgCraV2NotificationsCounter';
  /** counter for the whole player lifecycle */
  lifecycleCount: Scalars['Int']['output'];
  /** notification type */
  notificationType: Scalars['String']['output'];
  /** counter for the period established */
  periodCount: Scalars['Int']['output'];
  /** days of the period for this counter */
  periodDays: Scalars['Int']['output'];
};

export type RgCraV2NotificationsCounters = {
  __typename: 'RgCraV2NotificationsCounters';
  /** counter for communication indicators */
  commIndicatorsCounter: RgCraV2NotificationsCounter;
  /** counter for player payout requests */
  payoutsRequestCounter: RgCraV2NotificationsCounter;
  /** counter for player reward requests */
  rewardsRequestCounter: RgCraV2NotificationsCounter;
};

/** The outcome of a V2 risk event */
export type RgCraV2Outcome = {
  /** Optional comment on the outcome */
  comment: Maybe<Scalars['String']['output']>;
  /** The name of the outcome */
  name: Scalars['String']['output'];
};

/** The outcome of a V2 risk event in the history */
export enum RgCraV2OutcomeEnum {
  FinalRiskLevelUpdated = 'FinalRiskLevelUpdated',
  ReviewApproved = 'ReviewApproved',
  ReviewNeeded = 'ReviewNeeded',
  ReviewNotNeeded = 'ReviewNotNeeded',
  ReviewPending = 'ReviewPending',
  ReviewRejected = 'ReviewRejected',
  RiskLevelUpdated = 'RiskLevelUpdated',
  RiskOverrideAdded = 'RiskOverrideAdded',
  RiskOverrideRemoved = 'RiskOverrideRemoved',
  RiskRemoved = 'RiskRemoved'
}

/** A sub-part of the total V2 risk assessment made up of several rules */
export type RgCraV2Region = {
  __typename: 'RgCraV2Region';
  /** The weighted final score for this region */
  finalScore: Scalars['BigDecimal']['output'];
  /** The maximum possible score for this region */
  maxScore: Scalars['Int']['output'];
  /** The percentage score for this region */
  percentage: Scalars['BigDecimal']['output'];
  /** The name of the region */
  regionName: Scalars['String']['output'];
  /** The risk level of this region */
  regionRiskLevel: RgCraV2RiskLevel;
  /** If an agent review is required */
  reviewRequired: Scalars['Boolean']['output'];
  /** A list of risks that belong to this region */
  risks: Array<RgCraV2Risk>;
  /** The raw score for this region */
  score: Scalars['Int']['output'];
  /** The weight of this region in the total score */
  weight: Scalars['BigDecimal']['output'];
};

/** Review approved */
export type RgCraV2ReviewApproved = RgCraV2Outcome & {
  __typename: 'RgCraV2ReviewApproved';
  /** Optional comment on the outcome */
  comment: Maybe<Scalars['String']['output']>;
  /** The name of the outcome */
  name: Scalars['String']['output'];
  reviewTrigger: RgCraV2ReviewTrigger;
};

/** Review needed because of some trigger */
export type RgCraV2ReviewNeeded = RgCraV2Outcome & {
  __typename: 'RgCraV2ReviewNeeded';
  /** Optional comment on the outcome */
  comment: Maybe<Scalars['String']['output']>;
  /** The name of the outcome */
  name: Scalars['String']['output'];
  reviewTrigger: RgCraV2ReviewTrigger;
};

/** Review not needed anymore after risk reevaluation */
export type RgCraV2ReviewNotNeeded = RgCraV2Outcome & {
  __typename: 'RgCraV2ReviewNotNeeded';
  /** Optional comment on the outcome */
  comment: Maybe<Scalars['String']['output']>;
  /** The name of the outcome */
  name: Scalars['String']['output'];
};

/** Review pending */
export type RgCraV2ReviewPending = RgCraV2Outcome & {
  __typename: 'RgCraV2ReviewPending';
  /** Optional comment on the outcome */
  comment: Maybe<Scalars['String']['output']>;
  /** The name of the outcome */
  name: Scalars['String']['output'];
};

/** Review rejected */
export type RgCraV2ReviewRejected = RgCraV2Outcome & {
  __typename: 'RgCraV2ReviewRejected';
  /** Optional comment on the outcome */
  comment: Maybe<Scalars['String']['output']>;
  /** The name of the outcome */
  name: Scalars['String']['output'];
  reviewTrigger: RgCraV2ReviewTrigger;
};

/** V2 Review Status */
export enum RgCraV2ReviewStatus {
  ReviewApproved = 'ReviewApproved',
  ReviewNeeded = 'ReviewNeeded',
  ReviewNotNeeded = 'ReviewNotNeeded',
  ReviewPending = 'ReviewPending',
  ReviewRejected = 'ReviewRejected'
}

/** Info about the V2 review status */
export type RgCraV2ReviewStatusInfo = {
  __typename: 'RgCraV2ReviewStatusInfo';
  /** Timestamp when the last review happened */
  lastReviewed: Maybe<Scalars['OffsetDateTime']['output']>;
  /** Timestamp when status was last changed */
  processedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  /** The current review status */
  status: RgCraV2ReviewStatus;
};

/** V2 review trigger */
export type RgCraV2ReviewTrigger = {
  __typename: 'RgCraV2ReviewTrigger';
  byOverallRiskLevel: Scalars['Boolean']['output'];
  byRisks: Array<RgCraV2RiskPath>;
};

/** V2 review trigger input */
export type RgCraV2ReviewTriggerArg = {
  byOverallRiskLevel: Scalars['Boolean']['input'];
  byRisks: Array<RgCraV2RiskPathArg>;
};

/** The result of a V2 risk calculation */
export type RgCraV2Risk = {
  __typename: 'RgCraV2Risk';
  /** The last time this risk was calculated */
  calculatedAt: Scalars['OffsetDateTime']['output'];
  /** The maximum possible score for this risk */
  maxScore: Scalars['Int']['output'];
  /** Is an agent review required */
  reviewRequired: Scalars['Boolean']['output'];
  /** The id of the risk */
  riskId: Scalars['String']['output'];
  /** The risk level of this risk */
  riskLevel: RgCraV2RiskLevel;
  /** The name of the risk */
  riskName: Scalars['String']['output'];
  /** The raw score for this risk */
  score: Scalars['Int']['output'];
};

/** The field to order by */
export enum RgCraV2RiskAggregationOrderBy {
  calculatedAt = 'calculatedAt',
  lastReviewedAt = 'lastReviewedAt',
  reviewStatus = 'reviewStatus',
  riskLevel = 'riskLevel'
}

/** V2 Risk assessment report */
export type RgCraV2RiskAssessmentReport = {
  __typename: 'RgCraV2RiskAssessmentReport';
  url: Scalars['String']['output'];
};

/** The field to order by */
export enum RgCraV2RiskHistoryOrderBy {
  processedAt = 'processedAt'
}

/** RG-CRA V2 Risk Levels */
export enum RgCraV2RiskLevel {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium',
  VeryHigh = 'VeryHigh'
}

/** The risk level of an individual risk criteria was updated */
export type RgCraV2RiskLevelUpdated = RgCraV2Outcome & {
  __typename: 'RgCraV2RiskLevelUpdated';
  /** Optional comment on the outcome */
  comment: Maybe<Scalars['String']['output']>;
  /** Human-readable explanation of how the risk level was calculated */
  explanation: Maybe<Scalars['String']['output']>;
  /** The name of the outcome */
  name: Scalars['String']['output'];
  /** The region id of the risk */
  regionId: Scalars['String']['output'];
  /** The region name */
  regionName: Scalars['String']['output'];
  /** The risk id of the risk */
  riskId: Scalars['String']['output'];
  /** The risk level after the event */
  riskLevel: RgCraV2RiskLevel;
  /** The risk level before the event */
  riskLevelBefore: RgCraV2RiskLevel;
  /** The risk name */
  riskName: Scalars['String']['output'];
};

/** An override to the final/overall risk level was added */
export type RgCraV2RiskOverrideAdded = RgCraV2Outcome & {
  __typename: 'RgCraV2RiskOverrideAdded';
  /** Optional comment on the outcome */
  comment: Maybe<Scalars['String']['output']>;
  /** The name of the outcome */
  name: Scalars['String']['output'];
  /** The risk level of the override that was added */
  riskLevel: RgCraV2RiskLevel;
};

/** An override to the final/overall risk level was removed */
export type RgCraV2RiskOverrideRemoved = RgCraV2Outcome & {
  __typename: 'RgCraV2RiskOverrideRemoved';
  /** Optional comment on the outcome */
  comment: Maybe<Scalars['String']['output']>;
  /** The name of the outcome */
  name: Scalars['String']['output'];
  /** The risk level of the override that was removed */
  riskLevel: RgCraV2RiskLevel;
};

/** V2 risk path */
export type RgCraV2RiskPath = {
  __typename: 'RgCraV2RiskPath';
  regionId: Scalars['String']['output'];
  riskId: Scalars['String']['output'];
};

/** V2 risk path input */
export type RgCraV2RiskPathArg = {
  regionId: Scalars['String']['input'];
  riskId: Scalars['String']['input'];
};

/** Risk removed */
export type RgCraV2RiskRemoved = RgCraV2Outcome & {
  __typename: 'RgCraV2RiskRemoved';
  /** Optional comment on the outcome */
  comment: Maybe<Scalars['String']['output']>;
  /** The name of the outcome */
  name: Scalars['String']['output'];
  /** The region id of the risk */
  regionId: Scalars['String']['output'];
  /** The risk id of the risk */
  riskId: Scalars['String']['output'];
};

export type RgCraV2RiskTerm = {
  riskId: Scalars['String']['input'];
  riskLevel: RgCraV2RiskLevel;
};

/** The type of V2 review that is submitted */
export enum RgCraV2SubmitReviewStatus {
  ReviewApproved = 'ReviewApproved',
  ReviewPending = 'ReviewPending',
  ReviewRejected = 'ReviewRejected'
}

/** The result of a risk calculation attributing a risk score */
export type Risk = {
  __typename: 'Risk';
  /** The last time this risk was calculated */
  calculatedAt: Scalars['OffsetDateTime']['output'];
  /** The maximum score possible for this risk */
  maxScore: Scalars['Int']['output'];
  /** Is an agent review required */
  reviewRequired: Scalars['Boolean']['output'];
  /** The id of the risk */
  riskId: Scalars['String']['output'];
  /** The risk level of this particular risk */
  riskLevel: RiskLevel;
  /** The name of the risk */
  riskName: Scalars['String']['output'];
  /** The score that this risk contributes to the region */
  score: Scalars['Int']['output'];
};

/** The field to order by */
export enum RiskAggregationOrderBy {
  calculatedAt = 'calculatedAt',
  finalScore = 'finalScore',
  reviewStatus = 'reviewStatus',
  riskLevel = 'riskLevel',
  score = 'score'
}

/** The field to order by */
export enum RiskHistoryOrderBy {
  processedAt = 'processedAt'
}

/** Customer Risk Assessment Risk Levels */
export enum RiskLevel {
  High = 'High',
  Low = 'Low',
  Medium = 'Medium'
}

/** The risk level of an individual risk criteria was updated */
export type RiskLevelUpdated = Outcome & {
  __typename: 'RiskLevelUpdated';
  /** The name of the outcome */
  name: Scalars['String']['output'];
  /** The region id of the risk */
  regionId: Scalars['String']['output'];
  /** The risk id of the risk */
  riskId: Scalars['String']['output'];
  /** The risk level after the event */
  riskLevel: RiskLevel;
  /** The risk level of the risk criteria before the event */
  riskLevelBefore: RiskLevel;
};

/** An override to the final/overall risk level was added */
export type RiskOverrideAdded = Outcome & {
  __typename: 'RiskOverrideAdded';
  /** The name of the outcome */
  name: Scalars['String']['output'];
  /** The risk level of the override that was added */
  riskLevel: RiskLevel;
};

/** An override to the final/overall risk level was removed */
export type RiskOverrideRemoved = Outcome & {
  __typename: 'RiskOverrideRemoved';
  /** The name of the outcome */
  name: Scalars['String']['output'];
  /** The risk level of the override that was removed */
  riskLevel: RiskLevel;
};

/** risk path */
export type RiskPath = {
  __typename: 'RiskPath';
  regionId: Scalars['String']['output'];
  riskId: Scalars['String']['output'];
};

/** Risk path */
export type RiskPathArg = {
  regionId: Scalars['String']['input'];
  riskId: Scalars['String']['input'];
};

/** A rolling period for a limit */
export type RollingPeriod = {
  __typename: 'RollingPeriod';
  period: Maybe<Scalars['Duration']['output']>;
  periodType: RollingPeriodValue;
};

/** The type of rolling period for a limit */
export enum RollingPeriodValue {
  Finite = 'Finite',
  Infinite = 'Infinite'
}

/** Screening statuses of the player */
export type ScreeningStatuses = {
  __typename: 'ScreeningStatuses';
  fraud: OverwritableStatusCheck;
  pep: OverwritableStatusCheck;
  sanctioned: OverwritableStatusCheck;
};

/** The field by which to order the search results. */
export enum SearchChallengesRequestOrderBy {
  ChallengeName = 'ChallengeName',
  StartDate = 'StartDate'
}

/** The field by which to order the search results. */
export enum SearchPlayerRewardsOrderBy {
  assignedAt = 'assignedAt',
  rewardId = 'rewardId',
  status = 'status',
  updatedAt = 'updatedAt'
}

/** The field by which to order the search results. */
export enum SearchRewardsOrderBy {
  createdAt = 'createdAt',
  endsAt = 'endsAt',
  name = 'name',
  startsAt = 'startsAt',
  status = 'status'
}

/** Self exclusion changes count report */
export type SelfExclusionChangesCountReport = {
  __typename: 'SelfExclusionChangesCountReport';
  url: Scalars['String']['output'];
};

/** Self exclusion information */
export type SelfExclusionData = {
  __typename: 'SelfExclusionData';
  activeFrom: Scalars['OffsetDateTime']['output'];
  configuredAt: Scalars['OffsetDateTime']['output'];
  exclusionEndsAt: Maybe<Scalars['OffsetDateTime']['output']>;
};

/** Self Exclusion Details */
export type SelfExclusionDetails = {
  __typename: 'SelfExclusionDetails';
  configuredAt: Maybe<Scalars['OffsetDateTime']['output']>;
  exclusionEndsAt: Maybe<Scalars['OffsetDateTime']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  pending: Maybe<SelfExclusionData>;
  uuid: Scalars['String']['output'];
  willBeCancelledAt: Maybe<Scalars['OffsetDateTime']['output']>;
};

/** Self exclusion history */
export type SelfExclusionHistoryItem = {
  __typename: 'SelfExclusionHistoryItem';
  activeFrom: Maybe<Scalars['OffsetDateTime']['output']>;
  cancelledAt: Maybe<Scalars['OffsetDateTime']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  endsAt: Maybe<Scalars['OffsetDateTime']['output']>;
  eventType: Scalars['String']['output'];
  /** The ID of an object */
  id: Scalars['ID']['output'];
  playerId: Scalars['ID']['output'];
  previousEndDate: Maybe<Scalars['OffsetDateTime']['output']>;
  processedAt: Scalars['OffsetDateTime']['output'];
  requestedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  requestedBy: Maybe<Initiator>;
  uuid: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type SelfExclusionHistoryItemConnection = {
  __typename: 'SelfExclusionHistoryItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SelfExclusionHistoryItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SelfExclusionHistoryItemEdge = {
  __typename: 'SelfExclusionHistoryItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SelfExclusionHistoryItem;
};

/** Source service of the event */
export enum Service {
  Compliance = 'Compliance',
  Customer = 'Customer',
  GlobalId = 'GlobalId',
  Kyc6Gateway = 'Kyc6Gateway',
  PingwireGateway = 'PingwireGateway'
}

/** A session search item. */
export type SessionSearchItem = Node & {
  __typename: 'SessionSearchItem';
  brand: Maybe<Brand>;
  cause: Maybe<Scalars['String']['output']>;
  countryCode: Maybe<Scalars['String']['output']>;
  createdAt: Maybe<Scalars['OffsetDateTime']['output']>;
  /** The id of the object. */
  id: Scalars['ID']['output'];
  initiator: Maybe<Initiator>;
  ip: Maybe<Scalars['String']['output']>;
  player: Maybe<Player>;
  processedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  status: Maybe<Scalars['String']['output']>;
  userAgent: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type SessionSearchItemV2Connection = {
  __typename: 'SessionSearchItemV2Connection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SessionSearchItemV2Edge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SessionSearchItemV2Edge = {
  __typename: 'SessionSearchItemV2Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: SessionSearchItem;
};

/** The order to list session search results. */
export enum SessionSearchOrder {
  cause = 'cause',
  countryCode = 'countryCode',
  createdAt = 'createdAt',
  status = 'status'
}

/** The status of a session. */
export enum SessionStatus {
  Created = 'Created',
  Destroyed = 'Destroyed'
}

/** Smartico gamification details */
export type SmarticoGamification = {
  __typename: 'SmarticoGamification';
  factor: Scalars['Float']['output'];
  level: Maybe<Scalars['String']['output']>;
  limitMultiplier: Scalars['Float']['output'];
  nextFactor: Maybe<Scalars['Float']['output']>;
  nextLevel: Maybe<Scalars['String']['output']>;
  nextLimitMultiplier: Maybe<Scalars['Float']['output']>;
};

/** Smartico player gamification */
export type SmarticoGamificationDetails = {
  __typename: 'SmarticoGamificationDetails';
  level: Scalars['String']['output'];
};

/** The order to list SoW documents */
export enum SoWSearchOrder {
  limitReachedAt = 'limitReachedAt',
  statusChangedAt = 'statusChangedAt',
  submittedAt = 'submittedAt'
}

/** Provided source of fund type */
export enum SourceOfFundType {
  CLIENT_DECLARATION_OF_LINE_OF_BUSINESS = 'CLIENT_DECLARATION_OF_LINE_OF_BUSINESS',
  CRYPTO_MINING = 'CRYPTO_MINING',
  DIVIDENDS_FROM_CAP = 'DIVIDENDS_FROM_CAP',
  DIVIDENDS_FROM_NON_CAP = 'DIVIDENDS_FROM_NON_CAP',
  DONATION_OR_GIFT = 'DONATION_OR_GIFT',
  FUNDS_GENERATED_FROM_GAMBLING_WINNINGS = 'FUNDS_GENERATED_FROM_GAMBLING_WINNINGS',
  INCOME_AND_SALARY_BUSINESS_ACTIVITY = 'INCOME_AND_SALARY_BUSINESS_ACTIVITY',
  INCOME_FROM_INVESTMENTS = 'INCOME_FROM_INVESTMENTS',
  INHERITANCE = 'INHERITANCE',
  LOAN = 'LOAN',
  SALE_OF_COMPANY_FROM_CAP = 'SALE_OF_COMPANY_FROM_CAP',
  SALE_OF_COMPANY_FROM_NON_CAP = 'SALE_OF_COMPANY_FROM_NON_CAP',
  SALE_PROPERTY = 'SALE_PROPERTY',
  SAVINGS_FROM_CAP = 'SAVINGS_FROM_CAP',
  SAVINGS_FROM_NON_CAP = 'SAVINGS_FROM_NON_CAP'
}

export type SourceOfWealth = {
  __typename: 'SourceOfWealth';
  /** In the range of expending, the minimum amount. Same format as salary */
  expendingLowerBound: Maybe<Scalars['Int']['output']>;
  /** In the range of expending, the maximum amount. Same format as salary */
  expendingUpperBound: Maybe<Scalars['Int']['output']>;
  fundingOptions: Array<FundingOption>;
  /**
   * In the range of gross income, the minimum amount.
   * In (0 - 10.000) it would be 0
   * In (10.000 - 30.000) it would be 10000.
   * In 50.000+ it would be 50.000
   */
  grossIncomeLowerBound: Maybe<Scalars['Int']['output']>;
  /**
   * In the range of gross income, the maximum amount.
   * In (0 - 10.000) it would be 10000
   * In 50.000+ it would be null
   */
  grossIncomeUpperBound: Maybe<Scalars['Int']['output']>;
  nationality: Maybe<Scalars['String']['output']>;
  otherFundingDescription: Maybe<Scalars['String']['output']>;
  placeOfBirth: Maybe<Scalars['String']['output']>;
  /**
   * In the range of salary, the minimum amount.
   * In (0 - 10.000) it would be 0
   * In (10.000 - 30.000) it would be 10000.
   * In 50.000+ it would be 50.000
   */
  salaryLowerBound: Maybe<Scalars['Int']['output']>;
  /**
   * In the range of salary, the maximum amount.
   * In (0 - 10.000) it would be 10000
   * In 50.000+ it would be null
   */
  salaryUpperBound: Maybe<Scalars['Int']['output']>;
};

/** SoW history entry for SoW manually requested */
export type SourceOfWealthManuallyRequested = PlayerComplianceHistorySearchItem & {
  __typename: 'SourceOfWealthManuallyRequested';
  eventType: Scalars['String']['output'];
  /** @deprecated Use initiatorV2 */
  initiator: Initiator;
  initiatorV2: Maybe<Initiator>;
  playerGlobalId: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  playerUUID: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** SoW history entry for SoW required */
export type SourceOfWealthRequiredItem = PlayerComplianceHistorySearchItem & {
  __typename: 'SourceOfWealthRequiredItem';
  eventType: Scalars['String']['output'];
  /** @deprecated Use initiatorV2 */
  initiator: Maybe<Initiator>;
  initiatorV2: Maybe<Initiator>;
  playerGlobalId: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  playerUUID: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** SoW history entry for SoW submitted */
export type SourceOfWealthSubmittedItem = PlayerComplianceHistorySearchItem & {
  __typename: 'SourceOfWealthSubmittedItem';
  amlStatus: AmlRiskLevel;
  eventType: Scalars['String']['output'];
  initiatorV2: Maybe<Initiator>;
  playerGlobalId: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  playerUUID: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  sourceOfWealth: SourceOfWealth;
  uuid: Scalars['String']['output'];
};

/** SoW history entry for SoW verified */
export type SourceOfWealthVerifiedItem = PlayerComplianceHistorySearchItem & {
  __typename: 'SourceOfWealthVerifiedItem';
  decision: VerificationDecision;
  eventType: Scalars['String']['output'];
  /** @deprecated Use initiatorV2 */
  initiator: Initiator;
  initiatorV2: Maybe<Initiator>;
  playerGlobalId: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  playerUUID: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** The SOW Blocked status of a player */
export enum SowBlockedStatus {
  NotBlocked = 'NotBlocked',
  SowBlock = 'SowBlock'
}

/** SoW history entry for SoW deadline removed */
export type SowDeadlineRemovedItem = PlayerComplianceHistorySearchItem & {
  __typename: 'SowDeadlineRemovedItem';
  comment: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  /** @deprecated Use initiatorV2 */
  initiator: Initiator;
  initiatorV2: Maybe<Initiator>;
  playerGlobalId: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  playerUUID: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  uuid: Scalars['String']['output'];
};

/**
 * The URL from where the exported sow report will be accessible. Know that the
 * report might not be uploaded yet. The URL will be valid for a limited time.
 */
export type SowExportResponse = {
  __typename: 'SowExportResponse';
  url: Scalars['String']['output'];
};

/** SoW history entry for sow not requested */
export type SowNotRequestedItem = PlayerComplianceHistorySearchItem & {
  __typename: 'SowNotRequestedItem';
  comment: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  /** @deprecated Use initiatorV2 */
  initiator: Initiator;
  initiatorV2: Maybe<Initiator>;
  playerGlobalId: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  playerUUID: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** A sow report export details. */
export type SowReportDetails = {
  __typename: 'SowReportDetails';
  url: Scalars['String']['output'];
};

/** Sportsbook money drop reward type */
export type SportsbookMoneyDropReward = RewardType & {
  __typename: 'SportsbookMoneyDropReward';
  amount: Scalars['BigDecimal']['output'];
  currency: Scalars['String']['output'];
  name: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
};

/** Represents a money reward template */
export type SportsbookMoneyTemplate = {
  __typename: 'SportsbookMoneyTemplate';
  /** Optional affiliate ID, can also be defined at offer level */
  affiliateId: Maybe<Scalars['String']['output']>;
  /** Can be empty and defined at offer level */
  countries: Array<Scalars['ISOCountryCode']['output']>;
  currency: Scalars['ISOCurrencyCode']['output'];
  /** Max awarded amount depending on amount deposited: maxDepositAmount * multiplier = maxRewardAmount */
  dynamicAmount: Maybe<DynamicDepositAmount>;
  id: Scalars['String']['output'];
  /** Max awarded amount depending on amount deposited: maxDepositAmount * multiplier = maxRewardAmount */
  sportsbookTemplateId: Scalars['String']['output'];
  /** Default value in case dynamicAmount is not provided */
  staticAmount: Scalars['Int']['output'];
};

/** Statistics. */
export type StatsEntryType = {
  __typename: 'StatsEntryType';
  /** AvgBetSize */
  AvgBetSize: Maybe<Scalars['Float']['output']>;
  /** AvgDepositAmount */
  AvgDepositAmount: Maybe<Scalars['Float']['output']>;
  /** AvgDepositPerUser */
  AvgDepositPerUser: Maybe<Scalars['Float']['output']>;
  /** AvgRevenuePerUser */
  AvgRevenuePerUser: Maybe<Scalars['Float']['output']>;
  /** NetDeposits */
  NetDeposits: Maybe<Scalars['Float']['output']>;
  /** affiliateId */
  affiliateId: Maybe<Scalars['String']['output']>;
  /** allWins */
  allWins: Maybe<Scalars['Float']['output']>;
  /** allWinsRealMoney */
  allWinsRealMoney: Maybe<Scalars['Float']['output']>;
  /** amountAdjustments */
  amountAdjustments: Maybe<Scalars['Float']['output']>;
  /** amountAllBonus */
  amountAllBonus: Maybe<Scalars['Float']['output']>;
  /** amountBonusAdjustments */
  amountBonusAdjustments: Maybe<Scalars['Float']['output']>;
  /** amountBonusClaimed */
  amountBonusClaimed: Maybe<Scalars['Float']['output']>;
  /** amountBonusConverted */
  amountBonusConverted: Maybe<Scalars['Float']['output']>;
  /** amountCashbacks */
  amountCashbacks: Maybe<Scalars['Float']['output']>;
  /** amountDeposits */
  amountDeposits: Maybe<Scalars['Float']['output']>;
  /** amountFailedDeposits */
  amountFailedDeposits: Maybe<Scalars['Float']['output']>;
  /** amountFailedWithdrawals */
  amountFailedWithdrawals: Maybe<Scalars['Float']['output']>;
  /** amountFreeSpinWins */
  amountFreeSpinWins: Maybe<Scalars['Float']['output']>;
  /** amountFtd */
  amountFtd: Maybe<Scalars['Float']['output']>;
  /** amountInitWithdrawals */
  amountInitWithdrawals: Maybe<Scalars['Float']['output']>;
  /** amountMoneyDrops */
  amountMoneyDrops: Maybe<Scalars['Float']['output']>;
  /** amountReversals */
  amountReversals: Maybe<Scalars['Float']['output']>;
  /** amountWin */
  amountWin: Maybe<Scalars['Float']['output']>;
  /** amountWithdrawableWinnings */
  amountWithdrawableWinnings: Maybe<Scalars['Float']['output']>;
  /** amountWithdrawals */
  amountWithdrawals: Maybe<Scalars['Float']['output']>;
  /** birthYear */
  birthYear: Maybe<Scalars['String']['output']>;
  /** brand */
  brand: Maybe<Scalars['String']['output']>;
  /** calculatedBalance */
  calculatedBalance: Maybe<Scalars['Float']['output']>;
  /** campaignId */
  campaignId: Maybe<Scalars['String']['output']>;
  /** cashBackEnableLookup */
  cashBackEnableLookup: Maybe<Scalars['String']['output']>;
  /** currency */
  currency: Maybe<Scalars['String']['output']>;
  /** device */
  device: Maybe<Scalars['String']['output']>;
  /** ftd */
  ftd: Maybe<Scalars['Int']['output']>;
  /** ftdOfNrc */
  ftdOfNrc: Maybe<Scalars['Float']['output']>;
  /** ftp */
  ftp: Maybe<Scalars['Int']['output']>;
  /** gameCategoryLookup */
  gameCategoryLookup: Maybe<Scalars['String']['output']>;
  /** @deprecated use gameDescriptorV2 instead. */
  gameDescriptor: Maybe<GameDescriptor>;
  gameDescriptorV2: Maybe<GameDescriptorOrError>;
  /** gameId */
  gameId: Maybe<Scalars['String']['output']>;
  /** gameNameLookup */
  gameNameLookup: Maybe<Scalars['String']['output']>;
  /** gameProvider */
  gameProvider: Maybe<Scalars['String']['output']>;
  /** gameProviderGameId */
  gameProviderGameId: Maybe<Scalars['String']['output']>;
  /** gameStudioLookup */
  gameStudioLookup: Maybe<Scalars['String']['output']>;
  /** gameWin */
  gameWin: Maybe<Scalars['Float']['output']>;
  /** gameWinBonusWallet */
  gameWinBonusWallet: Maybe<Scalars['Float']['output']>;
  /** gameWinRealMoney */
  gameWinRealMoney: Maybe<Scalars['Float']['output']>;
  /** gender */
  gender: Maybe<Scalars['String']['output']>;
  /** ggr */
  ggr: Maybe<Scalars['Float']['output']>;
  /** ggrBonusWallet */
  ggrBonusWallet: Maybe<Scalars['Float']['output']>;
  /** ggrInRewards */
  ggrInRewards: Maybe<Scalars['Float']['output']>;
  /** ggrInRewardsNoCashback */
  ggrInRewardsNoCashback: Maybe<Scalars['Float']['output']>;
  /** ggrRealMoney */
  ggrRealMoney: Maybe<Scalars['Float']['output']>;
  globalPlayer: Maybe<GlobalPlayer>;
  /** hold_ */
  hold_: Maybe<Scalars['Float']['output']>;
  /** ip */
  ip: Maybe<Scalars['String']['output']>;
  /** isBot */
  isBot: Maybe<Scalars['String']['output']>;
  /** isIncognito */
  isIncognito: Maybe<Scalars['String']['output']>;
  /** isLiveCasinoGameLookup */
  isLiveCasinoGameLookup: Maybe<Scalars['String']['output']>;
  /** jpc */
  jpc: Maybe<Scalars['Float']['output']>;
  /** lastBonusedAt */
  lastBonusedAt: Maybe<Scalars['String']['output']>;
  /** lastTimeDeposit */
  lastTimeDeposit: Maybe<Scalars['String']['output']>;
  /** margin */
  margin: Maybe<Scalars['Float']['output']>;
  /** moneyDropType */
  moneyDropType: Maybe<Scalars['String']['output']>;
  /** ngr */
  ngr: Maybe<Scalars['Float']['output']>;
  /** ngrInRewards */
  ngrInRewards: Maybe<Scalars['Float']['output']>;
  /** ngrInRewardsNoCashback */
  ngrInRewardsNoCashback: Maybe<Scalars['Float']['output']>;
  /** ngrSinceLastManualReward */
  ngrSinceLastManualReward: Maybe<Scalars['Float']['output']>;
  /** nrc */
  nrc: Maybe<Scalars['Int']['output']>;
  /** nrcByNsc */
  nrcByNsc: Maybe<Scalars['Float']['output']>;
  /** nsc */
  nsc: Maybe<Scalars['Int']['output']>;
  /** numAdjustments */
  numAdjustments: Maybe<Scalars['Int']['output']>;
  /** numBlockAccountRequests */
  numBlockAccountRequests: Maybe<Scalars['Int']['output']>;
  /** numCancelSelfExclusionRequests */
  numCancelSelfExclusionRequests: Maybe<Scalars['Int']['output']>;
  /** numCashbacks */
  numCashbacks: Maybe<Scalars['Int']['output']>;
  /** numCloseAccountRequests */
  numCloseAccountRequests: Maybe<Scalars['Int']['output']>;
  /** numDeposits */
  numDeposits: Maybe<Scalars['Int']['output']>;
  /** numFailedDeposits */
  numFailedDeposits: Maybe<Scalars['Float']['output']>;
  /** numFailedWithdrawals */
  numFailedWithdrawals: Maybe<Scalars['Int']['output']>;
  /** numMoneyDrops */
  numMoneyDrops: Maybe<Scalars['Int']['output']>;
  /** numReopenAccountRequests */
  numReopenAccountRequests: Maybe<Scalars['Int']['output']>;
  /** numReversals */
  numReversals: Maybe<Scalars['Int']['output']>;
  /** numSelfExclusionRequests */
  numSelfExclusionRequests: Maybe<Scalars['Int']['output']>;
  /** numTotalCloseAccountRequests */
  numTotalCloseAccountRequests: Maybe<Scalars['Float']['output']>;
  /** numUniqueActiveDepositors */
  numUniqueActiveDepositors: Maybe<Scalars['Int']['output']>;
  /** numUniqueActiveGlobalPlayers */
  numUniqueActiveGlobalPlayers: Maybe<Scalars['Int']['output']>;
  /** numUniqueActivePlayers */
  numUniqueActivePlayers: Maybe<Scalars['Int']['output']>;
  /** numUniqueDepositors */
  numUniqueDepositors: Maybe<Scalars['Int']['output']>;
  /** numUniqueFreeSpinAssignations */
  numUniqueFreeSpinAssignations: Maybe<Scalars['Int']['output']>;
  /** numUniquePlayers */
  numUniquePlayers: Maybe<Scalars['Int']['output']>;
  /** numUniqueSessions */
  numUniqueSessions: Maybe<Scalars['Int']['output']>;
  /** numWithdrawals */
  numWithdrawals: Maybe<Scalars['Int']['output']>;
  /** os */
  os: Maybe<Scalars['String']['output']>;
  /** paymentProvider */
  paymentProvider: Maybe<Scalars['String']['output']>;
  /** pendingWithdrawals */
  pendingWithdrawals: Maybe<Scalars['Float']['output']>;
  player: Maybe<Player>;
  /** playerAccountStatusLookup */
  playerAccountStatusLookup: Maybe<Scalars['String']['output']>;
  /** playerCurrentSegment */
  playerCurrentSegment: Maybe<Scalars['String']['output']>;
  /** playerGlobalId */
  playerGlobalId: Maybe<Scalars['String']['output']>;
  /** playerId */
  playerId: Maybe<Scalars['String']['output']>;
  /** registrationDate */
  registrationDate: Maybe<Scalars['String']['output']>;
  /** residenceCountryCode */
  residenceCountryCode: Maybe<Scalars['String']['output']>;
  /** Period of time related to 'Granularity' */
  timePeriod: Maybe<Scalars['String']['output']>;
  /** turnover */
  turnover: Maybe<Scalars['Float']['output']>;
  /** turnoverBonusWallet */
  turnoverBonusWallet: Maybe<Scalars['Float']['output']>;
  /** turnoverRealMoney */
  turnoverRealMoney: Maybe<Scalars['Float']['output']>;
  /** volatilityLookup */
  volatilityLookup: Maybe<Scalars['String']['output']>;
  /** wagers */
  wagers: Maybe<Scalars['Int']['output']>;
};

/** Possible errors when loading statistics. */
export enum StatsError {
  /** No results could be generated within the given time out period. */
  TIMEOUT = 'TIMEOUT',
  /** Statistics are currently unavailable. */
  UNAVAILABLE = 'UNAVAILABLE',
  /** Statistics are currently unavailable for an unhandled reason. */
  UNKNOWN = 'UNKNOWN'
}

/** Statistics. */
export type StatsType = {
  __typename: 'StatsType';
  /** An optional error. */
  error: Maybe<StatsError>;
  /** An optional exported url. */
  exportedUrl: Maybe<Scalars['String']['output']>;
  /** Statistical query. */
  query: Scalars['String']['output'];
  /** Statistical rows. */
  rows: Array<StatsEntryType>;
};

/** Player screening status */
export type StatusCheck = {
  __typename: 'StatusCheck';
  checkedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  decision: Scalars['Boolean']['output'];
  details: Maybe<Scalars['String']['output']>;
  score: Maybe<Scalars['Int']['output']>;
  status: Scalars['Boolean']['output'];
};

/** Stuck withdrawals report */
export type StuckWithdrawalsReport = {
  __typename: 'StuckWithdrawalsReport';
  url: Scalars['String']['output'];
};

/** The type of review that is submitted */
export enum SubmitReviewStatus {
  ReviewApproved = 'ReviewApproved',
  ReviewPending = 'ReviewPending',
  ReviewRejected = 'ReviewRejected'
}

export type Subscription = {
  __typename: 'Subscription';
  bulkAdjustmentProgress: BulkAdjustmentProgressEventType;
};


export type SubscriptionbulkAdjustmentProgressArgs = {
  filePath: Scalars['String']['input'];
};

/** Suppression group type */
export type SuppressionGroupType = {
  __typename: 'SuppressionGroupType';
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['Long']['output'];
  name: Scalars['String']['output'];
};

/** A reusable standalone reward template */
export type Template = {
  __typename: 'Template';
  /** The ID of an object */
  id: Scalars['ID']['output'];
  rewardProfile: RewardProfile;
  templateId: Scalars['String']['output'];
  templateName: Scalars['String']['output'];
};

export type TemplateId = {
  __typename: 'TemplateId';
  templateId: Scalars['String']['output'];
};

/** Result of deleting a template, either success or error */
export type TemplateIdResult = TemplateId | WelcomeOfferError;

/** Result of a template operation, either success or error */
export type TemplateResult = Template | WelcomeOfferError;

/** A connection to a list of items. */
export type TemplatesConnectionConnection = {
  __typename: 'TemplatesConnectionConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TemplatesConnectionEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TemplatesConnectionEdge = {
  __typename: 'TemplatesConnectionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TemplateResult;
};

/** The termination cause. */
export enum TerminationCause {
  CreatedByAgent = 'CreatedByAgent',
  FailedLoginAttempt = 'FailedLoginAttempt',
  LimitExceeded = 'LimitExceeded',
  LoggedInFromAnotherDevice = 'LoggedInFromAnotherDevice',
  LoggedOut = 'LoggedOut',
  PlayerInactivated = 'PlayerInactivated',
  PlayerInactivity = 'PlayerInactivity',
  ResponsibleGaming = 'ResponsibleGaming',
  TerminatedBySystem = 'TerminatedBySystem'
}

/** A transaction export details. */
export type TransactionExportDetails = {
  __typename: 'TransactionExportDetails';
  url: Scalars['String']['output'];
};

/** A transaction search item. */
export type TransactionSearchItem = {
  __typename: 'TransactionSearchItem';
  adjustmentType: Maybe<AdjustmentTypeData>;
  amount: Maybe<Scalars['BigDecimal']['output']>;
  bonusTransactionData: Maybe<BonusTransactionData>;
  brand: Maybe<Brand>;
  closingBalance: Maybe<Scalars['BigDecimal']['output']>;
  comment: Maybe<Scalars['String']['output']>;
  cryptoInformation: Maybe<CryptoInformation>;
  currency: Maybe<Scalars['String']['output']>;
  euroQuote: Maybe<EuroQuote>;
  extTransactionId: Maybe<Scalars['String']['output']>;
  /** @deprecated use gameDescriptorV2 instead. */
  gameDescriptor: Maybe<GameDescriptor>;
  gameDescriptorV2: Maybe<GameDescriptorOrError>;
  gameId: Maybe<Scalars['String']['output']>;
  gameProvider: Maybe<Scalars['String']['output']>;
  gameRoundId: Maybe<Scalars['String']['output']>;
  /** @deprecated Do not ask for this, it will always be null */
  gameRoundStatus: Maybe<Scalars['String']['output']>;
  gameSessionId: Maybe<Scalars['String']['output']>;
  gameplayConversionData: Maybe<GameplayConversionData>;
  initiator: Maybe<Initiator>;
  isRoundFinished: Maybe<Scalars['Boolean']['output']>;
  openingBalance: Maybe<Scalars['BigDecimal']['output']>;
  payload: Maybe<Scalars['String']['output']>;
  paymentFee: Maybe<Fee>;
  paymentMethod: Maybe<Scalars['String']['output']>;
  paymentStatus: Maybe<Scalars['String']['output']>;
  playerId: Maybe<Scalars['ID']['output']>;
  playerSessionId: Maybe<Scalars['ID']['output']>;
  playerSessionUUID: Maybe<Scalars['String']['output']>;
  processedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  provider: Maybe<Scalars['String']['output']>;
  providerFee: Maybe<Fee>;
  rawTransactionId: Scalars['String']['output'];
  riskScore: Maybe<Scalars['String']['output']>;
  transactionId: Scalars['ID']['output'];
  transactionType: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type TransactionSearchItemConnection = {
  __typename: 'TransactionSearchItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<TransactionSearchItemEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TransactionSearchItemEdge = {
  __typename: 'TransactionSearchItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: TransactionSearchItem;
};

/** The order to list transaction search results. */
export enum TransactionSearchOrder {
  amount = 'amount',
  brand = 'brand',
  gameId = 'gameId',
  gameProvider = 'gameProvider',
  gameRoundId = 'gameRoundId',
  playerId = 'playerId',
  processedAt = 'processedAt'
}

/** Type of a transaction. */
export enum TransactionType {
  AdjustmentDeposit = 'AdjustmentDeposit',
  AdjustmentWithdrawal = 'AdjustmentWithdrawal',
  CancelDeposit = 'CancelDeposit',
  CancelWithdrawal = 'CancelWithdrawal',
  Cashback = 'Cashback',
  CasinoBet = 'CasinoBet',
  CasinoDeposit = 'CasinoDeposit',
  CasinoWin = 'CasinoWin',
  Deposit = 'Deposit',
  InitDeposit = 'InitDeposit',
  InitRollbackDeposit = 'InitRollbackDeposit',
  InitRollbackWithdrawal = 'InitRollbackWithdrawal',
  InitWithdrawal = 'InitWithdrawal',
  JackpotWin = 'JackpotWin',
  MoneyDropDeposit = 'MoneyDropDeposit',
  NegativeBet = 'NegativeBet',
  Rakeback = 'Rakeback',
  RollbackCasinoBet = 'RollbackCasinoBet',
  RollbackCasinoWin = 'RollbackCasinoWin',
  RollbackDeposit = 'RollbackDeposit',
  RollbackJackpotWin = 'RollbackJackpotWin',
  RollbackWithdrawal = 'RollbackWithdrawal',
  Withdrawal = 'Withdrawal'
}

/** Translated Player's address (for example Japanese players address in Katakana format) */
export type TranslatedPersonalInfo = {
  __typename: 'TranslatedPersonalInfo';
  city: Scalars['String']['output'];
  district: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  state: Maybe<Scalars['String']['output']>;
  street: Scalars['String']['output'];
};

/** Contains the address info fields that have translated versions */
export type TranslatedPersonalInfoDocument = {
  __typename: 'TranslatedPersonalInfoDocument';
  city: Maybe<Scalars['String']['output']>;
  district: Maybe<Scalars['String']['output']>;
  firstName: Maybe<Scalars['String']['output']>;
  lastName: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
  street: Maybe<Scalars['String']['output']>;
};

/** Upcoming cashback item */
export type UpcomingCashbackItem = {
  __typename: 'UpcomingCashbackItem';
  amount: Scalars['BigDecimal']['output'];
  cashbackPeriodEnd: Scalars['OffsetDateTime']['output'];
  cashbackPeriodStart: Scalars['OffsetDateTime']['output'];
  currency: Scalars['String']['output'];
  factor: Scalars['Float']['output'];
  /** The ID of an object */
  id: Scalars['ID']['output'];
  maxLimit: Maybe<Scalars['BigDecimal']['output']>;
  maybeRank: Maybe<Scalars['String']['output']>;
  processedAt: Maybe<Scalars['OffsetDateTime']['output']>;
};

/** Upcoming cashback item */
export type UpcomingCashbackItemV2 = {
  __typename: 'UpcomingCashbackItemV2';
  amount: Scalars['BigDecimal']['output'];
  cashbackPeriodEnd: Scalars['OffsetDateTime']['output'];
  cashbackPeriodStart: Scalars['OffsetDateTime']['output'];
  currency: Scalars['String']['output'];
  gamificationDetails: GamificationDetailsType;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  maxLimit: Maybe<Scalars['BigDecimal']['output']>;
  processedAt: Maybe<Scalars['OffsetDateTime']['output']>;
};

/** Upcoming rakeback item */
export type UpcomingRakebackItem = {
  __typename: 'UpcomingRakebackItem';
  amount: Scalars['BigDecimal']['output'];
  currency: Scalars['String']['output'];
  factor: Scalars['Float']['output'];
  /** The ID of an object */
  id: Scalars['ID']['output'];
  maxLimit: Maybe<Scalars['BigDecimal']['output']>;
  periodEnd: Scalars['OffsetDateTime']['output'];
  periodStart: Scalars['OffsetDateTime']['output'];
  processedAt: Maybe<Scalars['OffsetDateTime']['output']>;
};

/** Upcoming rakeback item */
export type UpcomingRakebackItemV2 = {
  __typename: 'UpcomingRakebackItemV2';
  amount: Scalars['BigDecimal']['output'];
  currency: Scalars['String']['output'];
  gamificationDetails: GamificationDetailsType;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  maxLimit: Maybe<Scalars['BigDecimal']['output']>;
  periodEnd: Scalars['OffsetDateTime']['output'];
  periodStart: Scalars['OffsetDateTime']['output'];
  processedAt: Maybe<Scalars['OffsetDateTime']['output']>;
};

/** SoW item for uploaded funding document */
export type UploadedFundingDocumentsItem = PlayerComplianceHistorySearchItem & {
  __typename: 'UploadedFundingDocumentsItem';
  comment: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  /** @deprecated Use initiatorV2 */
  initiator: Initiator;
  initiatorV2: Maybe<Initiator>;
  playerGlobalId: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  playerUUID: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  remainingToUploadFundingDocuments: Array<FundingOption>;
  uploadedFundingDocument: FundingOption;
  uuid: Scalars['String']['output'];
};

/** UTM parameters. */
export type UtmParameters = {
  __typename: 'UtmParameters';
  /** Identifies a specific product promotion or strategic campaign. */
  utmCampaign: Maybe<Scalars['String']['output']>;
  /** Identifies what specifically was clicked to bring the user to the site, such as a banner ad or a text link. */
  utmContent: Maybe<Scalars['String']['output']>;
  /** Identifies what type of link was used, such as cost per click or email. */
  utmMedium: Maybe<Scalars['String']['output']>;
  /** Identifies which site sent the traffic. */
  utmSource: Scalars['String']['output'];
  /** Identifies search terms. */
  utmTerm: Maybe<Scalars['String']['output']>;
};

/** Verification decision for Source of Wealth */
export enum VerificationDecision {
  Approved = 'Approved',
  Rejected = 'Rejected'
}

export type VerificationEmailSentResponse = {
  __typename: 'VerificationEmailSentResponse';
  email: Scalars['String']['output'];
  playerId: Scalars['String']['output'];
};

/** Verification Type */
export enum VerificationTypeEnum {
  Address = 'Address',
  Age = 'Age',
  Email = 'Email',
  Identity = 'Identity',
  PhoneNumber = 'PhoneNumber',
  SourceOfWealth = 'SourceOfWealth'
}

/** Verification type with the provider that verified it */
export type VerificationWithProvider = {
  __typename: 'VerificationWithProvider';
  provider: Scalars['String']['output'];
  verificationType: DocumentVerificationType;
};

/** A viewer. */
export type Viewer = EntityWithStatistics & Node & {
  __typename: 'Viewer';
  aggregatedKYC6Matches: AggregatedKyc6MatchItemConnection;
  aggregatedKyc6MatchReportDownloadLink: KYC6MatchReport;
  allLinkedAccounts: AllLinkedAccountsItemConnection;
  amlRiskAssessmentsReport: AmlRiskAssessmentReport;
  bonus: Maybe<Bonus>;
  /** Bonus codes, newest first unless a codePrefix is given, which the bonus code service matches by relevance */
  bonusCodes: BonusCodeConnection;
  bonusHistory: BonusHistoryConnection;
  bonuses: BonusConnection;
  brands: Array<Brand>;
  detailedCashbackReport: DetailedCashbackReport;
  detailedRakebackReport: DetailedRakebackReport;
  /** Get the jackpot contribution switch state for a brand */
  dinoJackpotContributionSwitch: DinoContributionSwitch;
  /** Search the jackpot contribution switch history */
  dinoJackpotContributionSwitchHistory: DinoContributionSwitchHistoryEntryConnection;
  /** Retrieve the leaderboard history for a dino jackpot pot */
  dinoJackpotLeaderboardHistory: Array<DinoJackpotLeaderboardHistoryEntry>;
  /** Get the dino jackpot opt-in status of a player */
  dinoJackpotOptIn: DinoJackpotOptInStatus;
  /** Get the dino jackpot opt-in status of a player for a given source code */
  dinoJackpotOptInBySourceCode: DinoJackpotOptInStatus;
  /** Search the jackpot opt-in/opt-out history */
  dinoJackpotOptInHistory: DinoOptInHistoryEntryConnection;
  /** Search the jackpot opt-in/opt-out history for a given source code */
  dinoJackpotOptInHistoryBySourceCode: DinoOptInHistoryEntryConnection;
  documents: DocumentConnection;
  expiredKycValidations: PlayerKYCValidationItemConnection;
  exportClosingBalancesReport: ClosingBalancesExportDetails;
  exportRiskAssessment: Scalars['Boolean']['output'];
  /** @deprecated Use the exportSowReportV2 instead. */
  exportSowReport: SowReportDetails;
  exportSowReportV2: SowExportResponse;
  /** Generate the cashback report based on from and to dates */
  exportedCashbackReportV5: Scalars['String']['output'];
  exportedDailyPlayerActivityFromElastic: TransactionExportDetails;
  exportedDailyPlayerActivityFromElasticV2: TransactionExportDetails;
  exportedGlobalPayments: PaymentExportDetails;
  /** Mutation to generate the MGA self exclusion report */
  exportedMGASelfExclusionReport: TransactionExportDetails;
  exportedMarketingPlayers: PlayerExportDetails;
  exportedMultipleAccounts: PlayerExportDetails;
  exportedPayments: PaymentExportDetails;
  exportedPlayerKycHistory: PlayerExportDetails;
  exportedPlayers: PlayerExportDetails;
  exportedPlayersKycCheckStatus: LongRunningPlayerExportDetails;
  /** Generate the rakeback report based on from and to dates */
  exportedRakebackReport: Scalars['String']['output'];
  exportedSelfExclusionsReport: TransactionExportDetails;
  exportedTransactionsV2: TransactionExportDetails;
  /** Generates a link to a csv file with details of players within a challenge */
  generateChallengeReport: Scalars['String']['output'];
  getKycRequestCount: GetKycRequestCountRequest;
  /** Allow to get any wallet (from Wallet-Service), used for debugging */
  getSpecificWallet: Wallet;
  globalNotes: NoteResponseConnection;
  hampiCheckByNamePlusDob: Maybe<HampiCheckResult>;
  hampiCheckBySsn: Maybe<HampiCheckResult>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  identity: Identity;
  identityV2: IdentityV2;
  kyc6MatchReportDownloadLink: KYC6MatchReport;
  kyc6MatchesByGlobalId: Kyc6MatchItemConnection;
  kyc6MatchesByGlobalIdV2: Kyc6MatchItemConnection;
  kyc6MatchesByPlayerId: Kyc6MatchItemConnection;
  kyc6MatchesByPlayerIdV2: Kyc6MatchItemConnection;
  /** @deprecated Parameter name changes to better reflect functionality, use expiredKycValidation instead */
  kycValidation: PlayerKYCValidationItemConnection;
  limitChangesCountReport: LimitChangesCountReport;
  listPaymentApprovals: PaymentApprovalConnection;
  payments: PaymentConnection;
  pendingKycFlowSearch: PendingKycFlowViewItemConnection;
  pepAndSanctionsPlayerListReport: PepAndSanctionsPlayerListExportDetails;
  /** List of changes to compliance */
  playerComplianceHistory: PlayerComplianceHistorySearchItemConnection;
  playerCompliancePlayersV3: PlayerComplianceV3Connection;
  playerInfoHistory: PlayerInfoHistoryItemConnection;
  playerInformationHistory: PlayerInformationHistoryDocumentConnection;
  playerInformationHistoryExport: Scalars['String']['output'];
  playerKycHistory: PlayerKycHistoryItemConnection;
  playersAsYouTypeV2: PlayerSearchItemConnection;
  playersProgress: PlayerProgressItemConnection;
  /**
   * For field marked with 'Wildcard enabled' you can use:
   * '?' which matches any single character.
   * '*' which can match zero or more characters, including an empty one.
   */
  playersSearchV2: PlayerSearchItemConnection;
  /** An existing reward */
  reward: Maybe<RewardItem>;
  /** List of created rewards. It's sorted by createdAt desc if none it's provided */
  rewards: RewardItemConnection;
  rgCraAutomationHistory: RgCraAutomationHistoryItemConnection;
  rgCraAutomationV2History: RgCraAutomationV2HistoryItemConnection;
  /**
   * RG-CRA-Automation v1 action history, read-only. Rows are per risk and per
   * region, unlike the aggregated v2 history, and region and risk names are v1's
   * own as agents saw them at the time. Capped at the instant v1 stopped being
   * authoritative. Removed once rg-cra-automation is decommissioned.
   */
  rgCraAutomationV2LegacyHistory: RgCraAutomationLegacyHistoryItemConnection;
  rgCraRiskAssessment: RgCraCustomerRiskAssessment;
  rgCraRiskAssessmentHistory: RgCraCustomerRiskAssessmentHistoryItemConnection;
  rgCraRiskAssessments: RgCraCustomerRiskAssessmentConnection;
  rgCraRiskAssessmentsReport: RgCraRiskAssessmentReport;
  /**
   * RG-CRA v1 risk history, read-only. Region and risk names are v1's own, as
   * agents saw them at the time, so they may differ from the current v2 taxonomy.
   * Removed once rg-cra is decommissioned.
   */
  rgCraV2LegacyRiskAssessmentHistory: RgCraV2CustomerRiskAssessmentHistoryItemConnection;
  rgCraV2RiskAssessment: RgCraV2GamingCustomerRiskAssessment;
  rgCraV2RiskAssessmentHistory: RgCraV2CustomerRiskAssessmentHistoryItemConnection;
  rgCraV2RiskAssessments: RgCraV2GamingCustomerRiskAssessmentConnection;
  rgCraV2RiskAssessmentsReport: RgCraV2RiskAssessmentReport;
  riskAssessment: CustomerRiskAssessment;
  riskAssessmentHistory: CustomerRiskAssessmentHistoryItemConnection;
  riskAssessments: CustomerRiskAssessmentConnection;
  searchChallenges: ChallengeItemV3Connection;
  searchChallengesV2: ChallengeItemV3Connection;
  /** Search Players Matching Personal Base Info for Responsible Gaming Check */
  searchPlayerMatchingResponsibleGaming: PlayerSearchItemConnection;
  selfExclusionsChangesCountReport: SelfExclusionChangesCountReport;
  sessionsV2: SessionSearchItemV2Connection;
  sowPlayerIdFromGlobalId: Maybe<PlayerComplianceHistorySearchItem>;
  /** Statistics. */
  stats: Maybe<StatsType>;
  stuckWithdrawalsReport: StuckWithdrawalsReport;
  /** Get a specific template by ID */
  template: TemplateResult;
  /** List reward templates with optional filters */
  templateList: TemplatesConnectionConnection;
  transactionsV2: TransactionSearchItemConnection;
  /** Get a specific offer by ID */
  welcomeOffer: OfferResult;
  /** List offers with optional filters */
  welcomeOfferList: OffersConnectionConnection;
  welcomeOffers: WelcomeOfferConnection;
};


/** A viewer. */
export type VieweraggregatedKYC6MatchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kyc6MatchTypes?: InputMaybe<Array<KYC6MatchTypes>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastSearchedAt?: InputMaybe<RangeDate>;
  maxScore?: InputMaybe<RangeInt>;
  orderBy?: InputMaybe<AggregatedKYC6MatchesOrderBy>;
  playerGlobalUUID?: InputMaybe<Scalars['String']['input']>;
  reviewStatus?: InputMaybe<KYC6ReviewStatus>;
};


/** A viewer. */
export type VieweraggregatedKyc6MatchReportDownloadLinkArgs = {
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  kyc6MatchTypes?: InputMaybe<Array<KYC6MatchTypes>>;
  lastSearchedAt?: InputMaybe<RangeDate>;
  maxScore?: InputMaybe<RangeInt>;
  orderBy?: InputMaybe<AggregatedKYC6MatchesOrderBy>;
  playerGlobalUUID?: InputMaybe<Scalars['String']['input']>;
  reviewStatus?: InputMaybe<KYC6ReviewStatus>;
};


/** A viewer. */
export type ViewerallLinkedAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A viewer. */
export type VieweramlRiskAssessmentsReportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  calculatedAt?: InputMaybe<RangeDate>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  finalScore?: InputMaybe<RangeInt>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastReviewedAt?: InputMaybe<RangeDate>;
  orderBy?: InputMaybe<RiskAggregationOrderBy>;
  percentage?: InputMaybe<RangeInt>;
  playerGlobalId?: InputMaybe<Scalars['ID']['input']>;
  reviewStatus?: InputMaybe<Array<ReviewStatus>>;
  riskLevels?: InputMaybe<Array<RiskLevel>>;
  score?: InputMaybe<RangeInt>;
};


/** A viewer. */
export type ViewerbonusArgs = {
  bonusId: Scalars['String']['input'];
};


/** A viewer. */
export type ViewerbonusCodesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  bonusItem?: InputMaybe<BonusCodeItemInput>;
  brand?: InputMaybe<BrandEnum>;
  category?: InputMaybe<BonusCodeCategory>;
  claimability?: InputMaybe<BonusCodeClaimability>;
  codePrefix?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<BonusCodeSortField>;
};


/** A viewer. */
export type ViewerbonusHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  bonusIds?: InputMaybe<Array<Scalars['String']['input']>>;
  brands?: InputMaybe<Array<BrandEnum>>;
  campaignIds?: InputMaybe<Array<Scalars['String']['input']>>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  eventTypes?: InputMaybe<Array<BonusEventType>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  playerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  playerSessionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  processedAt?: InputMaybe<RangeDate>;
  rewardIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A viewer. */
export type ViewerbonusesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  assignationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  before?: InputMaybe<Scalars['String']['input']>;
  bonusIds?: InputMaybe<Array<Scalars['String']['input']>>;
  brands?: InputMaybe<Array<BrandEnum>>;
  campaignIds?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<RangeDate>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<BonusOrder>;
  playerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  rewardIds?: InputMaybe<Array<Scalars['String']['input']>>;
  statuses?: InputMaybe<Array<BonusStatus>>;
};


/** A viewer. */
export type ViewerdetailedCashbackReportArgs = {
  brand: BrandEnum;
  from: Scalars['OffsetDateTime']['input'];
  playerUUID: Scalars['String']['input'];
  to: Scalars['OffsetDateTime']['input'];
};


/** A viewer. */
export type ViewerdetailedRakebackReportArgs = {
  brand: BrandEnum;
  from: Scalars['OffsetDateTime']['input'];
  playerUUID: Scalars['String']['input'];
  to: Scalars['OffsetDateTime']['input'];
};


/** A viewer. */
export type ViewerdinoJackpotContributionSwitchArgs = {
  brand: BrandEnum;
};


/** A viewer. */
export type ViewerdinoJackpotContributionSwitchHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<BrandEnum>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  initiatorId?: InputMaybe<Scalars['String']['input']>;
  initiatorType?: InputMaybe<InitiatorTypeEnum>;
  last?: InputMaybe<Scalars['Int']['input']>;
  processedAt?: InputMaybe<RangeDate>;
};


/** A viewer. */
export type ViewerdinoJackpotLeaderboardHistoryArgs = {
  brand: BrandEnum;
  currency: Scalars['String']['input'];
  externalJackpotId: Scalars['String']['input'];
  externalLevelId: Scalars['String']['input'];
  from: Scalars['OffsetDateTime']['input'];
  operatorId: Scalars['String']['input'];
  to: Scalars['OffsetDateTime']['input'];
};


/** A viewer. */
export type ViewerdinoJackpotOptInArgs = {
  brand: BrandEnum;
  playerId: Scalars['ID']['input'];
};


/** A viewer. */
export type ViewerdinoJackpotOptInBySourceCodeArgs = {
  brand: BrandEnum;
  playerId: Scalars['ID']['input'];
  sourceCode: Scalars['NonEmptyString']['input'];
};


/** A viewer. */
export type ViewerdinoJackpotOptInHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<BrandEnum>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  initiatorId?: InputMaybe<Scalars['String']['input']>;
  initiatorType?: InputMaybe<InitiatorTypeEnum>;
  last?: InputMaybe<Scalars['Int']['input']>;
  optedIn?: InputMaybe<Scalars['Boolean']['input']>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  processedAt?: InputMaybe<RangeDate>;
};


/** A viewer. */
export type ViewerdinoJackpotOptInHistoryBySourceCodeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<BrandEnum>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  initiatorId?: InputMaybe<Scalars['String']['input']>;
  initiatorType?: InputMaybe<InitiatorTypeEnum>;
  last?: InputMaybe<Scalars['Int']['input']>;
  optedIn?: InputMaybe<Scalars['Boolean']['input']>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  processedAt?: InputMaybe<RangeDate>;
  sourceCode: Scalars['NonEmptyString']['input'];
};


/** A viewer. */
export type ViewerdocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  documentStatus: Array<DocumentStatus>;
  documentType: Array<DocumentType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DocumentSearchOrder>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


/** A viewer. */
export type ViewerexpiredKycValidationsArgs = {
  aboutToExpireThresholdInDays?: InputMaybe<Scalars['PositiveInt']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  documentVerificationTypes: Array<DocumentVerificationType>;
  filterByAmlPercentageAbove?: InputMaybe<Scalars['PositiveInt']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ignorePendingValidations?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A viewer. */
export type ViewerexportClosingBalancesReportArgs = {
  brand?: InputMaybe<BrandEnum>;
  currency?: InputMaybe<Scalars['String']['input']>;
  finalDate: Scalars['LocalDate']['input'];
  initialDate: Scalars['LocalDate']['input'];
};


/** A viewer. */
export type ViewerexportSowReportArgs = {
  amlLevel?: InputMaybe<AmlRiskLevel>;
  complianceStatus?: InputMaybe<PlayerComplianceStatus>;
};


/** A viewer. */
export type ViewerexportSowReportV2Args = {
  amlLevel?: InputMaybe<AmlRiskLevel>;
  complianceStatus?: InputMaybe<PlayerComplianceStatus>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  limitReachedAt?: InputMaybe<RangeDate>;
  orderBy?: InputMaybe<SoWSearchOrder>;
  statusChangedAt?: InputMaybe<RangeDate>;
  submittedAt?: InputMaybe<RangeDate>;
};


/** A viewer. */
export type ViewerexportedCashbackReportV5Args = {
  brand: BrandEnum;
  forcePaymentFormula?: InputMaybe<Scalars['Boolean']['input']>;
  from: Scalars['OffsetDateTime']['input'];
  to: Scalars['OffsetDateTime']['input'];
};


/** A viewer. */
export type ViewerexportedDailyPlayerActivityFromElasticArgs = {
  batchSize?: InputMaybe<Scalars['Int']['input']>;
  brand: BrandEnum;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['OffsetDateTime']['input'];
  parallelism?: InputMaybe<Scalars['Int']['input']>;
  to: Scalars['OffsetDateTime']['input'];
  wasSentByAffiliates?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A viewer. */
export type ViewerexportedDailyPlayerActivityFromElasticV2Args = {
  brand: BrandEnum;
  from: Scalars['OffsetDateTime']['input'];
  includeNonAffiliates?: InputMaybe<Scalars['Boolean']['input']>;
  to: Scalars['OffsetDateTime']['input'];
};


/** A viewer. */
export type ViewerexportedGlobalPaymentsArgs = {
  brand?: InputMaybe<BrandEnum>;
  currency?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  gameProviderId?: InputMaybe<GameProvider>;
  id?: InputMaybe<Scalars['String']['input']>;
  indexPrefix?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<PaymentSearchOrder>;
  org?: InputMaybe<OrgEnum>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  paymentType?: InputMaybe<PaymentType>;
  playerGlobalId: Scalars['ID']['input'];
  rawId?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


/** A viewer. */
export type ViewerexportedMGASelfExclusionReportArgs = {
  brand?: InputMaybe<BrandEnum>;
  finalDate: Scalars['LocalDate']['input'];
  indexPrefix?: InputMaybe<Scalars['String']['input']>;
  initialDate: Scalars['LocalDate']['input'];
  initiatorType?: InputMaybe<InitiatorTypeEnum>;
};


/** A viewer. */
export type ViewerexportedMarketingPlayersArgs = {
  brand?: InputMaybe<BrandEnum>;
  isSmsMarketingAccepted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A viewer. */
export type ViewerexportedPaymentsArgs = {
  brand?: InputMaybe<BrandEnum>;
  currency?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  gameProviderId?: InputMaybe<GameProvider>;
  id?: InputMaybe<Scalars['String']['input']>;
  indexPrefix?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<PaymentSearchOrder>;
  org?: InputMaybe<OrgEnum>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  paymentType?: InputMaybe<PaymentType>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  rawId?: InputMaybe<Scalars['String']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


/** A viewer. */
export type ViewerexportedPlayerKycHistoryArgs = {
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  getOnlyLatestKycPerPlayer?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  kycProvider?: InputMaybe<KycProviderType>;
  orderBy?: InputMaybe<PlayerKycHistorySearchOrder>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


/** A viewer. */
export type ViewerexportedPlayersArgs = {
  accountStatus?: InputMaybe<AccountStatusEnum>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  brand?: InputMaybe<BrandEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  indexPrefix?: InputMaybe<Scalars['String']['input']>;
  isTestAccount?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastLoginFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  lastLoginIp?: InputMaybe<Scalars['String']['input']>;
  lastLoginIpCountryCode?: InputMaybe<Scalars['String']['input']>;
  lastLoginTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  maxBalance?: InputMaybe<Scalars['PositiveBigDecimal']['input']>;
  minBalance?: InputMaybe<Scalars['PositiveBigDecimal']['input']>;
  orderBy?: InputMaybe<PlayerSearchOrder>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  playerGlobalUUID?: InputMaybe<Scalars['String']['input']>;
  playerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  registeredFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  registeredIp?: InputMaybe<Scalars['String']['input']>;
  registeredIpCountryCode?: InputMaybe<Scalars['String']['input']>;
  registeredTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  registrationStatus?: InputMaybe<RegistrationStatusFilter>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


/** A viewer. */
export type ViewerexportedPlayersKycCheckStatusArgs = {
  brand?: InputMaybe<BrandEnum>;
  countryCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A viewer. */
export type ViewerexportedRakebackReportArgs = {
  brand: BrandEnum;
  from: Scalars['OffsetDateTime']['input'];
  to: Scalars['OffsetDateTime']['input'];
};


/** A viewer. */
export type ViewerexportedSelfExclusionsReportArgs = {
  brand?: InputMaybe<BrandEnum>;
  indexPrefix?: InputMaybe<Scalars['String']['input']>;
};


/** A viewer. */
export type ViewerexportedTransactionsV2Args = {
  adjustmentCategory?: InputMaybe<AdjustmentCategory>;
  adjustmentType?: InputMaybe<AdjustmentType>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<BrandEnum>;
  currency?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  gameRoundId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxAmount?: InputMaybe<Scalars['PositiveBigDecimal']['input']>;
  minAmount?: InputMaybe<Scalars['PositiveBigDecimal']['input']>;
  orderBy?: InputMaybe<TransactionSearchOrder>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<Array<PaymentStatus>>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  rawId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  transactionTypes?: InputMaybe<Array<TransactionType>>;
};


/** A viewer. */
export type ViewergenerateChallengeReportArgs = {
  challengeId: Scalars['String']['input'];
};


/** A viewer. */
export type ViewergetKycRequestCountArgs = {
  kycRequestStatuses: Array<KrofortKycRequestStatus>;
  requestRangeDate: RangeDate;
};


/** A viewer. */
export type ViewergetSpecificWalletArgs = {
  brand: BrandEnum;
  currency: Scalars['String']['input'];
  playerUUID: Scalars['String']['input'];
};


/** A viewer. */
export type ViewerglobalNotesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categories?: InputMaybe<Array<NoteCategoryEnum>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PlayerNoteSearchOrder>>;
  playerGlobalId?: InputMaybe<Scalars['ID']['input']>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  priority?: InputMaybe<PriorityEnum>;
};


/** A viewer. */
export type ViewerhampiCheckByNamePlusDobArgs = {
  birthDate: Scalars['LocalDate']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};


/** A viewer. */
export type ViewerhampiCheckBySsnArgs = {
  countryCode: Scalars['String']['input'];
  ssn: Scalars['String']['input'];
};


/** A viewer. */
export type Viewerkyc6MatchReportDownloadLinkArgs = {
  resourceId: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Long']['input']>;
};


/** A viewer. */
export type Viewerkyc6MatchesByGlobalIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kyc6MatchTypes?: InputMaybe<Array<KYC6MatchTypes>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastSearchedAt?: InputMaybe<RangeDate>;
  matchDecision?: InputMaybe<MatchDecision>;
  orderBy?: InputMaybe<KYC6MatchesOrderBy>;
  playerGlobalId: Scalars['ID']['input'];
  score?: InputMaybe<RangeInt>;
};


/** A viewer. */
export type Viewerkyc6MatchesByGlobalIdV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kyc6MatchTypes?: InputMaybe<Array<KYC6MatchTypes>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastSearchedAt?: InputMaybe<RangeDate>;
  matchDecision?: InputMaybe<FilteringMatchDecision>;
  orderBy?: InputMaybe<KYC6MatchesOrderBy>;
  playerGlobalId: Scalars['ID']['input'];
  score?: InputMaybe<RangeInt>;
};


/** A viewer. */
export type Viewerkyc6MatchesByPlayerIdArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kyc6MatchTypes?: InputMaybe<Array<KYC6MatchTypes>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastSearchedAt?: InputMaybe<RangeDate>;
  matchDecision?: InputMaybe<MatchDecision>;
  orderBy?: InputMaybe<KYC6MatchesOrderBy>;
  playerId: Scalars['ID']['input'];
  score?: InputMaybe<RangeInt>;
};


/** A viewer. */
export type Viewerkyc6MatchesByPlayerIdV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kyc6MatchTypes?: InputMaybe<Array<KYC6MatchTypes>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastSearchedAt?: InputMaybe<RangeDate>;
  matchDecision?: InputMaybe<FilteringMatchDecision>;
  orderBy?: InputMaybe<KYC6MatchesOrderBy>;
  playerId: Scalars['ID']['input'];
  score?: InputMaybe<RangeInt>;
};


/** A viewer. */
export type ViewerkycValidationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  amlPercentage?: InputMaybe<Scalars['PositiveInt']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  daysBeforeExpire?: InputMaybe<Scalars['PositiveInt']['input']>;
  documentVerificationTypes: Array<DocumentVerificationType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  ignorePendingValidations?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A viewer. */
export type ViewerlimitChangesCountReportArgs = {
  from: Scalars['OffsetDateTime']['input'];
  limitType: LimitType;
  to: Scalars['OffsetDateTime']['input'];
};


/** A viewer. */
export type ViewerlistPaymentApprovalsArgs = {
  PaymentIntegration?: InputMaybe<PaymentIntegration>;
  address?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  autoDecision?: InputMaybe<DecisionType>;
  before?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<BrandEnum>;
  currency?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  manualDecision?: InputMaybe<DecisionSearchType>;
  orderBy?: InputMaybe<Array<PaymentApprovalSearchOrder>>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<PaymentType>;
  playerId?: InputMaybe<Scalars['String']['input']>;
  processedAt?: InputMaybe<RangeDate>;
  tag?: InputMaybe<Scalars['String']['input']>;
};


/** A viewer. */
export type ViewerpaymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  indexPrefix?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PaymentSearchOrder>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  paymentType?: InputMaybe<PaymentType>;
  rawId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


/** A viewer. */
export type ViewerpendingKycFlowSearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  kycCheckDeadlineFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  kycCheckDeadlineTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  kycCheckStartedFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  kycCheckStartedTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  kycFlowId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PendingKycFlowViewSearchOrder>;
  playerGlobalUUID?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['String']['input']>;
};


/** A viewer. */
export type ViewerpepAndSanctionsPlayerListReportArgs = {
  registeredFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


/** A viewer. */
export type ViewerplayerComplianceHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PlayerComplianceHistorySearchOrder>;
  playerGlobalId?: InputMaybe<Scalars['ID']['input']>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};


/** A viewer. */
export type ViewerplayerCompliancePlayersV3Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  amlLevel?: InputMaybe<AmlRiskLevel>;
  before?: InputMaybe<Scalars['String']['input']>;
  complianceStatus?: InputMaybe<PlayerComplianceStatus>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limitReachedAt?: InputMaybe<RangeDate>;
  orderBy?: InputMaybe<SoWSearchOrder>;
  statusChangedAt?: InputMaybe<RangeDate>;
  submittedAt?: InputMaybe<RangeDate>;
};


/** A viewer. */
export type ViewerplayerInfoHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<BrandEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  playerId: Scalars['ID']['input'];
};


/** A viewer. */
export type ViewerplayerInformationHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  eventType?: InputMaybe<PlayerInformationHistoryEventType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PlayerInformationHistoryOrderBy>;
  playerGlobalId?: InputMaybe<Scalars['ID']['input']>;
  playerGlobalUUID?: InputMaybe<Scalars['String']['input']>;
  playerIds: Array<Scalars['ID']['input']>;
  playerUUIDs: Array<Scalars['String']['input']>;
  service?: InputMaybe<Service>;
  timestamp?: InputMaybe<RangeDate>;
};


/** A viewer. */
export type ViewerplayerInformationHistoryExportArgs = {
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  eventType?: InputMaybe<PlayerInformationHistoryEventType>;
  orderBy?: InputMaybe<PlayerInformationHistoryOrderBy>;
  playerGlobalId?: InputMaybe<Scalars['ID']['input']>;
  playerGlobalUUID?: InputMaybe<Scalars['String']['input']>;
  playerIds: Array<Scalars['ID']['input']>;
  playerUUIDs: Array<Scalars['String']['input']>;
  service?: InputMaybe<Service>;
  timestamp?: InputMaybe<RangeDate>;
};


/** A viewer. */
export type ViewerplayerKycHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  getOnlyLatestKycPerPlayer?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  kycProvider?: InputMaybe<KycProviderType>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PlayerKycHistorySearchOrder>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


/** A viewer. */
export type ViewerplayersAsYouTypeV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<BrandEnum>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  indexPrefix?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<PlayerSearchOrder>;
  playerGlobalId?: InputMaybe<Scalars['String']['input']>;
  playerId?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};


/** A viewer. */
export type ViewerplayersProgressArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  challengeIdList?: InputMaybe<Array<Scalars['String']['input']>>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  playerIdList?: InputMaybe<Array<Scalars['String']['input']>>;
  status: Array<PlayerProgressStatus>;
};


/** A viewer. */
export type ViewerplayersSearchV2Args = {
  accountStatus?: InputMaybe<AccountStatusEnum>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  brand?: InputMaybe<BrandEnum>;
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  indexPrefix?: InputMaybe<Scalars['String']['input']>;
  isTestAccount?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastLoginFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  lastLoginIp?: InputMaybe<Scalars['String']['input']>;
  lastLoginIpCountryCode?: InputMaybe<Scalars['String']['input']>;
  lastLoginTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  maxBalance?: InputMaybe<Scalars['PositiveBigDecimal']['input']>;
  minBalance?: InputMaybe<Scalars['PositiveBigDecimal']['input']>;
  orderBy?: InputMaybe<PlayerSearchOrder>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  playerGlobalUUID?: InputMaybe<Scalars['String']['input']>;
  playerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  registeredFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  registeredIp?: InputMaybe<Scalars['String']['input']>;
  registeredIpCountryCode?: InputMaybe<Scalars['String']['input']>;
  registeredTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  registrationStatus?: InputMaybe<RegistrationStatusFilter>;
  ssn?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


/** A viewer. */
export type ViewerrewardArgs = {
  id: Scalars['String']['input'];
};


/** A viewer. */
export type ViewerrewardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['CampaignId']['input']>;
  createdAtFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  createdAtTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  endsAtFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  endsAtTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  excludeRewardIds?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SearchRewardsOrderBy>;
  playerIds?: InputMaybe<Array<Scalars['String']['input']>>;
  rewardId?: InputMaybe<Scalars['String']['input']>;
  rewardName?: InputMaybe<Scalars['String']['input']>;
  rewardReason?: InputMaybe<RewardReason>;
  rewardStatus?: InputMaybe<RewardStatus>;
  rewardSystem?: InputMaybe<RewardTargetSystem>;
  rewardTypeEnum?: InputMaybe<RewardTypeEnum>;
  rewardTypes?: InputMaybe<Array<RewardTypeEnum>>;
  startsAtFrom?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  startsAtTo?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


/** A viewer. */
export type ViewerrgCraAutomationHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  playerGlobalId: Scalars['ID']['input'];
  processedAt?: InputMaybe<RangeDate>;
  showSuspended?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A viewer. */
export type ViewerrgCraAutomationV2HistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  playerGlobalId: Scalars['ID']['input'];
  processedAt?: InputMaybe<RangeDate>;
  showSuspended?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A viewer. */
export type ViewerrgCraAutomationV2LegacyHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  playerGlobalId: Scalars['ID']['input'];
  processedAt?: InputMaybe<RangeDate>;
  showSuspended?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A viewer. */
export type ViewerrgCraRiskAssessmentArgs = {
  playerGlobalId: Scalars['ID']['input'];
};


/** A viewer. */
export type ViewerrgCraRiskAssessmentHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  initiatorId?: InputMaybe<Scalars['String']['input']>;
  initiatorType?: InputMaybe<InitiatorTypeEnum>;
  last?: InputMaybe<Scalars['Int']['input']>;
  playerGlobalId?: InputMaybe<Scalars['ID']['input']>;
  rgCraEventId?: InputMaybe<Scalars['String']['input']>;
  rgCraEventType?: InputMaybe<RgCraEventType>;
  rgCraHistoryOrderBy?: InputMaybe<RgCraRiskHistoryOrderBy>;
  rgCraOutcomes?: InputMaybe<Array<RgCraOutcomeEnum>>;
  rgCraProcessedAt?: InputMaybe<RangeDate>;
};


/** A viewer. */
export type ViewerrgCraRiskAssessmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  calculatedAt?: InputMaybe<RangeDate>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastReviewedAt?: InputMaybe<RangeDate>;
  orderBy?: InputMaybe<RgCraRiskAggregationOrderBy>;
  percentage?: InputMaybe<RangeInt>;
  playerGlobalId?: InputMaybe<Scalars['ID']['input']>;
  rgCraOrderBy?: InputMaybe<RgCraRiskAggregationOrderBy>;
  rgCraReviewStatus?: InputMaybe<Array<RgCraReviewStatus>>;
  rgCraRiskLevels?: InputMaybe<Array<RgCraRiskLevel>>;
  rgCraRiskTerms?: InputMaybe<Array<RgCraRiskTerm>>;
};


/** A viewer. */
export type ViewerrgCraRiskAssessmentsReportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  calculatedAt?: InputMaybe<RangeDate>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastReviewedAt?: InputMaybe<RangeDate>;
  orderBy?: InputMaybe<RgCraRiskAggregationOrderBy>;
  percentage?: InputMaybe<RangeInt>;
  playerGlobalId?: InputMaybe<Scalars['ID']['input']>;
  rgCraReviewStatus?: InputMaybe<Array<RgCraReviewStatus>>;
  rgCraRiskLevels?: InputMaybe<Array<RgCraRiskLevel>>;
  rgCraRiskTerms?: InputMaybe<Array<RgCraRiskTerm>>;
};


/** A viewer. */
export type ViewerrgCraV2LegacyRiskAssessmentHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  initiatorId?: InputMaybe<Scalars['String']['input']>;
  initiatorType?: InputMaybe<InitiatorTypeEnum>;
  last?: InputMaybe<Scalars['Int']['input']>;
  playerGlobalId?: InputMaybe<Scalars['ID']['input']>;
  rgCraEventId?: InputMaybe<Scalars['String']['input']>;
  rgCraEventType?: InputMaybe<RgCraV2EventType>;
  rgCraHistoryOrderBy?: InputMaybe<RgCraV2RiskHistoryOrderBy>;
  rgCraOutcomes?: InputMaybe<Array<RgCraV2OutcomeEnum>>;
  rgCraProcessedAt?: InputMaybe<RangeDate>;
};


/** A viewer. */
export type ViewerrgCraV2RiskAssessmentArgs = {
  playerGlobalId: Scalars['ID']['input'];
};


/** A viewer. */
export type ViewerrgCraV2RiskAssessmentHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  initiatorId?: InputMaybe<Scalars['String']['input']>;
  initiatorType?: InputMaybe<InitiatorTypeEnum>;
  last?: InputMaybe<Scalars['Int']['input']>;
  playerGlobalId?: InputMaybe<Scalars['ID']['input']>;
  rgCraEventId?: InputMaybe<Scalars['String']['input']>;
  rgCraEventType?: InputMaybe<RgCraV2EventType>;
  rgCraHistoryOrderBy?: InputMaybe<RgCraV2RiskHistoryOrderBy>;
  rgCraOutcomes?: InputMaybe<Array<RgCraV2OutcomeEnum>>;
  rgCraProcessedAt?: InputMaybe<RangeDate>;
};


/** A viewer. */
export type ViewerrgCraV2RiskAssessmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  calculatedAt?: InputMaybe<RangeDate>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastReviewedAt?: InputMaybe<RangeDate>;
  orderBy?: InputMaybe<RgCraV2RiskAggregationOrderBy>;
  percentage?: InputMaybe<RangeInt>;
  playerGlobalId?: InputMaybe<Scalars['ID']['input']>;
  rgCraOrderBy?: InputMaybe<RgCraV2RiskAggregationOrderBy>;
  rgCraReviewStatus?: InputMaybe<Array<RgCraV2ReviewStatus>>;
  rgCraRiskLevels?: InputMaybe<Array<RgCraV2RiskLevel>>;
  rgCraRiskTerms?: InputMaybe<Array<RgCraV2RiskTerm>>;
};


/** A viewer. */
export type ViewerrgCraV2RiskAssessmentsReportArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  calculatedAt?: InputMaybe<RangeDate>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastReviewedAt?: InputMaybe<RangeDate>;
  orderBy?: InputMaybe<RgCraV2RiskAggregationOrderBy>;
  percentage?: InputMaybe<RangeInt>;
  playerGlobalId?: InputMaybe<Scalars['ID']['input']>;
  rgCraReviewStatus?: InputMaybe<Array<RgCraV2ReviewStatus>>;
  rgCraRiskLevels?: InputMaybe<Array<RgCraV2RiskLevel>>;
  rgCraRiskTerms?: InputMaybe<Array<RgCraV2RiskTerm>>;
};


/** A viewer. */
export type ViewerriskAssessmentArgs = {
  playerGlobalId: Scalars['ID']['input'];
};


/** A viewer. */
export type ViewerriskAssessmentHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<EventType>;
  first?: InputMaybe<Scalars['Int']['input']>;
  initiatorId?: InputMaybe<Scalars['String']['input']>;
  initiatorType?: InputMaybe<InitiatorTypeEnum>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RiskHistoryOrderBy>;
  outcomes?: InputMaybe<Array<OutcomeEnum>>;
  playerGlobalId?: InputMaybe<Scalars['ID']['input']>;
  processedAt?: InputMaybe<RangeDate>;
};


/** A viewer. */
export type ViewerriskAssessmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  calculatedAt?: InputMaybe<RangeDate>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  finalScore?: InputMaybe<RangeInt>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastReviewedAt?: InputMaybe<RangeDate>;
  orderBy?: InputMaybe<RiskAggregationOrderBy>;
  percentage?: InputMaybe<RangeInt>;
  playerGlobalId?: InputMaybe<Scalars['ID']['input']>;
  reviewStatus?: InputMaybe<Array<ReviewStatus>>;
  riskLevels?: InputMaybe<Array<RiskLevel>>;
  score?: InputMaybe<RangeInt>;
};


/** A viewer. */
export type ViewersearchChallengesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brands: Array<BrandEnum>;
  challengeId?: InputMaybe<Scalars['String']['input']>;
  countries: Array<Scalars['String']['input']>;
  desc?: Scalars['Boolean']['input'];
  endDate?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchChallengesOrderBy: SearchChallengesRequestOrderBy;
  startDate?: InputMaybe<Scalars['OffsetDateTime']['input']>;
};


/** A viewer. */
export type ViewersearchChallengesV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  challengeIdList?: InputMaybe<Array<Scalars['String']['input']>>;
  challengeNamePrefix?: InputMaybe<Scalars['String']['input']>;
  challengeSystem?: InputMaybe<ChallengeExternalSystem>;
  desc?: Scalars['Boolean']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<ChallengeStatus>>;
};


/** A viewer. */
export type ViewersearchPlayerMatchingResponsibleGamingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  birthDate?: InputMaybe<Scalars['LocalDate']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
};


/** A viewer. */
export type ViewerselfExclusionsChangesCountReportArgs = {
  from: Scalars['OffsetDateTime']['input'];
  to: Scalars['OffsetDateTime']['input'];
};


/** A viewer. */
export type ViewersessionsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<BrandEnum>;
  cause?: InputMaybe<TerminationCause>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  initiatorId?: InputMaybe<Scalars['String']['input']>;
  initiatorType?: InputMaybe<InitiatorTypeEnum>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SessionSearchOrder>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<SessionStatus>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};


/** A viewer. */
export type ViewersowPlayerIdFromGlobalIdArgs = {
  playerGlobalId: Scalars['ID']['input'];
};


/** A viewer. */
export type ViewerstatsArgs = {
  dataSourceVersion?: InputMaybe<DataSourceVersionEnum>;
  exchangeRateBaseCurrency?: InputMaybe<Scalars['String']['input']>;
  exchangeRateDate?: InputMaybe<Scalars['LocalDate']['input']>;
  from: Scalars['OffsetDateTime']['input'];
  granularity: GranularityEnum;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ColumnOrderSpecType>>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['OffsetDateTime']['input'];
};


/** A viewer. */
export type ViewertemplateArgs = {
  templateId: Scalars['String']['input'];
};


/** A viewer. */
export type ViewertemplateListArgs = {
  affiliateId?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  claimDays?: InputMaybe<Scalars['Int']['input']>;
  countries?: InputMaybe<Array<Scalars['ISOCountryCode']['input']>>;
  dynamicAmountMultiplier?: InputMaybe<Scalars['BigDecimal']['input']>;
  dynamicMaxPayoutMultiplier?: InputMaybe<Scalars['BigDecimal']['input']>;
  dynamicMaxRewardAmount?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gameId?: InputMaybe<Scalars['String']['input']>;
  gameProvider?: InputMaybe<GameProvider>;
  last?: InputMaybe<Scalars['Int']['input']>;
  paylines?: InputMaybe<Scalars['Int']['input']>;
  rewardProfileType?: InputMaybe<RewardProfileType>;
  spreadOverDays?: InputMaybe<Scalars['Int']['input']>;
  staticAmount?: InputMaybe<Scalars['Int']['input']>;
  staticMaxPayout?: InputMaybe<Scalars['Int']['input']>;
  valueCents?: InputMaybe<Scalars['Int']['input']>;
  wageringRequirementFactor?: InputMaybe<Scalars['Int']['input']>;
};


/** A viewer. */
export type ViewertransactionsV2Args = {
  adjustmentCategory?: InputMaybe<AdjustmentCategory>;
  adjustmentType?: InputMaybe<AdjustmentType>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<BrandEnum>;
  currency?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  externalTransactionId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  gameRoundId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maxAmount?: InputMaybe<Scalars['PositiveBigDecimal']['input']>;
  minAmount?: InputMaybe<Scalars['PositiveBigDecimal']['input']>;
  orderBy?: InputMaybe<TransactionSearchOrder>;
  paymentMethod?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<Array<PaymentStatus>>;
  playerId?: InputMaybe<Scalars['ID']['input']>;
  rawId?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['OffsetDateTime']['input']>;
  transactionTypes?: InputMaybe<Array<TransactionType>>;
};


/** A viewer. */
export type ViewerwelcomeOfferArgs = {
  offerId: Scalars['String']['input'];
};


/** A viewer. */
export type ViewerwelcomeOfferListArgs = {
  affiliateId?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<BrandEnum>;
  countries?: InputMaybe<Array<Scalars['ISOCountryCode']['input']>>;
  currency?: InputMaybe<Scalars['ISOCurrencyCode']['input']>;
  depositNumber?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  gameId?: InputMaybe<Scalars['String']['input']>;
  gameProvider?: InputMaybe<GameProvider>;
  last?: InputMaybe<Scalars['Int']['input']>;
  lifecycle?: InputMaybe<OfferLifecycle>;
  rewardProfileType?: InputMaybe<RewardProfileType>;
};


/** A viewer. */
export type ViewerwelcomeOffersArgs = {
  affiliateId?: InputMaybe<Scalars['String']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<BrandEnum>;
  country?: InputMaybe<Scalars['ISOCountryCode']['input']>;
  currency?: InputMaybe<Scalars['ISOCurrencyCode']['input']>;
  depositNumber?: InputMaybe<Scalars['Int']['input']>;
  desc?: Scalars['Boolean']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Wagering requirement cycle summary. */
export type WageringRequirementSummary = {
  __typename: 'WageringRequirementSummary';
  /** Whether there wagering requirement bypass flag has been set. */
  bypass: Scalars['Boolean']['output'];
  /** Whether the withdrawal is permitted. */
  canWithdraw: Scalars['Boolean']['output'];
  /** Whether there is an open cycle. */
  cycleOpen: Scalars['Boolean']['output'];
  /** Whether there wagering requirement is considered met. */
  isMet: Scalars['Boolean']['output'];
  /** Remaining to wager to unblock withdrawals. */
  remainingToWager: Maybe<Scalars['BigDecimal']['output']>;
  /** Total deposited in this cycle. */
  totalDeposited: Maybe<Scalars['BigDecimal']['output']>;
  /** Total wagered in this cycle. */
  totalWagered: Maybe<Scalars['BigDecimal']['output']>;
};

/** A wallet. */
export type Wallet = {
  __typename: 'Wallet';
  /** Amount of balance. */
  balance: Scalars['BigDecimal']['output'];
  /** Brand of the wallet. */
  brand: Maybe<Brand>;
  /** Wallet ISO currency. */
  currency: Scalars['String']['output'];
  /** Deposit limit. */
  depositLimit: Limit;
  displayBalance: Maybe<Scalars['BigDecimal']['output']>;
  displayCurrency: Maybe<Scalars['ISOCurrencyCode']['output']>;
  displayReservedBalance: Maybe<Scalars['BigDecimal']['output']>;
  /** The ID of an object */
  id: Scalars['ID']['output'];
  /** The last time the wallet was used. */
  lastUsedAt: Maybe<Scalars['OffsetDateTime']['output']>;
  /** Loss limit. */
  lossLimit: Limit;
  /** Id of the player */
  playerId: Scalars['ID']['output'];
  /** Amount of reserved balance. */
  reservedBalance: Scalars['BigDecimal']['output'];
  /** Session limit. */
  sessionLimit: Limit;
  uuid: Scalars['String']['output'];
  /** Wager limit. */
  wagerLimit: Limit;
  /** Wagering requirement summary. */
  wageringRequirement: WageringRequirementSummary;
  /** Withdrawal limit. */
  withdrawalLimit: Limit;
};

/** A connection to a list of items. */
export type WelcomeOfferConnection = {
  __typename: 'WelcomeOfferConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<WelcomeOfferEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Represents the details of a welcome offer */
export type WelcomeOfferDetails = {
  __typename: 'WelcomeOfferDetails';
  /** If defined, overrides any template affiliateId */
  affiliateId: Maybe<Scalars['String']['output']>;
  brand: Brand;
  /** If non-empty, overrides any template countries */
  countries: Array<Scalars['ISOCountryCode']['output']>;
  currency: Scalars['ISOCurrencyCode']['output'];
  /** Deposit number this offer applies to (1 for first deposit, 2 for second deposit and 0 for registration) */
  depositNumber: Scalars['Int']['output'];
  expirationDate: Scalars['LocalDate']['output'];
  id: Scalars['String']['output'];
  modifiedAt: Scalars['OffsetDateTime']['output'];
  modifiedBy: Scalars['String']['output'];
  name: Scalars['String']['output'];
  rewardTemplates: Array<RewardTemplateType>;
  version: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WelcomeOfferEdge = {
  __typename: 'WelcomeOfferEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: WelcomeOfferDetails;
};

/** Error response from welcome offers service */
export type WelcomeOfferError = {
  __typename: 'WelcomeOfferError';
  details: Array<Scalars['String']['output']>;
  error: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Represents a KycProvider */
export enum kycProvider {
  Brite = 'Brite',
  BullPay = 'BullPay',
  Dino = 'Dino',
  Eniro = 'Eniro',
  Finshark = 'Finshark',
  Infinipi = 'Infinipi',
  Krofort = 'Krofort',
  Kyc6 = 'Kyc6',
  Sofort = 'Sofort',
  SumSub = 'SumSub',
  Trustly = 'Trustly',
  Zimpler = 'Zimpler'
}

export type origin = Brand | GlobalOrigin;

/** A player sharing the same source of wealth requirements */
export type playerLinkedBySoW = {
  __typename: 'playerLinkedBySoW';
  id: Scalars['ID']['output'];
  player: Player;
  uuid: Scalars['String']['output'];
};

/** SoW threshold reached */
export type sourceOfWealthThresholdReached = PlayerComplianceHistorySearchItem & {
  __typename: 'sourceOfWealthThresholdReached';
  depositProcessedAt: Scalars['OffsetDateTime']['output'];
  eventType: Scalars['String']['output'];
  initiatorV2: Maybe<Initiator>;
  playerGlobalId: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  playerUUID: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  uuid: Scalars['String']['output'];
};

/** SoW threshold unreached */
export type sourceOfWealthThresholdUnreached = PlayerComplianceHistorySearchItem & {
  __typename: 'sourceOfWealthThresholdUnreached';
  depositProcessedAt: Scalars['OffsetDateTime']['output'];
  eventType: Scalars['String']['output'];
  initiatorV2: Maybe<Initiator>;
  playerGlobalId: Scalars['String']['output'];
  playerId: Scalars['ID']['output'];
  playerUUID: Scalars['String']['output'];
  processedAt: Scalars['OffsetDateTime']['output'];
  uuid: Scalars['String']['output'];
};
